window.theme = window.theme || {};
var CartDomTime 

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function($){
  
  var $ = jQuery = $;
  
  //gqx country header
    
  $("#btncountry").click(function(event) {
    $("#myDivcountry").toggle(); 
    $(this).toggleClass('upper');
    $(document).one("click",function() {
      $("#btncountry").removeClass('upper');
      $("#myDivcountry").hide();
    });
    event.stopPropagation();
  });

  theme.utils = {

    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
  };
  
  theme.a11y = {
  
    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };
  
      /**
       * Get every possible visible focusable element
       */
      var $focusableElements = options.$container.find(
        $(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
        ).filter(':visible')
      );
      var firstFocusable = $focusableElements[0];
      var lastFocusable = $focusableElements[$focusableElements.length - 1];
  
      if (!options.$elementToFocus) {
        options.$elementToFocus = options.$container;
      }
  
      function _manageFocus(evt) {
        // Tab key
        if (evt.keyCode !== 9) return;
  
        /**
         * On the last focusable element and tab forward,
         * focus the first element.
         */
        if (evt.target === lastFocusable && !evt.shiftKey) {
          evt.preventDefault();
          firstFocusable.focus();
        }
        /**
         * On the first focusable element and tab backward,
         * focus the last element.
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
  
      options.$container.attr('tabindex', '-1');
      options.$elementToFocus.focus();
  
      $(document).off('focusin');
  
      $(document).on(eventsName.focusout, function() {
        $(document).off(eventsName.keydown);
      });
  
      $(document).on(eventsName.focusin, function(evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;
  
        $(document).on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });
    },
  
    /**
     * Removes the trap of focus in a particular container
     *
     * @param {object} options - Options to be used
     * @param {jQuery} options.$container - Container to trap focus within
     * @param {string} options.namespace - Namespace used for new focus event handler
     */
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.$container && options.$container.length) {
        options.$container.removeAttr('tabindex');
      }
  
      $(document).off(eventName);
    },
  
    lockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.on('touchmove' + namespace, function () {
        return false;
      });
    },
  
    unlockMobileScrolling: function(namespace, $element) {
      if ($element) {
        var $el = $element;
      } else {
        var $el = $(document.documentElement).add('body');
      }
      $el.off(namespace);
    }
  };
  
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    $(document)
      .on('shopify:section:load', this._onSectionLoad.bind(this))
      .on('shopify:section:unload', this._onSectionUnload.bind(this))
      .on('shopify:section:select', this._onSelect.bind(this))
      .on('shopify:section:deselect', this._onDeselect.bind(this))
      .on('shopify:block:select', this._onBlockSelect.bind(this))
      .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
    createInstance: function(container, constructor, customScope) {
      var $container = $(container);
      var id = $container.attr('data-section-id');
      var type = $container.attr('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (customScope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          return;
        }
      }
  
      var instance = $.extend(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
  
      this.instances.push(instance);
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (AOS) {
        AOS.refreshHard();
      }
      var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];
  
      if (!container) {
        return;
      }
  
      this.createInstance(container);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      if (!subSection) {
        this._loadSubSections();
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
    },
  
    _loadSubSections: function() {
      if (AOS) {
        AOS.refreshHard();
      }
      $('[data-subsection]').each(function(evt, el) {
        this._onSectionLoad(null, el, $(el).data('section-id'));
      }.bind(this));
    },
  
    _onSectionUnload: function(evt) {
      var instance = this._removeInstance(evt.detail.sectionId);
      if (instance && typeof instance.onUnload === 'function') {
        instance.onUnload(evt);
      }
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(evt);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    register: function(type, constructor, $scope) {
      var afterLoad = false;
      this.constructors[type] = constructor;
      var $sections = $('[data-section-type=' + type + ']');
  
      if ($scope) {
        $sections = $('[data-section-type=' + type + ']', $scope);
      }
  
      $sections.each(function(index, container) {
        this.createInstance(container, constructor, $scope);
      }.bind(this));
    }
  });
  
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *
   * Alternatives
   * - Accounting.js - http://openexchangerates.github.io/accounting.js/
   *
   */
  
  theme.Currency = (function() {
    var moneyFormat = '$';
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
  
  
  /**
   * Image Helper Functions
   * -----------------------------------------------------------------------------
   * A collection of functions that help with basic image operations.
   *
   */
  
  theme.Images = (function() {
  
    /**
     * Find the Shopify image attribute size
     *
     * @param {string} src
     * @returns {null}
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
  
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     *
     * @param src
     * @param size
     * @returns {*}
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }
  
      if (size == null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
  
      return null;
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    /**
     * Create lazyloading-friendly image string
     *
     * @param string
     * @returns string with _{width}x as size param
     */
    function lazyloadImagePath(string) {
      var image;
  
      if (string !== null) {
        image = string.replace(/(\.[^.]*)$/, "_{width}x$1");
      }
  
      return image;
    }
  
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      lazyloadImagePath: lazyloadImagePath
    };
  })();
  
  theme.Variants = (function() {
  
    function Variants(options) {
      this.$container = options.$container;
      this.namespace = options.namespace;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();
  
      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
      // 产品页修改qty 更新这个
      var that = this;
      $('body').on('qty.product',function(data){
        var variant = that._getVariantFromOptions()
        that._updatePrice(variant,true)
      });
    }
  
    Variants.prototype = $.extend({}, Variants.prototype, {
  
      _getCurrentOptions: function() {
        var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};
  
          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
  
              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
  
            return currentOption;
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = this._compact(currentOptions);
  
        return currentOptions;
      },
  
      _getVariantFromOptions: function() {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;
  
        variants.forEach(function(variant) {
          var match = true;
          var options = variant.options;
  
          selectedValues.forEach(function(option) {
            if (match) {
              match = (variant[option.index] === option.value);
            }
          });
  
          if (match) {
            found = variant;
          }
        });
  
        return found || null;
      },
  
      _onSelectChange: function() {
        var variant = this._getVariantFromOptions();
  
        this.$container.trigger({
          type: 'variantChange',
          variant: variant
        });
  
        if (!variant) {
          return;
        }
  
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;
  
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },
  
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};
  
        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },
  
      _updatePrice: function(variant,isUpdate) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price && !isUpdate) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },
  
      _updateUnitPrice: function(variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantUnitPriceChange',
          variant: variant
        });
      },
  
      _updateSKU: function(variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantSKUChange',
          variant: variant
        });
      },
  
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },
  
      _updateMasterSelect: function(variant) {
        $(this.originalSelectorId, this.$container).val(variant.id);
      },
  
      // _.compact from lodash
      // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
      _compact: function(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];
  
        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
    });
  
    return Variants;
  })();
  
  theme.rte = {
    init: function() {
      theme.rte.wrapTable();
      theme.rte.wrapVideo();
      theme.rte.imageLinks();
    },
  
    wrapTable: function() {
      $('.rte table').wrap('<div class="table-wrapper"></div>');
    },
  
    wrapVideo: function() {
      var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
      var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
  
      $iframeVideo.each(function () {
        // Add wrapper to make video responsive
        if (!$(this).parents('.video-wrapper').length) {
          $(this).wrap('<div class="video-wrapper"></div>');
        }
      });
  
      $iframeReset.each(function () {
        // Re-set the src attribute on each iframe after page load
        // for Chrome's "incorrect iFrame content on 'back'" bug.
        // https://code.google.com/p/chromium/issues/detail?id=395791
        // Need to specifically target video and admin bar
        this.src = this.src;
      });
    },
  
    // Remove CSS that adds animated underline under image links
    imageLinks: function() {
      $('.rte a img').parent().addClass('rte__image');
    }
  };
  

  theme.LibraryLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };
  
    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };
  
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  
    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };
  
    function load(libraryName, callback) {
      var library = libraries[libraryName];
  
      if (!library) return;
      if (library.status === status.requested) return;
  
      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }
  
      library.status = status.requested;
  
      var tag;
  
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }
  
      tag.id = library.tagId;
      library.element = tag;
  
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  
    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    return {
      load: load
    };
  })();
  
  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: 'modal-open',
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.$modal = $('#' + id);
  
      if (!this.$modal.length) {
        return false;
      }
  
      this.nodes = {
        $parent: $('html').add('body'),
        $modalContent: this.$modal.find('.modal__inner')
      };
  
      this.config = $.extend(defaults, options);
      this.modalIsOpen = false;
      this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
      this.isSolid = this.config.solid;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      var $openBtn = $(this.config.open);
  
      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');
  
      $(this.config.open).on('click', this.open.bind(this));
      this.$modal.find(this.config.close).on('click', this.close.bind(this));
  
      // Close modal if a drawer is opened
      $('body').on('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget).attr('aria-expanded', 'true');
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.$modal
        .prepareTransition()
        .addClass(this.config.openClass);
      this.nodes.$parent.addClass(this.config.bodyOpenClass);
  
      if (this.isSolid) {
        this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = true;
  
      theme.a11y.trapFocus({
        $container: this.$modal,
        $elementToFocus: this.$focusOnOpen,
        namespace: 'modal_focus'
      });
  
      $('body')
        .trigger('productModalOpen')
        .trigger('modalOpen.' + this.id);
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function() {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
  
      this.$modal
        .prepareTransition()
        .removeClass(this.config.openClass)
        .addClass(this.config.closingClass);
      this.nodes.$parent.removeClass(this.config.bodyOpenClass);
      this.nodes.$parent.addClass(this.config.bodyClosingClass);
      window.setTimeout(function() {
        this.nodes.$parent.removeClass(this.config.bodyClosingClass);
        this.$modal.removeClass(this.config.closingClass);
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
          this.$activeSource.attr('aria-expanded', 'false').focus();
        }
      }.bind(this), 550); // modal close css transition
  
      if (this.isSolid) {
        this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      theme.a11y.removeTrapFocus({
        $container: this.$modal,
        namespace: 'modal_focus'
      });
  
      $('body').trigger('modalClose.' + this.id);
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      // Pressing escape closes modal
      this.nodes.$parent.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.$modal.on('click.modal', this.close.bind(this));
  
        // Exception to above: clicking anywhere on the modal content will NOT close it
        this.nodes.$modalContent.on('click.modal', function(evt) {
          evt.stopImmediatePropagation();
        });
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      this.nodes.$parent.off('.modal');
  
      if (this.config.closeOffContentClick) {
        this.$modal.off('.modal');
        this.nodes.$modalContent.off('.modal');
      }
    };
  
    return Modal;
  })();
  
  theme.Drawers = (function() {
    function Drawer(id, name, ignoreScrollLock) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name,
        headSiteHeader:".header-sticky-wrapper .site-header",
        announcementBar:".announcement-bar"
      };
  
      this.$nodes = {
        parent: $(document.documentElement).add('body'),
        page: $('#MainContent')
      };
  
      this.$drawer = $('#' + id);
  
      if (!this.$drawer.length) {
        return false;
      }
  
      this.isOpen = false;
      this.ignoreScrollLock = ignoreScrollLock;
      this.init();
    };
  
    Drawer.prototype = $.extend({}, Drawer.prototype, {
      init: function() {
        var $openBtn = $(this.config.open);
  
        // Add aria controls
        $openBtn.attr('aria-expanded', 'false');
  
        $openBtn.on('click', this.open.bind(this));
        this.$drawer.find(this.config.close).on('click', this.close.bind(this));
  
        // Close modal if a drawer is opened
        $('body').on('productModalOpen', function() {
          this.close();
        }.bind(this));
      },
  
      open: function(evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }
  
        if (this.isOpen) {
          if((this.config.id) == "NavDrawer")
            this.close();
          return;
        }
  		
        // 避免同时出现多个弹框 所以 每次open 都默认先关闭所有
  		this.$nodes.page.click();
        
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          this.$activeSource = $(evt.currentTarget).attr('aria-expanded', 'true');
        } else if (returnFocusEl) {
          var $el = $(returnFocusEl);
          this.$activeSource = $el.attr('aria-expanded', 'true');
        }
  
        this.$drawer.prepareTransition().addClass(this.config.activeDrawer);
  
        this.$nodes.parent.addClass(this.config.openClass);
        this.isOpen = true;
  
        theme.a11y.trapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
  
        $('body')
          .trigger('drawerOpen')
          .trigger('drawerOpen.' + this.config.id);
  
        this.bindEvents();
        
        if(this.isStyleNew())
        {
          this.styleNewOpen();
        }
      },
  
      close: function() {
        if (!this.isOpen) {
          return;
        }
  
        // deselect any focused form elements
        $(document.activeElement).trigger('blur');
  
        this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);
  
        this.$nodes.parent.removeClass(this.config.openClass);
        this.$nodes.parent.addClass(this.config.closingClass);
        window.setTimeout(function() {
          this.$nodes.parent.removeClass(this.config.closingClass);
          if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'false').focus();
          }
        }.bind(this), 500);
  
        this.isOpen = false;
  
        theme.a11y.removeTrapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
  
        this.unbindEvents();
        
        if(this.isStyleNew())
        {
          this.styleNewClose();
        }
      },
  
      bindEvents: function() {
        if (!this.ignoreScrollLock) {
          theme.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);
        }
  
        // Clicking out of drawer closes it.
        // Check to see if clicked on element in drawer
        // because of any drawer built witin #MainContent
        this.$nodes.page.on('click' + this.config.namespace, function (evt) {
          var $target = $(evt.target);
          var doNotClose = this.elementInsideDrawer($target);
          if (!doNotClose) {
            this.close();
            return false;
          }
  
        }.bind(this));
  
        // Pressing escape closes drawer
        this.$nodes.parent.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
      },
  
      unbindEvents: function() {
        if (!this.ignoreScrollLock) {
          theme.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
        }
        this.$nodes.parent.off(this.config.namespace);
        this.$nodes.page.off(this.config.namespace);
      },
  
      // Check if clicked element is inside the drawer
      elementInsideDrawer: function($el) {
        return this.$drawer.find($el).length;
      },
      
      // 是否使用新的样式
      isStyleNew:function(){
    	var data_nav_drawer_style = this.$drawer.attr("data-nav-drawer-style");
    	if( data_nav_drawer_style == "true")
      		return true;
      	return false;
      },

      styleNewOpen:function(){
    	var headerLayout = $(this.config.headSiteHeader);
		var announcementBar = $(this.config.announcementBar);
        var drawerOpenNav = $(this.config.open);
		if(headerLayout.hasClass("site-header--opening"))
		{
			var headerLayoutOff = headerLayout.position();
			var headerLayoutOffTop = headerLayoutOff.top;
            
		}
		else
		{
			var headerLayoutOff = headerLayout.offset();
			var headerLayoutOffTop = headerLayoutOff.top;
            
		}
        $('.header-sticky-wrapper').css({"z-index":"101"})
		var headerLayoutH = headerLayout.outerHeight(true);
		var navDrawerTop =  headerLayoutOffTop + headerLayoutH;
        $("#NavDrawer").css({"height":"calc(100% - "+navDrawerTop+")"});

        if ($(window).width() >= 768) {
          drawerOpenNav.find(".search-image.icon_pc").animate({"opacity":"0"},0,function(){
            $(this).animate({"opacity":"1"},0);
            $(this).html(`
                         <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_505_785)">
                          <path d="M10.901 10.0021L10.0308 10.8724L29.1769 30.0185L30.0471 29.1482L10.901 10.0021Z" fill="#2E2E2E"/>
                          <path d="M29.1769 10.0022L10.0308 29.1483L10.901 30.0186L30.0471 10.8725L29.1769 10.0022Z" fill="#2E2E2E"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_505_785">
                          <rect width="20" height="20" fill="white" transform="translate(10 10)"/>
                          </clipPath>
                          </defs>
                          </svg>
                         `)
          
          })
        }else{
          drawerOpenNav.find(".search-image.icon_mb").animate({"opacity":"0"},0,function(){
			$(this).animate({"opacity":"1"},0)
            $(this).html(`
                         <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_198_5517)">
                          <path d="M5.81108 5.00191L5.02783 5.78516L22.2593 23.0166L23.0426 22.2334L5.81108 5.00191Z" fill="#2E2E2E"/>
                          <path d="M22.2593 5.00192L5.02783 22.2334L5.81108 23.0166L23.0426 5.78517L22.2593 5.00192Z" fill="#2E2E2E"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_198_5517">
                          <rect width="18" height="18" fill="white" transform="translate(5 5)"/>
                          </clipPath>
                          </defs>
                          </svg>
                         `)
          })
        }
        
      },
      styleNewClose:function(){
        var headerLayout = $(this.config.headSiteHeader);
		var announcementBar = $(this.config.announcementBar);
        var drawerOpenNav = $(this.config.open);
        headerLayout.css({"z-index":""})
        
		announcementBar.css({"z-index":""})
        if ($(window).width() >= 768) {
          drawerOpenNav.find(".search-image.icon_pc").animate({"opacity":"0"},0,function(){
            $(this).animate({"opacity":"1"},0);
            $(this).html(`
                         <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_172_3471)">
                          <path d="M31 13H9V14H31V13Z" fill="#2E2E2E"/>
                          <path d="M31 19.5H9V20.5H31V19.5Z" fill="#2E2E2E"/>
                          <path d="M31 26H9V27H31V26Z" fill="#2E2E2E"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_172_3471">
                          <rect width="22" height="14" fill="white" transform="translate(9 13)"/>
                          </clipPath>
                          </defs>
                          </svg>
                         `)
          })
        }else{
          drawerOpenNav.find(".search-image.icon_mb").animate({"opacity":"0"},0,function(){
			$(this).animate({"opacity":"1"},0)
            $(this).html(`
                         <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_172_3552)">
                          <path d="M25 7H3V8H25V7Z" fill="#2E2E2E"/>
                          <path d="M25 13.5H3V14.5H25V13.5Z" fill="#2E2E2E"/>
                          <path d="M25 20H3V21H25V20Z" fill="#2E2E2E"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_172_3552">
                          <rect width="22" height="14" fill="white" transform="translate(3 7)"/>
                          </clipPath>
                          </defs>
                          </svg>

                         `)
          })
        }

        
        
        setTimeout(function() {
            $('.header-sticky-wrapper').css({"z-index":""})
            $('.header-sticky-wrapper .header-wrapper .site-header').removeClass('light_box_show')
        }, 0);
      }
    });
  
    return Drawer;
  })();
  
  theme.cart = {
    getCart: function() {
      var url = ''.concat("/cart.js", '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.json());
      /*
      return $.getJSON('/cart.js');
      */
    },
  
    changeItem: function(key, qty) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + qty + '&id=' + key,
        dataType: 'json'
      });
    },
    updateItem: function(data,call) {
        return $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: data,
            dataType: 'json'
        }).then(function(cart) {
          return cart;
        }.bind(this));   
    },
    addItemFromForm: function(data) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
      });
    },
  
    _updateCart: function(params) {
      return $.ajax(params)
        .then(function(cart) {
          return cart;
        }.bind(this))
    },
  
    updateNote: function(note) {
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + theme.cart.attributeToString(note),
        dataType: 'json',
        success: function(cart) {},
        error: function(XMLHttpRequest, textStatus) {}
      };
  
      $.ajax(params);
    },
  
    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return $.trim(attribute);
    }
  }
  
  $(function() {
    // Add a loading indicator on the cart checkout button (/cart and drawer)
    $('body').on('click', '.cart__checkout', function() {
      $(this).addClass('btn--loading');
    });
  
    $('body').on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();
      theme.cart.updateNote(newNote);
    });
  
  
    // Custom JS to prevent checkout without confirming terms and conditions
    $('body').on('click', '.cart__checkout--ajax', function(evt) {
      if ($('#CartAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
  
    $('body').on('click', '.cart__checkout--page', function(evt) {
      if ($('#CartPageAgree').is(':checked')) {
      } else {
        alert(theme.strings.cartTermsConfirmation);
        $(this).removeClass('btn--loading');
        return false;
      }
    });
  });
  
  theme.QtySelector = (function() {
    var classes = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };
  
    function QtySelector($el, options) {
      this.$wrapper = $el;
      this.$input = $el.find(classes.input);
      this.$plus = $el.find(classes.plus);
      this.$minus = $el.find(classes.minus);
      this.minValue = this.$input.attr('min') || 1;
  
      var defaults = {
        namespace: null,
        key: this.$input.data('id')
      };
  
      this.options = $.extend(defaults, options);
  
      this.initEventListeners();
    };
  
    QtySelector.prototype = $.extend({}, QtySelector.prototype, {
      initEventListeners: function() {
        this.$plus.on('click', function() {
          var qty = this.validateQty(this.$input.val());
          this.addQty(qty);
        }.bind(this));
  
        this.$minus.on('click', function() {
          var qty = this.validateQty(this.$input.val());
          this.subtractQty(qty);
        }.bind(this));
  
        this.$input.on('change', function() {
          var qty = this.validateQty(this.$input.val());
          this.changeQty(qty);
        }.bind(this));
      },
  
      addQty: function(number) {
        var qty = number + 1;
        this.changeQty(qty);
      },
  
      subtractQty: function(number) {
        var qty = number - 1;
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
        this.changeQty(qty);
      },
  
      changeQty: function(qty) {
        this.$input.val(qty);
        $('body').trigger('qty' + this.options.namespace, [this.options.key, qty]);
      },
  
      validateQty: function(number) {
        if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          number = 1;
        }
        return parseInt(number);
      }
    });
  
    return QtySelector;
  })();
  
  theme.CartDrawer = (function() {
    var config = {
      namespace: '.ajaxcart'
    };
  
    var selectors = {
      drawer: '#CartDrawer',
      container: '#CartContainer',
      template: '#CartTemplate',
      cartBubble: '.cart-link__bubble',
      removeBtn:".remove-product",
    };
  
    function CartDrawer() {
      this.status = {
        loaded: false,
        loading: false
      };
  
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
  
      // Prep handlebars template
      var source = $(selectors.template).html();
      this.template = Handlebars.compile(source);
  
      // Build cart on page load so it's ready in the drawer
      theme.cart.getCart().then(this.buildCart.bind(this));
  
      this.initEventListeners();
    };
  
    CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
      initEventListeners: function() {
        $('body').on('updateCart' + config.namespace, this.initQtySelectors.bind(this));
        $('body').on('updateCart' + config.namespace, this.updateCartNotification.bind(this));
  
        $('body').on('added.ajaxProduct', function(evt, returnFocusEl) {
          theme.cart.getCart().then(function(cart) {
            this.buildCart(cart, true, returnFocusEl);
          }.bind(this));
        }.bind(this));

        $('body').on('added.ajaxProductFlase', function(evt, returnFocusEl) {
          theme.cart.getCart().then(function(cart) {
            this.buildCart(cart, false, returnFocusEl);
          }.bind(this));
        }.bind(this));

        $('body').on('added.ajaxProductDrawerUpdate', function(evt, returnFocusEl) {
          //console.log("ajaxProductDrawerUpdate")
          theme.cart.getCart().then(function(cart) {
          	var isUpdate = false;
            $.each(cart.items,function(ck,cv){
            	var cartItem = $(selectors.container).find(".ajaxcart__product").eq(ck);
            	var cartKey = cartItem.find(".js-qty__num").attr("data-id");
                //console.log(cartItem,ck)
                //console.log(cartKey,cv["key"])
                if(cartKey != cv["key"])
                {
                	isUpdate = true;
                    return false;
                }
            })
			if(isUpdate)
            {
            	//console.log("ajaxProductDrawerUpdate buildCart")    
          		this.buildCart(cart, false, returnFocusEl);
            }
          }.bind(this));
        }.bind(this));
        
        $('body').on('openCart', function() {
          this.drawer.open(false)
        }.bind(this));
        
        // 购物车 产品删除
        var that = this;
        $("body").on("click",selectors.drawer+" "+selectors.removeBtn,function(){
              var key = $(this).attr("data-id");
              var qty = 0;
              theme.cart.changeItem(key, qty)
                    .then(function(cart) {
                      that.updateSuccess(cart);
                    }.bind(that))
                    .catch(function(XMLHttpRequest) {
                      that.updateError(XMLHttpRequest)
                    }.bind(that))
                    .always(function() {
                      that.loading(false);
                    }.bind(that));

          })
        
      },
  
      buildCart: function(cart, openDrawer, returnFocusEl) {
        
          
        	cart = this.cartProductOptimization(cart);
		

        if(cart === false)
          	return false; 
           
        
          var mbCartRecommend = $('.cart-recommend-box.cart-recommend-mb-box')
          var mbCartRecommendH = mbCartRecommend.outerHeight()
        
        
          
  		
          	this.linkFreeProduct(cart)
            
        
        this.loading(true);
        this.emptyCart();
  
        if (cart.item_count === 0) {
            $(selectors.container).append(`
				
                 <div class="drawer__scrollable null-cart">
                  <div class="appear-animation appear-delay-3">

                  <div class="empty_text"><span class="empty-cart">Ihr Warenkorb ist leer.</span><br>Gönnen Sie sich den Luxus der Seide</div>

                  <div class="cart_catalog">
                      <a href="/collections/best-seller" class="cart_catalog-box">
						<div class="catalog-box">
                          <div class="catalog">Bestseller</div>
						  <div class="catalog-img">
                          	<img src="https://cdn.shopify.com/s/files/1/1873/0299/files/16d8c5a3dae5e2934c3675b73324267a.svg?v=1628496658">
                          </div>
						</div>
                      </a>
                      <a href="/collections/neuheiten" class="cart_catalog-box">
						<div class="catalog-box">
                          <div class="catalog">Neuheiten</div>
						  <div class="catalog-img">
                          	<img src="https://cdn.shopify.com/s/files/1/1873/0299/files/16d8c5a3dae5e2934c3675b73324267a.svg?v=1628496658">
                          </div>
						</div>
                      </a>
                      <a href="/collections/seide-kissenbezug" class="cart_catalog-box">
						<div class="catalog-box">
                          <div class="catalog">Seide Kissenbezug</div>
						  <div class="catalog-img">
                          	<img src="https://cdn.shopify.com/s/files/1/1873/0299/files/16d8c5a3dae5e2934c3675b73324267a.svg?v=1628496658">
                          </div>
						</div> 
                      </a>
                      <a href="/collections/side-bettdecken" class="cart_catalog-box">
						<div class="catalog-box">
                          <div class="catalog">Bettdecken</div>
						  <div class="catalog-img">
                          	<img src="https://cdn.shopify.com/s/files/1/1873/0299/files/16d8c5a3dae5e2934c3675b73324267a.svg?v=1628496658">
                          </div>
						</div>
                      </a>
                      <a href="/pages/sale" class="cart_catalog-box">
						<div class="catalog-box"  style="color: #9c142b;font-family: 'FU-WebFonts-M';">
                          <div class="catalog">Verkauf</div>
						  <div class="catalog-img">
                          	<img src="https://cdn.shopify.com/s/files/1/1873/0299/files/16d8c5a3dae5e2934c3675b73324267a.svg?v=1628496658">
                          </div>
						</div>
                      </a>
                  </div>
                  </div>
                  </div>
              </div>
              <div class="cart_image img">
                  <a href="/collections/sale">
                    <img src="https://cdn.shopify.com/s/files/1/0418/4539/1527/files/de_c34d34b8-63e8-457a-9537-951402e725ab.jpg?v=1744161945" >
        
                  </a>
                
                  
                
                  
              </div>
              	`);
        } else {
          var items = [];
          var item = {};
          var data = {};
          var animation_row = 1;
  
          $.each(cart.items, function(index, product) {
  
            var prodImg;
            if (product.image !== null) {
              prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
            } else {
              prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
            }
  
            if (product.properties !== null) {
              $.each(product.properties, function(key, value) {
                if (key.charAt(0) === '_' || !value) {
                   delete product.properties[key];
                 }
              });
            }
  
            // If we have line-item discount, add formattedAmount to discount object
            var amount = 0;
            if (product.line_level_discount_allocations.length !== 0) {
              for (var discount in product.line_level_discount_allocations) {
                amount = product.line_level_discount_allocations[discount].amount;
  
                product.line_level_discount_allocations[discount].formattedAmount = theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
              }
            }
  
            animation_row+=2;
            
            if (product.variant_title != null ){
              if (product.variant_title.indexOf("-preorder") != -1 ){
                // 口罩 20天
                var pre_order_day = "15 Tagen";
                if(product.product_id == "5894251544737")
                 	pre_order_day = "20 Tagen"; 
                ispreorder='*Versand der Vorbestellungen in '+pre_order_day;
              }else{
                ispreorder='';
              }
              var title_product=product.variant_title.replace('-preorder','')
            }else{
            	ispreorder='';
                var title_product=product.variant_title
            }
            // 判断是不是0元产品
            var isGiveaway = false
            if(product.price == 0)
              	isGiveaway = true
  
            item = {
              key: product.key,
              url: product.url,
              img: prodImg,
              animationRow: animation_row,
              name: (product.product_title).replace("Gratis-Geschenk",`<span class="free-gift">Gratis-Geschenk</span>`),
              variation: title_product,
              properties: product.properties,
              product_attr_id:product.id,
              itemQty: product.quantity,
              price: theme.Currency.formatMoney(product.price, theme.settings.moneyFormat),
              unitPrice: theme.Currency.formatMoney(product.unit_price, theme.settings.moneyFormat),
              unitBase: theme.Currency.getBaseUnit(product),
              discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount/product.quantity)), theme.settings.moneyFormat),
              discounts: product.line_level_discount_allocations,
              discountsApplied: product.line_level_discount_allocations.length === 0 ? false : true,
              discountsMessage: product.discounts.length ? product.discounts[0].title : "",
              vendor: product.vendor,
              ispreorder:ispreorder,
              isGiveaway:isGiveaway
            };
            if(typeof(gaDataDeploy) == "object")
              item['ga_data'] = JSON.stringify(gaDataDeploy.getGaProductDataCart(product));
            
            items.push(item);
          });
  
          animation_row+=2;
  
          // If we have cart discount, add a formattedAmount to the discount object
          var cartAmount = 0;
          if (cart.cart_level_discount_applications.length !== 0) {
            for (var cartDiscount in cart.cart_level_discount_applications) {
              cartAmount = cart.cart_level_discount_applications[cartDiscount].total_allocated_amount;
  
              cart.cart_level_discount_applications[cartDiscount].formattedAmount = theme.Currency.formatMoney(cartAmount,theme.settings.moneyFormat);
            }
          }
  
          data = {
            items: items,
            note: cart.note,
            lastAnimationRow: animation_row,
            cartDiscounts: cart.cart_level_discount_applications,
            cartDiscountsApplied: cart.cart_level_discount_applications.length === 0 ? false : true,
            totalPrice: theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat),
            totalPrice_number:cart.total_price/100,
            checkDisable:cart.total_price > 0 ? false : true,
            original_total_price:theme.Currency.formatMoney(cart.original_total_price, theme.settings.moneyFormat),
            original_total_price_number:cart.original_total_price/100,
            is_discount:cart.original_total_price > cart.total_price ? true : false,
          };
          data["items"][items.length - 1]["is_last"] = true;

          
          data["pricePoint"] = getPricePoints(cart.total_price);
          data["pricePointMsg"] = 'Reward %Points% Points'.replace('%Points%',data["pricePoint"])
          
          
          // minicart 模板写入
          
          	var cartHtml = $("<div>"+this.template(data)+"</div>")
            cartHtml.find('.cart-recommend-box.cart-recommend-mb-box').css({"height":mbCartRecommendH})
            $(selectors.container).append(cartHtml.html());
             
          if(theme.miniAddToCartTop && theme.miniRecommendAdd)
         	$(selectors.container).animate({"scrollTop":0},600)
        }
  
        this.status.loaded = true;
        this.loading(false);
        this.updatecartCount(cart);	
        this.cartNote(cart.note);
        this.cartSale()
        
  		var SlickDom = $("#CartDrawer .freehippingprice .title")
  		
  
  		
            if(SlickDom.hasClass('slick-initialized')){
              SlickDom.slick("unslick")
            }
  			change_progress_price(cart.total_price/100);
  		
  
        $('body').trigger('updateCart' + config.namespace, cart);
  
        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
  
        // If specifically asked, open the cart drawer (only happens after product added from form)
        if (openDrawer === true) {
          this.drawer.open(false, returnFocusEl);
        }
        
        
        
        
 			setTimeout(cart_recommend_ajax_product,0);
          
    	
    	if(typeof(gaDataDeploy) == "object")
          	gaDataDeploy.cartDeploy();
    
      },
  
      initQtySelectors: function() {
        $(selectors.container).find('.js-qty__wrapper').each(function(index, el) {
          var selector = new theme.QtySelector($(el), {
            namespace: '.cart-drawer'
          });
        }.bind(this));
  
        $('body').on('qty.cart-drawer', this.updateItem.bind(this));
      },
  
      updateItem: function(evt, key, qty) {
        if (this.status.loading) {
          return;
        }
  
        this.loading(true);
  
        theme.cart.changeItem(key, qty)
          .then(function(cart) {
            this.updateSuccess(cart);
          }.bind(this))
          .catch(function(XMLHttpRequest) {
            this.updateError(XMLHttpRequest)
          }.bind(this))
          .always(function() {
            this.loading(false);
          }.bind(this));
      },
  
      loading: function(state) {
        this.status.loading = state;
  
        if (state) {
          $(selectors.container).addClass('is-loading');
        } else {
          $(selectors.container).removeClass('is-loading');
        }
      },
  
      emptyCart: function() {
        $(selectors.container).empty();
      },
  
      updateSuccess: function(cart,openDrawer) {
        this.buildCart(cart,openDrawer)
      },
  
      updateError: function(XMLHttpRequest) {
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          // console.warn(XMLHttpRequest.responseJSON.description);
        }
      },
      
      // 关于购物车产品判断的问题  保证赠品都是唯一的
      cartProductOptimization:function(cart)
	  {
        //console.log("cartProductOptimization",cart);
		if (cart.items.length > 0) 
		{
			var isRefreshCart = false;
			var refreshCart = {"updates":{}};
			var freeGiftJson = [];
            var freeGiftLadderJson = [];
			//var cartRealProductNum = getCartRealProductNum(cart);
			
          	// 判断赠品是否超过两个
          	var freeGiftNumOptimization = this.cartProductFreeGiftOptimization(cart);
          	if(!freeGiftNumOptimization)
              	return false;
          
            // 是否自动加购
            var autoAdd = true
         	// 满赠
			
				var giftBoxId = $("#freeGiftBoxProductId").val();
				var giftBoxPrice = "0";
                freeGiftJson.push({"giftBoxId":giftBoxId,"giftBoxPrice":giftBoxPrice,"autoAdd":autoAdd});
			
          
			$.each(freeGiftJson,function(k,v){
			
				var giftBoxId = v["giftBoxId"];
				var giftBoxVariantId = "";
				var giftBoxPrice = v["giftBoxPrice"] ? v["giftBoxPrice"] : 0;
				var giftBoxNum = v["giftBoxNum"] ? v["giftBoxNum"] : 0;
              	var autoAdd = v["autoAdd"];
				var isHaveGiftBox = false;
				var giftBoxQty = 0;
				var isFreePrice = false;
				var isReturn = false;
				
				if(giftBoxId)
				{
					// 判断是否含有赠品
					$.each(cart.items,function(k,v){
                        var productType = autoAdd ? "variant_id" : "product_id";
						if(v[productType] == giftBoxId)
						{
							isHaveGiftBox = true;
							giftBoxQty = v["quantity"];
							giftBoxVariantId = v["variant_id"];
							return false; 
						}
					})
					if(!giftBoxVariantId && !autoAdd)
                      return true;
					// 判断价格是否满足
					//if(cart.total_price >= (giftBoxPrice * 100) && cartRealProductNum >= giftBoxNum)
					if(cart.total_price >= (giftBoxPrice * 100))
					  isFreePrice = true;
					// 不符合 但是已经有赠品的 删除赠品
					if(isHaveGiftBox && !isFreePrice)
					{
					  isRefreshCart = true;
					  refreshCart["updates"][giftBoxVariantId] = 0;
					}
					else if(isHaveGiftBox  && giftBoxQty > 1)
					{
					  isRefreshCart = true;
					  refreshCart["updates"][giftBoxVariantId] = 1;
					}
					else if(!isHaveGiftBox  && isFreePrice)
					{
					  isRefreshCart = true;
					  refreshCart["updates"][giftBoxId] = 1;
					}
				}
			})
            // 梯度满赠
			
				var giftBoxId3 = $("#freeGiftLadderProductId3").val();
				var giftBoxPrice3 = "300";
                if(giftBoxId3 && giftBoxPrice3)
					freeGiftLadderJson.push({"giftBoxId":giftBoxId3,"giftBoxPrice":giftBoxPrice3});
			
            
				var giftBoxId2 = $("#freeGiftLadderProductId2").val();
				var giftBoxPrice2 = "199";
                if(giftBoxId2 && giftBoxPrice2)
					freeGiftLadderJson.push({"giftBoxId":giftBoxId2,"giftBoxPrice":giftBoxPrice2});
			
            
				var giftBoxId1 = $("#freeGiftLadderProductId1").val();
				var giftBoxPrice1 = "99";
                if(giftBoxId1 && giftBoxPrice1)
					freeGiftLadderJson.push({"giftBoxId":giftBoxId1,"giftBoxPrice":giftBoxPrice1});
			
          
          	var isParentHave = false; // 上移阶梯产品cart是否有
			$.each(freeGiftLadderJson,function(k,v){
			
				var giftBoxId = v["giftBoxId"];
				var giftBoxVariantId = "";
				var giftBoxPrice = v["giftBoxPrice"] ? v["giftBoxPrice"] : 0;
				var giftBoxNum = v["giftBoxNum"] ? v["giftBoxNum"] : 0;
				var isHaveGiftBox = false;
				var giftBoxQty = 0;
				var isFreePrice = false;
				var isReturn = false;
				
				if(giftBoxId)
				{
					// 判断是否含有赠品
					$.each(cart.items,function(k,v){
                      	var productType = autoAdd ? "variant_id" : "product_id";
						if(v[productType] == giftBoxId)
						{
							isHaveGiftBox = true;
							giftBoxQty = v["quantity"];
							giftBoxVariantId = v["variant_id"];
							return false; 
						}
					})
                    
					if(!giftBoxVariantId  && !autoAdd)
                      return true;
                    if(autoAdd)
                      giftBoxVariantId = giftBoxId;
					// 判断价格是否满足
					//if(cart.total_price >= (giftBoxPrice * 100) && cartRealProductNum >= giftBoxNum)
					if(cart.total_price >= (giftBoxPrice * 100))
					  isFreePrice = true;
				  
                    //console.log(isHaveGiftBox,isFreePrice,giftBoxQty,isParentHave)
                   if(isParentHave)
					{
                      if(isHaveGiftBox)
                      {
                        isRefreshCart = true;
                        refreshCart["updates"][giftBoxVariantId] = 0;
                      }
					}
                    else if(isHaveGiftBox && !isFreePrice)
					{
                      // 不符合 但是已经有赠品的 删除赠品
					  isRefreshCart = true;
					  refreshCart["updates"][giftBoxVariantId] = 0;
					}
					else if(isHaveGiftBox  && giftBoxQty > 1)
					{
					  isRefreshCart = true;
					  refreshCart["updates"][giftBoxVariantId] = 1;
                      isParentHave = true;
					}
					else if(!isHaveGiftBox  && isFreePrice)
					{
					  isRefreshCart = true;
					  refreshCart["updates"][giftBoxVariantId] = 1;
                      isParentHave = true;
					} 
                    if(isHaveGiftBox)
                    	isParentHave = true;
				}
			})
			if(isRefreshCart)
			{
				changeData = theme.cart.updateItem(refreshCart)
					.then(function(cart) {
					  this.updateSuccess(cart,true);
					}.bind(this))
					.catch(function(XMLHttpRequest) {
					  this.updateError(XMLHttpRequest)
					}.bind(this))
					.always(function() {
					  this.loading(false);
					}.bind(this));
			}
			else
			{
				return cart;
			}
			return false;
		}
        else
        {
          return cart;
        }
	  }, 
      // 判断赠品是否超过2个 
      cartProductFreeGiftOptimization:function(cart)
	  {
       	var removeProductReady = {"updates":{}};
        var freeGiftQty = 0;
        $.each(cart.items, function(index, product) {
        	if(product.price == 0)
            {	
                var productId = product.id;
                var productKey = product.key;
                var productQty = product.quantity;
                removeProductReady["updates"][productKey] = 0;
                freeGiftQty += 	productQty;
            }
        })
        if(freeGiftQty >1 )
        {
            theme.cart.updateItem(removeProductReady)
                .then(function(cart) {
                this.updateSuccess(cart,true);
                }.bind(this))
                .catch(function(XMLHttpRequest) {
                this.updateError(XMLHttpRequest)
                }.bind(this))
                .always(function() {
                this.loading(false);
                }.bind(this));  
            return false;
        }
        return true
      },
      // 链接赠品
      linkFreeProduct:function(cart){
        //console.log("linkFreeProduct")
        var keyVal = "survey=gift"
		var giftBoxId = $("input[name='linkFreeGiftProductId1']").val();
        var isAddLinkFreeProduct = this.isAddLinkFreeProduct
        
		keyVal = keyVal.split("=");
		var key = keyVal[0];
		var val = keyVal[1];
  
		if(getUrlParam(key) == val  && val && !isAddLinkFreeProduct  && giftBoxId)
		{
			var isHaveGiftBox = false;
			$.each(cart.items,function(k,v){
				var productType = "variant_id";
				if(v[productType] == giftBoxId)
				{
					isHaveGiftBox = true;
					return false; 
				}
			})
            //console.log("linkFreeProduct",isHaveGiftBox)
			if(isHaveGiftBox)
            {
              	this.isAddLinkFreeProduct = true;
				return false
            }
				
			var refreshCart = {"updates":{}};
			refreshCart["updates"][giftBoxId] = 1;
			changeData = theme.cart.updateItem(refreshCart).then(function(cart) {
				this.buildCart(cart, true);
			}.bind(this))
            this.isAddLinkFreeProduct = true;
		}
	  },
   
      updateCartNotification: function(evt, cart) {
        if (cart.items.length > 0) {
          $(selectors.cartBubble).addClass('cart-link__bubble--visible');
        } else {
          $(selectors.cartBubble).removeClass('cart-link__bubble--visible');
        }
      },
     // 更改购物车产品数量
      updatecartCount:function(cart){
          $(selectors.drawer).find(".drawer__title .product-item").html(`( ${cart.item_count} Artikel )`);
          $('.site-nav .site-nav__link.js-drawer-open-cart .cart-item').html(`${cart.item_count}`)
      },
      // 购物车 note
      cartNote:function(note){
		  var container = $(selectors.container);
		  var cartNote = container.find(".cart-note-text");
		  var textarea = cartNote.find(".textarea-box .textarea #contents");
		  var cartNoteSaveBtn = cartNote.find('.save-note-button');
		  var maxl = 250 //总长
          var speed  = 300;
		  // note内容状态
		  function noteStatusUpdate(noteText,isKey)
  		  {
                if(!noteText ) noteText = ""
			  	var noteL = noteText.length
				if(noteL)
				{
					if(!isKey)
					{
                        cartNote.find('.input').hide()
						cartNote.find('.edit-text').show()
					}else{
                    }
				}
				else
				{
                  if(!isKey){
                    cartNote.find('.edit-text').hide();
                    cartNote.find('.input').show();
                  }else{
                    cartNote.find('.edit-text').hide();
                    cartNote.find('.input').hide()
                  }
					
				}
				cartNote.find('.count-num .surplus-num').text(`${noteL}`);
		  }
		  noteStatusUpdate(note);
		  // note输入事件
		  textarea.keyup(function(){
			  	var noteText = $(this).val();
				var noteL = $(this).val().length;
				if (noteL > maxl) 
				{
					noteText = noteText.substr(maxl, maxl)
					$(this).val(noteText);
				}
				noteStatusUpdate(noteText,true)
		  })
		  // 提交按钮
		  cartNoteSaveBtn.click(function() {
				var noteText = textarea.val();
				theme.cart.updateNote(`${noteText}`);
				noteDrawerStatusUpdate()
				noteStatusUpdate(noteText)
              
		  })
		  // note 抽屉状态
		  function noteDrawerStatusUpdate(isOpen)
		  {
			  if(isOpen)
			  {
                    cartNote.find('.textarea-box').slideDown(speed);
				  	textarea.focus();
					container.find(".drawer__footer").addClass("openNote")
			  }
			  else
			  {
				  cartNote.find('.textarea-box').slideUp(speed);
				  container.find(".drawer__footer").removeClass("openNote")
			  }
		  }
		  // 单选框
		  cartNote.find('.input').click(function() {
			var isEmptyNote = $(this).hasClass('input-true') ? true : false
			if(isEmptyNote) 
			{
				$(this).removeClass('input-true');
				theme.cart.updateNote('');
				textarea.val('');
				noteStatusUpdate("")
				noteDrawerStatusUpdate()
			}
			else 
			{
                $(this).hide();
				noteDrawerStatusUpdate(true)
			}
		 })
		 // 修改按钮
		 cartNote.on("click",".edit-text",function(){
			noteDrawerStatusUpdate(true);
             $(this).hide();
		 })		  
	  },
      // 购物车sale信息展示
      cartSale:function(){
          return true;
          var url = "/cart"
          url = url + '?view=sale';
          $('.cartSaleBoxBB').load(url, function(data) {
            $(this).html(data)
          }.bind(this));
      }


    });
    return CartDrawer;
  })();
  
  theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };
  
    function ProductForm($form,callback) {
      this.$form = $form;
      this.callback = callback;
      this.bigCart = "";
      var formProductId = this.$form.parents('.product-section').attr("data-section-id")
      this.$addToCart = this.$form.find('.add-to-cart');
      this.$addToCartFixed = $('.suspension-nav-'+ formProductId +' .suspension-nav-button-box')
      this.formDiscount = ""
  
      if (this.$form.length) {
        //this.$form.on('submit', this.addItemFromForm.bind(this,$(this)));
        var that = this
        this.$form.on('submit',function(evt){
            that.bigCart = $(this).data("bigcart");
        	that.addItemFromForm(evt,$(this))
        });
      }
    };
  
    ProductForm.prototype = $.extend({}, ProductForm.prototype, {
      addItemFromForm: function(evt, thisForm){
        evt.preventDefault();
  
        if (status.loading) {
          return;
        }
  
        // Loading indicator on add to cart button
        this.$addToCart.addClass('btn--loading');
  
        status.loading = true;
  
        var data = thisForm.serialize();
        this.formDiscount = thisForm.find("input[name='discount-code']").val();
  
          theme.cart.addItemFromForm(data)
          .then(function(product) {
          
            if ($('.addcheckbox').length >= 1){
              if($('.addcheckbox').hasClass('addcheckboxtrue')){
                  var adddata=$('.addcheckbox').attr('value');
                  theme.cart.addItemFromForm(adddata)
                  .then(function(product) {
                    this.success(product);
                  }.bind(this))
                  .catch(function(XMLHttpRequest) {
                    this.error(XMLHttpRequest)
                  }.bind(this))
                  .always(function() {
                    status.loading = false;
                    this.$addToCart.removeClass('btn--loading');
                  }.bind(this));
              }
            };
            
            this.success(product);
            
            
          	if(this.callback)
          		this.callback();
            
          }.bind(this))
          .catch(function(XMLHttpRequest) {
            this.error(XMLHttpRequest)
          }.bind(this))
          .always(function() {
            status.loading = false;
            this.$addToCart.removeClass('btn--loading');
          }.bind(this));
      },
  
      success: function(product) {
        this.$form.find('.errors').remove();
        this.useDiscount()
        if(this.bigCart){
            var cartUrl = "/cart";
		    if(this.formDiscount)
			   cartUrl = "/cart?discount="+this.formDiscount;
		    window.location.href = cartUrl
        }else{
          $('body').trigger('added.ajaxProduct', this.$addToCart);
        }
      },
  
      error: function(XMLHttpRequest) {
        this.$form.find('.errors').remove();
  
        if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
          this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
        }
      },
      useDiscount:function(){
          var discount = this.formDiscount
		  var scDiscountForm = $(".scDiscount__container form");
		  var scDiscountFormCode = scDiscountForm.find("input[name='code']").val();
		  //if(scDiscountFormCode == "" && discount && typeof window.DiscountHero == "object")
          if(discount && typeof window.DiscountHero == "object")
		  	window.DiscountHero.discount.apply(discount)		   

	  }
    });
  
    return ProductForm;
  })();
  
  theme.collapsibles = (function() {
  
    var selectors = {
      triggerssBox:".mobile-nav__has-sublist",
      triggerss:".mobile-nav__item.appear-animation",
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height'
    };
  
    var namespace = '.collapsible';
  
    var isTransitioning = false;
  
    function init() {
      $(selectors.triggerss).each(function() {
        var $el = $(this).parent().find('.collapsible-trigger');
        var state = $el.hasClass(classes.open);
        $el.attr('aria-expanded', state);
      });
  
      // Event listeners (hack for modals)
      $('body, .modal__inner')
        .off(namespace)
        .on('click' + namespace, selectors.triggerssBox, function() {
        if($(this).parent().hasClass('is-open')){
          $(this).parent().removeClass('is-open')
        }else{
          $(this).parent().addClass('is-open')
        }
        if (isTransitioning) {
          return;
        }
  
        isTransitioning = true;
  
        var $el = $(this).parent().find('.collapsible-trigger');
        var isOpen = $el.hasClass(classes.open);
        var moduleId = $el.attr('aria-controls');
        var $module = $('#' + moduleId);
        var height = $module.find(selectors.moduleInner).outerHeight();
        var isAutoHeight = $el.hasClass(classes.autoHeight);

  
        // If isAutoHeight, set the height to 0 just after setting the actual height
        // so the closing animation works nicely
        if (isOpen && isAutoHeight) {
          setTimeout(function() {
            height = 0;
            setTransitionHeight($module, height, isOpen, isAutoHeight);
          }, 0);
        }
  
        if (isOpen && !isAutoHeight) {
          height = 0;
        }
  
        $el
          .attr('aria-expanded', !isOpen)
          .toggleClass(classes.open, !isOpen);
  
        setTransitionHeight($module, height, isOpen, isAutoHeight);
      });
    }
  
    function setTransitionHeight($module, height, isOpen, isAutoHeight) {
      $module
        .removeClass(classes.hide)
        .prepareTransition()
        .css('height', height)
        .toggleClass(classes.open, !isOpen);
  	var nav_color=$module.prev().find('.silder-text');
      if (!isOpen && isAutoHeight) {
        var o = $module;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 350);
        nav_color.addClass('nav_open_color');
      } else {
        isTransitioning = false;
        nav_color.removeClass('nav_open_color');
      }
    }

    return {
      init: init
    };
  })();
  
  theme.headerNav = (function() {
  
    var $parent = $(document.documentElement).add('body');
    var $page = $('#MainContent');
    var selectors = {
      wrapper: '.header-wrapper',
      siteHeader: '.site-header',
      searchBtn: '.js-search-header',
      closeSearch: '.js-search-header-close',
      searchContainer: '.site-header__search-container',
      logoContainer: '.site-header__logo',
      logo: '.site-header__logo img',
      navigation: '.site-navigation',
      megamenu: '.megamenu',
      navContainerWithLogo: '.header-item--logo',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level'
    };
  
    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused',
      overlaidBodyClass: 'overlaid-header',
      stickyBodyClass: 'sticky-header'
    };
  
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      stickyEnabledClass: 'header-wrapper--sticky',
      stickyEnabled: false,
      stickyActive: false,
      stickyInitialized: false,
      forceStopSticky: false,
      stickyClass: 'site-header--stuck',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };
  
    // Elements used in resize functions, defined in init
    var $window;
    var $navContainerWithLogo;
    var $logoContainer;
    var $nav;
    var $wrapper;
    var $siteHeader;
  
    function init() {
      $window = $(window);
      $navContainerWithLogo = $(selectors.navContainerWithLogo);
      $logoContainer = $(selectors.logoContainer);
      $nav = $(selectors.navigation);
      $wrapper = $(selectors.wrapper);
      $siteHeader = $(selectors.siteHeader);
  
      config.wrapperOverlayed = theme.settings.overlayHeader = $wrapper.hasClass(config.overlayedClass);
      config.stickyEnabled = $siteHeader.data('sticky');
  
      if (config.stickyEnabled) {
        stickyHeaderCheck();
        $window.on('resize' + config.namespace, $.debounce(150, stickyHeaderCheck));
      }
  
      if (config.wrapperOverlayed) {
        $('body').addClass(classes.overlaidBodyClass);
      }
  
      accessibleDropdowns();
      searchDrawer();
    }
  
    function unload() {
      $(window).off(config.namespace);
      $(selectors.searchBtn).off(config.namespace);
      $(selectors.closeSearch).off(config.namespace);
      $parent.off(config.namespace);
      $(selectors.navLinks).off(config.namespace);
      $(selectors.navDropdownLinks).off(config.namespace);
    }
  
    function searchDrawer() {
      $(selectors.searchBtn).on('click' + config.namespace, function(evt) {
        evt.preventDefault();
        openSearchDrawer();
      });
  
      $(selectors.closeSearch).on('click' + config.namespace, function() {
        closeSearchDrawer();
      });
    }
  
    function openSearchDrawer() {
      $(selectors.searchContainer).addClass('is-active');
      $parent.addClass('js-drawer-open--search');
  
      theme.a11y.trapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search',
        $elementToFocus: $(selectors.searchContainer).find('input')
      });
  
      // If sticky is enabled, scroll to top on mobile when close to it
      // so you don't get an invisible search box
      if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
        window.scrollTo(0,0);
      }
  
      // Bind events
      theme.a11y.lockMobileScrolling(config.namespace);
  
      // Clicking out of container closes it
      $page.on('click' + config.namespace, function () {
        closeSearchDrawer();
        return false;
      });
  
      $parent.on('keyup' + config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      });
    }
  
    function closeSearchDrawer() {
      // deselect any focused form elements
      $(document.activeElement).trigger('blur');
  
      $parent.removeClass('js-drawer-open--search').off(config.namespace);
      $(selectors.searchContainer).removeClass('is-active');
  
      theme.a11y.removeTrapFocus({
        $container: $(selectors.searchContainer),
        namespace: 'header_search'
      });
  
      theme.a11y.unlockMobileScrolling(config.namespace);
      $page.off('click' + config.namespace);
      $parent.off('keyup' + config.namespace);
    }
  
    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;
  
      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        $(selectors.navLinksWithDropdown).on('touchend' + config.namespace, function(evt) {
          var $el = $(this);
          var $parentItem = $el.parent();
          if (!$parentItem.hasClass(classes.dropdownActive)) {
            evt.preventDefault();
            closeDropdowns();
            openFirstLevelDropdown($el);
          } else {
            window.location.replace($el.attr('href'));
          }
        });
  
        $(selectors.navDropdownLinks).on('touchend' + config.namespace, function(evt) {
          var $el = $(this);
          var $parentItem = $el.parent();
  
          // Open third level menu or go to link based on active state
          if ($parentItem.hasClass(classes.hasSubDropdownClass)) {
            if (!$parentItem.hasClass(classes.dropdownActive)) {
              evt.preventDefault();
              closeThirdLevelDropdown();
              openSecondLevelDropdown($el);
            } else {
              window.location.replace($el.attr('href'));
            }
          } else {
            // No third level nav, go to link
            window.location.replace($el.attr('href'));
          }
        });
      }
  
      $(selectors.navLinks).on('focusin mouseover' + config.namespace, function() {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }
  
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
  
        openFirstLevelDropdown($(this));
      });
  
      // Force remove focus on sitenav links because focus sometimes gets stuck
      $(selectors.navLinks).on('mouseleave' + config.namespace, function() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      });
  
      // Open/hide sub level dropdowns
      $(selectors.navDropdownLinks).on('focusin' + config.namespace, function() {
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
  
        openSecondLevelDropdown($(this), true);
      });
  
      // Private dropdown methods
      function openFirstLevelDropdown($el) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasDropdownClass)) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveDropdown = true;
        }
  
        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            $('body').on(eventType + config.namespace, function() {
              closeDropdowns();
              $('body').off(config.namespace);
              closeOnClickActive = false;
            });
          }
        }
      }
  
      function openSecondLevelDropdown($el, skipCheck) {
        var $parentItem = $el.parent();
        if ($parentItem.hasClass(classes.hasSubDropdownClass) || skipCheck) {
          $parentItem.addClass(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }
  
      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }
  
      function closeSecondLevelDropdown() {
        $(selectors.navItems).removeClass(classes.dropdownActive);
      }
  
      function closeThirdLevelDropdown() {
        $(selectors.navDropdownLinks).parent().removeClass(classes.dropdownActive);
      }
    }
  
    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();
  
      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeaderSetup();
      } else {
        config.forceStopSticky = true;
      }
    }
  
    function stickyHeaderSetup() {
      if (!config.stickyInitialized) {
        $parent.addClass(classes.stickyBodyClass);
        $siteHeader.wrap('<div class="site-header-sticky"></div>');
  
        stickyHeaderHeight();
        setTimeout(function() {
          stickyHeaderHeight();
        }, 200);
  
        $window.on('resize' + config.namespace, $.debounce(50, stickyHeaderHeight));
        $window.on('scroll' + config.namespace, $.throttle(15, stickyHeaderScroll));
      }
  
      config.stickyInitialized = true;
    }
  
    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      $(selectors.megamenu).each(function() {
        var h = $(this).outerHeight();
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });
  
      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < (largestMegaNav + 120)) {
        return false;
      }
  
      return true;
    }
  
    function stickyHeaderHeight() {
      var height = $siteHeader.outerHeight(true);
      //var $stickyHeader = $('.site-header-sticky').css('height', height);
  
      // Also update top position of sticky sidebar
      if ($('.grid__item--sidebar').length) {
        $('.grid__item--sidebar').css('top', height + 10);
      }
    }
    
  
    function stickyHeaderScroll() {
      if (config.forceStopSticky) {
        return;
      }
      
      var scroll = $window.scrollTop();
      var threshold = 150;
      var scrollDirection = scroll - config.lastScroll;
      config.lastScroll = scroll;
      if (scroll > threshold) {
        if (scrollDirection <= 0){
          if (config.stickyActive) {
            return;
          }
          config.stickyActive = true;
          $('.announcement-bar').addClass('announcement-sticky');
          $siteHeader.addClass(config.stickyClass);
          if (config.wrapperOverlayed) {
            $wrapper.removeClass(config.overlayedClass);
          }
    
          // Add open transition class after element is set to fixed
          // so CSS animation is applied correctly
          setTimeout(function() {
            $siteHeader.addClass(config.openTransitionClass);
          }, 100);
        }else{
          if (!config.stickyActive) {
            return;
          }
    
          
          if ($('.js.sticky-header').hasClass('js-drawer-open')){
            return;
          }else{
            config.stickyActive = false;
    
            $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClass);
            $('.announcement-bar').removeClass('announcement-sticky');
            if (config.wrapperOverlayed) {
              $wrapper.addClass(config.overlayedClass);
            }
          }
          
        
        }
      } else {
        if (!config.stickyActive) {
          return;
        }
        if ($('.js.sticky-header').hasClass('js-drawer-open')){
          return;
        }else{
          config.stickyActive = false;
          $('.announcement-bar').removeClass('announcement-sticky');
          $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClass);
          if (config.wrapperOverlayed) {
            $wrapper.addClass(config.overlayedClass);
          }
        }
        
      }
  
      
    }
  
    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      $(selectors.wrapper)
        .removeClass(config.stickyEnabledClass)
        .removeClass(config.overlayedClass);
  
      $('body').removeClass(classes.overlaidBodyClass);
      config.wrapperOverlayed = false;
    }
  
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader,
      unload: unload
    };
  })();
  
  theme.Slideshow = (function() {
    this.$slideshow = null;
  
    var classes = {
      next: 'is-next',
      init: 'is-init',
      animateOut: 'animate-out',
      wrapper: 'slideshow-wrapper',
      slideshow: 'slideshow',
      allSlides: 'slick-slide',
      currentSlide: 'slick-current',
      pauseButton: 'slideshow__pause',
      isPaused: 'is-paused'
    };
  
    function slideshow(el, args) {
      this.$slideshow = $(el);
      this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
      this.$pause = this.$wrapper.find('.' + classes.pauseButton);
  
      this.settings = {
        accessibility: true,
        arrows: args.arrows ? true : false,
        dots: args.dots ? true : false,
        fade: args.fade ? true : false,
        speed: args.speed ? args.speed : 500,
        draggable: true,
        touchThreshold: 5,
        pauseOnHover: false,
        autoplay: args.autoplay ? true : false,
        autoplaySpeed: this.$slideshow.data('speed')
      };
  
      this.$slideshow.off('beforeChange');
      this.$slideshow.off('afterSlideChange');
      this.$slideshow.on('init', this.init.bind(this));
      this.$slideshow.on('beforeChange', this.beforeSlideChange.bind(this));
      this.$slideshow.on('afterChange', this.afterSlideChange.bind(this));
  
      this.$slideshow.slick(this.settings);
  
      this.$pause.on('click', this._togglePause.bind(this));
    }
  
    slideshow.prototype = $.extend({}, slideshow.prototype, {
      init: function(event, obj) {
        this.$slideshowList = obj.$list;
        this.$slickDots = obj.$dots;
        this.$allSlides = obj.$slides;
        this.slideCount = obj.slideCount;
  
        this.$slideshow.addClass(classes.init);
        this._a11y();
        this._clonedLazyloading();
      },
      beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.' + classes.currentSlide).addClass(classes.animateOut);
      },
      afterSlideChange: function(event, slick, currentSlide) {
        var $slider = slick.$slider;
        var $allSlides = $slider.find('.' + classes.allSlides).removeClass(classes.animateOut);
      },
      destroy: function() {
        this.$slideshow.slick('unslick');
      },
  
      // Playback
      _play: function() {
        this.$slideshow.slick('slickPause');
        $(classes.pauseButton).addClass('is-paused');
      },
      _pause: function() {
        this.$slideshow.slick('slickPlay');
        $(classes.pauseButton).removeClass('is-paused');
      },
      _togglePause: function() {
        var slideshowSelector = this._getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
          this.$pause.removeClass(classes.isPaused);
          $(slideshowSelector).slick('slickPlay');
        } else {
          this.$pause.addClass(classes.isPaused);
          $(slideshowSelector).slick('slickPause');
        }
      },
  
      // Helpers
      _getSlideshowId: function($el) {
        return '#Slideshow-' + $el.data('id');
      },
      _activeSlide: function() {
        return this.$slideshow.find('.slick-active');
      },
      _currentSlide: function() {
        return this.$slideshow.find('.slick-current');
      },
      _nextSlide: function(index) {
        return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
      },
  
      // a11y fixes
      _a11y: function() {
        var $list = this.$slideshowList;
        var autoplay = this.settings.autoplay;
  
        if (!$list) {
          return;
        }
  
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
  
        // When an element in the slider is focused
        // pause slideshow and set aria-live
        $(classes.wrapper).on('focusin', function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }
  
          $list.attr('aria-live', 'polite');
          if (autoplay) {
            this._pause();
          }
        }.bind(this));
  
        // Resume autoplay
        $(classes.wrapper).on('focusout', function(evt) {
          if (!$(classes.wrapper).has(evt.target).length) {
            return;
          }
  
          $list.removeAttr('aria-live');
          if (autoplay) {
            this._play();
          }
        }.bind(this));
      },
  
      // Make sure lazyloading works on cloned slides
      _clonedLazyloading: function() {
        var $slideshow = this.$slideshow;
  
        $slideshow.find('.slick-slide').each(function(index, el) {
          var $slide = $(el);
          if ($slide.hasClass('slick-cloned')) {
            var slideId = $slide.data('id');
            var $slideImg = $slide.find('.hero__image').removeClass('lazyloading').addClass('lazyloaded');
  
            // Get inline style attribute from non-cloned slide with arbitrary timeout
            // so the image is loaded
            setTimeout(function() {
              var loadedImageStyle = $slideshow.find('.slideshow__slide--' + slideId + ':not(.slick-cloned) .hero__image').attr('style');
  
              if (loadedImageStyle) {
                $slideImg.attr('style', loadedImageStyle);
              }
  
            }, this.settings.autoplaySpeed / 1.5);
  
          }
        }.bind(this));
      }
    });
  
    return slideshow;
  })();
  
  theme.announcementBar = (function() {
    var slideCount = 0;
    var compact = false;
    var defaults = {
      accessibility: true,
      arrows: false,
      dots: true,
      autoplay: false,
      autoplaySpeed: 4000,
      touchThreshold: 20,
      slidesToShow: 1,
      autoplay:true,
      autoplaySpeed: 4000,
      fade: true,
      draggable:true,
    };
    var $slider;
  
    function init() {
      $slider = $('#AnnouncementSlider');
      if (!$slider.length) {
        return;
      }
  
      slideCount = $slider.data('block-count');
      compact = $slider.data('compact-style');
  
      var desktopOptions = $.extend({}, defaults, {
        slidesToShow: compact ? 1 : slideCount,
        slidesToScroll: 1
      });
  
      var mobileOptions = $.extend({}, defaults, {
        slidesToShow: 1
      });
  
      if (theme.config.bpSmall) {
        initSlider($slider, mobileOptions);
      } else {
        initSlider($slider, desktopOptions);
      }
  
      $('body').on('matchSmall', function() {
        initSlider($slider, mobileOptions);
      }.bind(this));
  
      $('body').on('matchLarge', function() {
        initSlider($slider, desktopOptions);
      }.bind(this));
      
      if(typeof(gaDataDeploy) == "object")
      {
        var otherShowDeploy = gaDataDeploy.otherShowDeploy( gaDataDeploy.config.topPromotion.box,gaDataDeploy.config.topPromotion.item,{"creative":"Top_Promotion","positionPrefix":"Top_Promotion"});
        otherShowDeploy.itemShowAction();
        $slider.on("afterChange",function(event, slick, currentSlide, nextSlide){
          setTimeout(function(){
          	otherShowDeploy.itemShowAction();
          },100)
        })
      }      
    }
  
    function initSlider($slider, args) {
      if (isInitialized($slider)) {
        $slider.slick('unslick');
      }
      $slider.slick(args);
    }
  
    
    function isInitialized($slider) {
      return $slider.length && $slider.hasClass('slick-initialized');
    }
  
    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var $slide = $('#AnnouncementSlide-' + id);
      if ($slider.length) {
        $slider.slick('slickPause');
      }
      if ($slide.length) {
        $slider.slick('slickGoTo', $slide.data('index'));
      }
    }
  
    function onBlockDeselect(id) {
      if ($slider.length && isInitialized($slider)) {
        $slider.slick('slickPlay');
      }
    }
  
    function unload() {
      if (isInitialized($slider)) {
        $slider.slick('unslick');
      }
    }
  
    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  })();
  
  theme.predictiveSearch = (function() {
    var currentString = '';
    var isLoading = false;
    var searchTimeout;
    var namespace = '.predictive';
  
    var selectors = {
      form: '#HeaderSearchForm',
      input: 'input[type="search"]',
      wrapper: '.predictive-results',
  
      searchButton: '[data-predictive-search-button]',
  
      resultDiv: '#PredictiveResults',
      resultTemplate: '#PredictiveTemplate'
    };
  
    var classes = {
      isActive: 'predicitive-active'
    };
  
    var keys = {
      up_arrow: 38,
      down_arrow: 40,
      tab: 9
    };
  
    function init() {
      
      return false;
      // Only some languages support predictive search
      if (document.getElementById('shopify-features')) {
        var supportedShopifyFeatures = JSON.parse(document.getElementById('shopify-features').innerHTML);
        if (!supportedShopifyFeatures.predictiveSearch) {
          return;
        }
      }
  
      $(selectors.form).attr('autocomplete', 'off');
  
      $(selectors.input, selectors.form).on('keyup' + namespace, handleKeyup);
      $(selectors.searchButton, selectors.wrapper).on('click' + namespace, triggerSearch);
  
      // Prep handlebars template
      var source = $(selectors.resultTemplate).html();
      resultTemplate = Handlebars.compile(source);
    }
  
    function reset() {
      $(selectors.wrapper).addClass('hide');
      clearTimeout(searchTimeout);
    }
  
    function triggerSearch() {
      $(selectors.form).trigger('submit');
    }
  
    function handleKeyup(evt) {
      if (evt.keyCode === keys.up_arrow) {
        navigationEvent(evt, 'up');
        return;
      }
  
      if (evt.keyCode === keys.down_arrow) {
        navigationEvent(evt, 'down');
        return;
      }
  
      if (evt.keyCode === keys.tab) {
        return;
      }
  
      search();
    }
  
    function search() {
      var keyword = $(selectors.input, selectors.form).val();
  
      if (keyword === '') {
        reset();
        return;
      }
  
      var q = _normalizeQuery(keyword);
  
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }
  
    function predictQuery(q) {
      if (isLoading) {
        return;
      }
  
      // Do not re-search the same thing
      if (currentString === q) {
        return;
      }
  
      currentString = q;
      isLoading = true;
  
      jQuery.getJSON('/search/suggest.json', {
        "q": q,
        "resources": {
          "type": theme.settings.predictiveSearchType,
          "limit": 4,
          "options": {
            "unavailable_products": "last",
            "fields": "title,product_type,variants.title,vendor"
          }
        }
      }).done(function(response) {
        isLoading = false;
        var data = {};
        var resultCount = 0;
  
        $(selectors.wrapper).removeClass('hide');
  
        var resultTypes = Object.entries(response.resources.results);
  
        for (var i = resultTypes.length - 1; i >= 0; i--) {
          var obj = resultTypes[i];
          var type = obj[0];
          var results = obj[1];
          resultCount += results.length;
  
          switch(type) {
            case 'products':
              data[type] = buildProducts(results);
              break;
            default:
              data[type] = parseResultImages(results);
              break;
          }
        }
  
        if (resultCount === 0) {
          reset();
        }
  
        // Append result markup
        $(selectors.resultDiv).empty().append(resultTemplate(data));
      });
    }
  
    function buildProducts(results) {
      var products = [];
  
      for (var i = results.length - 1; i >= 0; i--) {
        var product = results[i];
  
        var new_product = {
          title: product.title,
          url: product.url,
          image: theme.Images.lazyloadImagePath(product.image),
          vendor: product.vendor,
          price: theme.Currency.formatMoney(product.price),
          compare_price_max: theme.Currency.formatMoney(product.compare_at_price_max),
          on_sale: parseInt(product.compare_at_price_max) > parseInt(product.price),
          custom_label: _checkCustomLabel(product.tags)
        };
  
        products.push(new_product);
      }
  
      return products;
    }
  
    // Overwrite full sized image returned form API
    // with lazyloading-friendly path
    function parseResultImages(results) {
      for (var i = results.length - 1; i >= 0; i--) {
        if (!results[i].image) {
          continue;
        }
  
        var image = theme.Images.lazyloadImagePath(results[i].image);
        results[i].image = image;
      }
  
      return results;
    }
  
    function _checkCustomLabel(tags) {
      if (!tags.length) {
        return false;
      }
  
      for (var i = tags.length - 1; i >= 0; i--) {
        if (tags[i].indexOf('_label_') !== -1) {
          return tags[i].replace('_label_', '');
        }
      }
  
      return false;
    }
  
    function _normalizeQuery(string) {
      if (typeof string !== 'string') {
        return null;
      }
  
      return string
        .trim()
        .replace(/\ /g, '-')
        .toLowerCase();
    }
  
    function navigationEvent(evt, direction) {
  
    }
  
    return {
      init: init
    };
  })();
  
  theme.initQuickShop = function() {
    var ids = [];
    var $buttons = $('.quick-product__btn');
  
    $buttons.each(function() {
      var id = $(this).data('product-id');
      var modalId = 'QuickShopModal-' + id;
      var name = 'quick-modal-' + id;
  
      // If another identical modal exists, remove duplicates
      if (ids.indexOf(id) > -1) {
        $('.modal--quick-shop[data-product-id="'+ id +'"]').each(function(i) {
          if (i > 0) {
            $(this).remove();
          }
        });
        return;
      }
  
      new theme.Modals(modalId, name);
      ids.push(id);
    });
  };
  
  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function() {
    var youtubePlayer = null;
    var videoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        branding: 0,
        cc_load_policy: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      },
      events: {
        onReady: onPlayerReady
      }
    };
  
    var videoHolderId = 'VideoHolder';
    var activeVideo = false;
  
    var selectors = {
      videoHolder: '#' + videoHolderId,
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };
  
    if (!$(selectors.youtube).length && !$(selectors.mp4Trigger).length) {
      return;
    }
  
    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      solid: true
    });
  
    $(selectors.youtube).on('click', triggerYouTubeModal);
    $(selectors.mp4Trigger).on('click', triggerMp4Modal);
  
    // Handle closing video modal
    $('body').on('modalClose.VideoModal', function() {
      // Slight timeout so YouTube player is destroyed after the modal closes
      if (youtubePlayer && activeVideo === 'youtube') {
        setTimeout(function() {
          youtubePlayer.destroy();
        }, 500); // modal close css transition
      } else {
        emptyVideoHolder();
      }
    });
  
    function triggerYouTubeModal(evt) {
      emptyVideoHolder();
  
      evt.preventDefault();
      theme.LibraryLoader.load('youtubeSdk');
  
      if (theme.config.youTubeReady) {
        startYoutubeOnClick(evt);
      } else {
        $('body').on('youTubeReady', function() {
          startYoutubeOnClick(evt);
        });
      }
    }
  
    function triggerMp4Modal(evt) {
      emptyVideoHolder();
  
      var $el = $(evt.currentTarget);
      var $mp4Player = $el.next(selectors.mp4Player);
  
      $mp4Player.clone().removeClass('hide').appendTo(selectors.videoHolder);
  
      modal.open(evt);
  
      // Play new video element
      $(selectors.videoHolder).find('video')[0].play();
  
      activeVideo = 'mp4';
    }
  
    function startYoutubeOnClick(evt) {
      var $el = $(evt.currentTarget);
      var videoId = getYoutubeVideoId($el.attr('href'));
  
      var args = $.extend({}, videoOptions, {
        videoId: videoId
      });
  
      // Disable plays inline on mobile
      args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;
  
      youtubePlayer = new YT.Player(videoHolderId, args);
      modal.open(evt);
  
      activeVideo = 'youtube';
    }
  
    function onPlayerReady(evt) {
      evt.target.playVideo();
    }
  
    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  
    function emptyVideoHolder() {
      $(selectors.videoHolder).empty();
    }
  };
  
  theme.RecentlyViewed = (function() {
    var selectors = {
      template: '#RecentlyViewedProduct',
      outputContainer: '#RecentlyViewed-'
    };
  
    var init = false;
  
    function RecentlyViewed(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      this.namespace = '.recently-viewed' + sectionId;
  
      if (!$(selectors.template).length) {
        return;
      }
  
      // Lazyload API
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(200, this.checkVisibility.bind(this)));
    };
  
    RecentlyViewed.prototype = $.extend({}, RecentlyViewed.prototype, {
      init: function() {
        if (init) {
          return;
        }
  
        init = true;
  
        if ($.isEmptyObject(theme.recentlyViewed.recent)) {
          // No previous history on page load, so bail
          return;
        }
  
        this.outputContainer = $(selectors.outputContainer + this.sectionId);
        this.handle = this.$container.attr('data-product-handle');
  
        // Request new product info via JS API
        var promises = [];
        for (handle in theme.recentlyViewed.recent) {
          promises.push(this.getProductInfo(handle));
        }
  
        Promise.all(promises).then(function(result) {
          this.setupOutput(result);
          this.captureProductDetails(result);
        }.bind(this), function(error) {
          console.warn('Theme | recently viewed products failed to load');
        });
      },
  
      checkVisibility: function() {
        if (theme.isElementVisible(this.$container, 600)) {
          this.init();
          $(window).off('scroll' + this.namespace);
        }
      },
  
      getProductInfo: function(handle) {
        return new Promise(function(resolve, reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve(theme.recentlyViewed.productInfo[handle]);
          } else {
            jQuery.getJSON('/products/'+ handle +'.js', function(product) {
              resolve(product);
            });
          }
        });
      },
  
      setupOutput: function(products) {
        var allProducts = [];
        var data = {};
        var limit = this.$container.attr('data-recent-count');
  
        var i = 0;
        for (key in products) {
          var product = products[key];
          // Ignore current product
          if (product.handle === this.handle) {
            continue;
          }
  
          i++;
  
          // New or formatted properties
          product.url_formatted = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
          product.image_responsive_url = theme.recentlyViewed.recent[product.handle].featuredImage;
          product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;
          product.on_sale = product.compare_at_price > product.price;
          product.sold_out = !product.available;
          product.price_formatted = theme.Currency.formatMoney(product.price, theme.settings.moneyFormat);
          product.compare_at_price_formatted = theme.Currency.formatMoney(product.compare_at_price, theme.settings.moneyFormat);
          product.price_min_formatted = theme.Currency.formatMoney(product.price_min, theme.settings.moneyFormat);
          product.money_saved = theme.Currency.formatMoney((product.compare_at_price - product.price), theme.settings.moneyFormat);
  
          // Unit pricing checks first variant
          var firstVariant = product.variants[0];
          if (firstVariant && firstVariant.unit_price) {
            var baseUnit = '';
  
            if (firstVariant.unit_price_measurement) {
              if (firstVariant.unit_price_measurement.reference_value != 1) {
                baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
              }
              baseUnit += firstVariant.unit_price_measurement.reference_unit;
            }
  
            product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
            if (baseUnit != '') {
              product.unit_price += '/' + baseUnit;
            }
          }
  
          allProducts.unshift(product);
        }
  
        data = {
          items: allProducts.slice(0, limit),
          grid_item_width: this.$container.attr('data-grid-item-class')
        };
  
        if (allProducts.length === 0) {
          return;
        }
  
        // Prep handlebars template
        var source = $(selectors.template).html();
        var template = Handlebars.compile(source);
        this.outputContainer.append(template(data));
  
        if (AOS) {
          AOS.refreshHard();
        }
      },
  
      captureProductDetails: function(products) {
        for (var i = 0; i < products.length; i++) {
          var product = products[i];
          theme.recentlyViewed.productInfo[product.handle] = product;
        }
  
        // Add data to session storage to reduce API requests later
        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
        }
      },
  
      onUnload: function() {
        init = false;
        $('window').off(this.namespace);
      }
    });
  
    return RecentlyViewed;
  })();
  
  theme.parallaxSections = {};
  
  theme.Parallax = (function() {
    var speed = 7; // higher is slower
  
    function parallax(el, args) {
      this.$container = $(el);
      this.namespace = args.namespace;
  
      if (!this.$container.length) {
        return;
      }
  
      if (args.desktopOnly) {
        this.desktopInit();
      } else {
        this.init(this.$container, args)
      }
    }
  
    parallax.prototype = $.extend({}, parallax.prototype, {
      init: function(desktopOnly) {
        var $window = this.$window = $(window);
        var elTop = this.$container.offset().top;
  
        $window.on('scroll' + this.namespace, function(evt) {
          var scrolled = $window.scrollTop();
          var shiftDistance = (elTop - scrolled) / speed;
          this.$container.css({
            'transform': 'translate3d(0, ' + shiftDistance + 'px, 0)'
          });
        }.bind(this));
  
        // Reinit on resize
        $window.on('resize' + this.namespace, $.debounce(350, function() {
          $window.off(this.namespace);
  
          if (desktopOnly) {
            if (!theme.config.bpSmall) {
              this.init(true);
              return;
            }
          }
  
          this.init();
        }.bind(this)));
      },
  
      desktopInit: function() {
        if (!theme.config.bpSmall) {
          this.init(true);
        }
  
        $('body').on('matchSmall', function() {
          this.destroy();
        }.bind(this));
  
        $('body').on('matchLarge', function() {
          this.init(true);
        }.bind(this));
      },
  
      destroy: function() {
        this.$container.removeAttr('style');
        this.$window.off(this.namespace);
      }
    });
  
    return parallax;
  })();
  
  // Select-like popovers for currency and language selection
  theme.Disclosure = (function() {
    var selectors = {
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };
  
    var classes = {
      listVisible: 'disclosure-list--visible'
    };
  
    function Disclosure($disclosure) {
      this.$container = $disclosure;
      this.cache = {};
      this._cacheSelectors();
      this._connectOptions();
      this._connectToggle();
      this._onFocusOut();
    }
  
    Disclosure.prototype = $.extend({}, Disclosure.prototype, {
      _cacheSelectors: function() {
        this.cache = {
          $disclosureList: this.$container.find(selectors.disclosureList),
          $disclosureToggle: this.$container.find(selectors.disclosureToggle),
          $disclosureInput: this.$container.find(selectors.disclosureInput),
          $disclosureOptions: this.$container.find(selectors.disclosureOptions)
        };
      },
  
      _connectToggle: function() {
        this.cache.$disclosureToggle.on(
          'click',
          function(evt) {
            var ariaExpanded =
              $(evt.currentTarget).attr('aria-expanded') === 'true';
            $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);
  
            this.cache.$disclosureList.toggleClass(classes.listVisible);
          }.bind(this)
        );
      },
  
      _connectOptions: function() {
        this.cache.$disclosureOptions.on(
          'click',
          function(evt) {
            evt.preventDefault();
            this._submitForm($(evt.currentTarget).data('value'));
          }.bind(this)
        );
      },
  
      _onFocusOut: function() {
        this.cache.$disclosureToggle.on(
          'focusout',
          function(evt) {
            var disclosureLostFocus =
              this.$container.has(evt.relatedTarget).length === 0;
  
            if (disclosureLostFocus) {
              this._hideList();
            }
          }.bind(this)
        );
  
        this.cache.$disclosureList.on(
          'focusout',
          function(evt) {
            var childInFocus =
              $(evt.currentTarget).has(evt.relatedTarget).length > 0;
            var isVisible = this.cache.$disclosureList.hasClass(
              classes.listVisible
            );
  
            if (isVisible && !childInFocus) {
              this._hideList();
            }
          }.bind(this)
        );
  
        this.$container.on(
          'keyup',
          function(evt) {
            if (evt.which !== 27) return;
            this._hideList();
            this.cache.$disclosureToggle.focus();
          }.bind(this)
        );
  
        $('body').on(
          'click',
          function(evt) {
            var isOption = this.$container.has(evt.target).length > 0;
            var isVisible = this.cache.$disclosureList.hasClass(
              classes.listVisible
            );
  
            if (isVisible && !isOption) {
              this._hideList();
            }
          }.bind(this)
        );
      },
  
      _submitForm: function(value) {
        $('body').addClass('unloading');
        this.cache.$disclosureInput.val(value);
        this.$container.parents('form').submit();
      },
  
      _hideList: function() {
        this.cache.$disclosureList.removeClass(classes.listVisible);
        this.cache.$disclosureToggle.attr('aria-expanded', false);
      },
  
      unload: function() {
        this.cache.$disclosureOptions.off();
        this.cache.$disclosureToggle.off();
        this.cache.$disclosureList.off();
        this.$container.off();
      }
    });
  
    return Disclosure;
  })();
  
  theme.ProductMedia = (function() {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};
  
    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };
  
    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };
  
      modelViewerContainers.each(function(index) {
        var $modelViewerContainer = $(this);
        var mediaId = $modelViewerContainer.data('media-id');
        var $modelViewerElement = $(
          $modelViewerContainer.find('model-viewer')[0]
        );
        var modelId = $modelViewerElement.data('model-id');
  
        if (index === 0) {
          var $xrButton = $modelViewerContainer
            .closest(selectors.mediaGroup)
            .find(selectors.xrButton);
          xrButtons[sectionId] = {
            $element: $xrButton,
            defaultId: modelId
          };
        }
  
        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          $container: $modelViewerContainer,
          $element: $modelViewerElement
        };
      });
  
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);
  
      theme.LibraryLoader.load('modelViewerUiStyles');
    }
  
    function setupShopifyXr(errors) {
      if (errors) return;
  
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function() {
          setupShopifyXr();
        });
        return;
      }
  
      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];
  
          if (modelSection.loaded) continue;
          var $modelJson = $('#ModelJson-' + sectionId);
  
          window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }
  
    function setupModelViewerUi(errors) {
      if (errors) return;
  
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
          }
          setupModelViewerListeners(model);
        }
      }
    }
  
    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];
      model.$container.on('mediaVisible', function() {
        xrButton.$element.attr('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });
  
      model.$container
        .on('mediaHidden', function() {
          xrButton.$element.attr('data-shopify-model3d-id', xrButton.defaultId);
          model.modelViewerUi.pause();
        })
        .on('xrLaunch', function() {
          model.modelViewerUi.pause();
        });
    }
  
    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }
  
    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();
  

  theme.collectionTemplate = (function() {
    var isAnimating = false;
  
    var selectors = {
      collectionGrid: '.collection-grid__wrapper',
      sidebar: '#CollectionSidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list a',
      filters: '.collection-filter'
    };
  
    var settings = {
      combineTags: $(selectors.sidebar).data('combine-tags')
    };
  
    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove'
    };
  
    function init() {
      // Ajax pagination
      $(window).on('popstate', function(state) {
        if (state) {
          getNewCollectionContent(location.href);
        }
      });
  
      // Set mobile top value for filters if sticky header enabled
      if (theme.config.stickyHeader) {
        setFilterStickyPosition();
        $(window).on('resize', $.debounce(150, setFilterStickyPosition));
      }
  
      initTagClicks();
    }
  
    function initTagClicks() {
      $('body').on('click', selectors.tags, function(evt) {
        var $el = $(this);
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
  
        if ($el.hasClass('no-ajax')) {
          return;
        }
  
        evt.preventDefault();
        if (isAnimating) {
          return;
        }
  
        isAnimating = true;
  
        var $el = $(evt.currentTarget);
        var $parent = $el.parent();
        var newUrl = $el.attr('href');
  
        if (settings.combineTags) {
          if ($parent.hasClass(classes.activeTag)) {
            $parent.removeClass(classes.activeTag);
          } else {
            $parent.addClass(classes.activeTag);
  
            // If adding a tag, show new tag right away.
            // Otherwise, remove it before ajax finishes
            if ($el.parent('li').hasClass(classes.removeTagParent)) {
              $(this).parent().remove();
            } else {
              $(selectors.activeTagList).append('<li class="tag tag--remove"><a class="btn btn--small js-no-transition">' + $el.text() + '</a></li>');
            }
          }
        } else {
          $(selectors.tags).parent().removeClass(classes.activeTag);
          $parent.addClass(classes.activeTag);
        }
  
        updateScroll(true);
  
        history.pushState({}, '', newUrl);
        $(selectors.collectionGrid).addClass('unload');
        getNewCollectionContent(newUrl);
      });
    }
  
    function updateScroll(animate) {
      var scrollTo;
      if (theme.config.bpSmall) {
        // 60 is ~ height of sticky filters
        scrollTo = $('[data-scroll-to]').offset().top - 60;
      } else {
        scrollTo = $('#CollectionAjaxResult').offset().top + 1;
      }
  
      if (theme.config.stickyHeader) {
        var heightOfStickyNav = $('.site-header').outerHeight(true);
        scrollTo = scrollTo - heightOfStickyNav;
      }
  
      if (animate) {
        $('html, body').animate({ scrollTop: scrollTo }, 300);
      } else {
        $('html, body').scrollTop(scrollTo);
      }
    }
  
    function setFilterStickyPosition() {
      var headerHeight = $('.site-header').outerHeight(true);
      $(selectors.filters).css('top', headerHeight + 10);
    }
  
    function getNewCollectionContent(url) {
      url = url + '?view=ajax';
      $('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent', function() {
        isAnimating = false;
        theme.reinitSection('collection-template');
        theme.collectionTemplate.reinit();
      }.bind(this));
    }
  
    function reinit() {
      settings.combineTags = $(selectors.sidebar).data('combine-tags');
  
      updateScroll(false);
  
      // Setup page transition classes
      theme.pageTransitions();
  
      theme.reinitProductGridItem();
  
      // Trigger resize for sticky sidebar styles to update
      $('body').trigger('resize');
    }
  
    return {
      init: init,
      reinit: reinit
    };
  })();
  
  theme.customerTemplates = (function() {
  
    function initEventListeners() {
      // Show reset password form
      $('#RecoverPassword').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
  
      // Hide reset password form
      $('#HideRecoverPasswordLink').on('click', function(evt) {
        evt.preventDefault();
        toggleRecoverPasswordForm();
      });
    }
  
    /**
     *
     *  Show/Hide recover password form
     *
     */
    function toggleRecoverPasswordForm() {
      $('#RecoverPasswordForms').toggleClass('hide');
      $('#CustomerLoginForms').toggleClass('hide');
    }
  
    /**
     *
     *  Show reset password success message
     *
     */
    function resetPasswordSuccess() {
      var $formState = $('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!$formState.length) {
        return;
      }
  
      // show success message
      $('#ResetSuccess').removeClass('hide');
    }
  
    /**
     *
     *  Show/hide customer address forms
     *
     */
    function customerAddressForm() {
      var $newAddressForm = $('#AddressNewForm');
      var $addressForms = $('.js-address-form');
  
      if (!$newAddressForm.length || !$addressForms.length) {
        return;
      }
  
      if (Shopify) {
        $('.js-address-country').each(function() {
          var $container = $(this);
          var countryId = $container.data('country-id');
          var provinceId = $container.data('province-id');
          var provinceContainerId = $container.data('province-container-id');
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }
  
      // Toggle new/edit address forms
      $('.address-new-toggle').on('click', function() {
        $newAddressForm.toggleClass('hide');
        $newAddressForm.find('.modal').toggleClass('modal--is-active')
      });
      
      $('.address_div_close').on('click', function() {
        $(this).parent().parent().parent().toggleClass('modal--is-active');
        $(this).parent().parent().parent().parent().toggleClass('hide');
      });
  
      $('.address-edit-toggle').on('click', function() {
        var formId = $(this).data('form-id');
        $('#EditAddress_' + formId).toggleClass('hide');
        //gqx add
        $('#EditAddress_' + formId).find('.modal').toggleClass('modal--is-active');
      });
      
      
  
      $('.address-delete').on('click', function() {
        var $el = $(this);
        var formId = $el.data('form-id');
        var confirmMessage = $el.data('confirm-message');
  
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
          Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
        }
      });
    }
  
    /**
     *
     *  Check URL for reset password hash
     *
     */
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    return {
      init: function() {
        checkUrlHash();
        initEventListeners();
        resetPasswordSuccess();
        customerAddressForm();
      }
    };
  })();
  

  theme.Product = (function() {
  
    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible',
      optionAction:"option_action"
    };
  
    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      currentSlide: '.slick-current',
      startingSlide: '.starting-slide'
    };
  
    var youtubeReady;
    var videos = {};
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      height: '480',
      width: '850',
      playerVars :{
        autohide: 0,
        autoplay: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      }
    };
  
    function onVideoPlayerReady(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
      if (videos[playerId].style === 'muted') {
        youtubePlayers[playerId].mute();
      } else {
        setParentAsLoaded($player);
      }
  
      // If first slide or only photo, start video
      if ($player.closest(selectors.startingSlide).length || $player.data('image-count') === 1) {
        if (videos[playerId].style === 'muted') {
          youtubePlayers[playerId].playVideo();
          initCheckVisibility(playerId);
        }
      }
    }
  
    function initCheckVisibility(playerId) {
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
    }
  
    function videoVisibilityCheck(id) {
      var playerId;
  
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        if (!id.data) {return}
        playerId = id.data.id;
      }
  
      if (theme.isElementVisible($('#' + playerId))) {
        if (videos[playerId] && videos[playerId].style === 'unmuted') {
          return;
        }
        playVisibleVideo(playerId);
      } else {
        pauseHiddenVideo(playerId);
      }
    }
  
    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }
  
    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }
  
    function onVideoStateChange(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];
  
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          if (videos[playerId] && videos[playerId].loop) {
            player.playVideo();
          }
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }
  
    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }
  
    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }
  
    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }
    
    function isInitialized($slider) {
      return $slider.length && $slider.hasClass('slick-initialized');
    }
  
    function Product(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
  
      this.inModal = $container.closest('.modal').length;
      this.$modal;
  
      this.settings = {
        enableHistoryState: $container.data('enable-history-state') || false,
        namespace: '.product-' + sectionId,
        inventory: $container.data('inventory') || false,
        incomingInventory: $container.data('incoming-inventory') || false,
        modalInit: false,
        slickMainInitialized: false,
        slickThumbInitialized: false,
        thumbArrows: false,
        thumbVertical: false,
        hasImages: true,
        hasMultipleImages: false,
        has3d: false,
        imageSize: '620x',
        videoLooping: $container.data('video-looping')
      };
  
      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.$modal = $('#QuickShopModal-' + sectionId);
      }
  
      this.selectors = {
        variantsJson: 'VariantsJson-' + sectionId,
        currentVariantJson: 'CurrentVariantJson-' + sectionId,
  
        video: 'ProductVideo-' + sectionId,
        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '.product__thumb-' + sectionId,
        thumbSlider: '#ProductThumbs-' + sectionId,
        mainSlider: '#ProductPhotos-' + sectionId,
        imageContainer: '[data-product-images]',
        productImageMain: '.product-image-main--' + sectionId,
        dotsContainer: '.product__photo-dots--' + sectionId,
  
        priceWrapper: '.product__price-wrap-' + sectionId,
        price: '.ProductPrice-' + sectionId,
        comparePrice: '.ComparePrice-' + sectionId,
        savePrice: '#SavePrice-' + sectionId,
        eachPrice: '#EachPrice-' + sectionId,
        priceA11y: '#PriceA11y-' + sectionId,
        comparePriceA11y: '#ComparePriceA11y-' + sectionId,
        unitWrapper: '.product__unit-price-wrapper--' + sectionId,
        unitPrice: '.product__unit-price--' + sectionId,
        unitPriceBaseUnit: '.product__unit-base--' + sectionId,
        sku: '#Sku-' + sectionId,
        inventory: '#ProductInventory-' + sectionId,
        incomingInventory: '#ProductIncomingInventory-' + sectionId,
  
        addToCart: '#AddToCart-' + sectionId,
        addToCartText: '#AddToCartText-' + sectionId,
  
        originalSelectorId: '#ProductSelect-' + sectionId,
        singleOptionSelector: '.variant__input-' + sectionId,
        variantColorSwatch: '.variant__input--color-swatch-' + sectionId,
        variantSizeSwatch: '.variant__input--size-swatch-' + sectionId,
  
        modalFormHolder: '#ProductFormHolder-' + sectionId,
        formContainer: '#AddToCartForm-' + sectionId,
        pricePoint: '.product_point_box_'+ sectionId + ' .product_points' ,
        totalPrice: '.total_'+ sectionId,
        qtyInput:"input[name='quantity']",
        sizeGuidBtn:".size_divs-box .size_click",
      };
  
      this.$mainSlider = $(this.selectors.mainSlider);
      this.$thumbSlider = $(this.selectors.thumbSlider);
      this.$firstProductImage = this.$mainSlider.find('img').first();
      
      this.$mainSliderHtml = this.$mainSlider.html();  //存储数据用
      this.isSizeUpdateImg = false; // 判断是否根据size 切换图片
  
      if (!this.$firstProductImage.length) {
        this.settings.hasImages = false;
      }
  
      this.init();
    }
  	
    Product.prototype = $.extend({}, Product.prototype, {
      init: function() {
        var that = this;
        if (this.inModal) {
          this.$container.addClass(classes.isModal);
          $('body')
            .off('modalOpen.QuickShopModal-' + this.sectionId)
            .off('modalClose.QuickShopModal-' + this.sectionId);
          $('body').on('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
          $('body').on('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
        }
        
        // 判断是否根据size 切换图片 黄康 2021-07-13
        if(this.$thumbSlider.find(".product__thumb-item[data-size!='']").length)
          	this.isSizeUpdateImg = true;
  
        if (!this.inModal) {
          this.stringOverrides();
          this.formSetup();
          this.productSetup();
  
          this.checkIfVideos();
          this.createImageCarousels();
          this.customMediaListners();
          this.isProduct()
          //暂时关闭产品页轮播
          //this.ProductCodeSlick()
          this.sizeGuide()
  
          // Add product id to recently viewed array
          this.addIdToRecentlyViewed();
          // 
          this.updateProductImgLoad();
          $(window).resize(function(){
              that.updateProductImgLoad();
          })
          
          this.setProductSuspensionNav();
          $(window).scroll(function(){
              that.setProductSuspensionNav();
          })
        }
      },
      
      
      
      //产品折扣信息轮播事件
      ProductCodeSlick:function(){
         var Slick = $('.wm_pro_saleinfo .wm_pro_saleinfo-box')
         function ProductSlick(Slick){
           Slick.slick({
             arrows: false,
             autoplaySpeed: 4000,
             slidesToShow:1,
             slidesToScroll:1,
             autoplay:true,
             draggable:true,
             dots:false,
             vertical:true,
             verticalSwiping:true,
           })
         }
         ProductSlick(Slick)
      },
      //判断产品是否满足某些折扣条件
      isProduct:function(){
        var PrductUrl =  getUrlParam("product_code")
        if(PrductUrl){
          var PrductCodeDom = `<input type="hidden" name="discount-code" value="${PrductUrl}">`
          $('.quick_foem_false .product-single__form').prepend(PrductCodeDom)
        }   
      },
      // size guide
      sizeGuide:function(){
        var formContainer = $(this.selectors.formContainer)
        var that = this;
      	// 关闭按钮
		formContainer.find('.content-size-guide .close,.size-guide-box').click(function(){
			var ContentSizeTotalGuide = formContainer.find(".size-guide-total-box");
			ContentSizeTotalGuide.removeClass("is_active");
	    })
	    // 打开按钮
	    formContainer.find(this.selectors.sizeGuidBtn).click(function(){
		   var ContentSizeTotalGuide = formContainer.find(".size-guide-total-box");
           ContentSizeTotalGuide.addClass("is_active");
		   ContentSizeTotalGuide.find(".content-size-guide .top p").removeClass("active").eq(0).click();
           ContentSizeTotalGuide.find(".image").addClass("aos-init aos-animate");
        })
		// 展示 tab 切换
		formContainer.find(".content-size-guide .top p").click(function(){
		 	var index = $(this).index();
			$(this).parent().find("p").removeClass("active");
			$(this).addClass("active");
			var bottom = $(this).parents(".content-size-guide").find(".bottom");
			bottom.find(".tab").css("display","none").eq(index).css("display","block")
		})
		// 单位切换
		formContainer.find(".lump").click(function(){
		 	var bottom = $(this).parents(".bottom");
			var index = bottom.find(".button span.text-color").index();
			index = index == 0 ? 0 : 1;
			var nextIndex = index + 1 
			nextIndex = nextIndex % 2
			bottom.find(".button span").removeClass("text-color").eq(nextIndex).addClass("text-color"); 
            nextIndex ? bottom.find(".color").addClass("slide") : bottom.find(".color").removeClass("slide");
            // tab 方向和按钮是反的 md
            nextIndex = nextIndex ? 0 : 1
			nextIndex ? bottom.addClass("bottom-1") : bottom.removeClass("bottom-1");
			bottom.find(".tab .size-table").css("display","none").eq(nextIndex).css("display","block")
			if(bottom.find(".tab .size-table").eq(nextIndex).find(".metatitle").length > 0)
				bottom.find(".tab .size-table").eq(nextIndex).find(".metatitle button.colorblack").click();
		})
		// 情侣睡衣 tab切换
		formContainer.find(".metatitle button").click(function(){
			var bottom  = $(this).parents(".bottom")
			var index = $(this).index();
			$.each(bottom.find(".size-table"),function(){
				$(this).find(".metatitle button").removeClass("colorblack").eq(index).addClass("colorblack");
				$(this).find(".size-guide-table").hide().eq(index).show();
			})
			return false;
		})
      },
      // 图片展示模式
      isImageStyleNew:function(){
      	
        // 模式切换 单颜色模式 黄康 2021-04-25
        if(this.$mainSlider.attr("data-color-style-new") !== "false")
          return true;
      	return false;
      },
  
      formSetup: function() {
        // Determine how to handle variant availability selectors
        if (theme.settings.dynamicVariantsEnable) {
          this.$variantSelectors = $(this.selectors.formContainer).find(this.selectors.singleOptionSelector);
        }
  
        this.initQtySelector();
        this.initAjaxProductForm();
        this.initVariants();
      },
  
      productSetup: function() {
        this.setImageSizes();
        this.initImageSwitch();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();
      },
  
      addIdToRecentlyViewed: function() {
        var handle = this.$container.attr('data-product-handle');
        var url = this.$container.attr('data-product-url');
        var aspectRatio = this.$container.attr('data-aspect-ratio');
        var featuredImage = this.$container.attr('data-img-url');
  
        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }
  
        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage
        };
  
        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }
      },
  
      stringOverrides: function() {
        theme.productStrings = theme.productStrings || {};
        $.extend(theme.strings, theme.productStrings);
      },
  
      initVariants: function() {
        if (!document.getElementById(this.selectors.variantsJson)) {
          return;
        }
  
        this.variantsObject = JSON.parse(document.getElementById(this.selectors.variantsJson).innerHTML);
  
        var options = {
          $container: this.$container,
          namespace: this.settings.namespace,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject
        };
  
        if ($(this.selectors.variantColorSwatch).length) {
          $(this.selectors.variantColorSwatch).on('change', function(evt) {
            var $el = $(evt.currentTarget);
            var color = $el.data('color-name');
            var index = $el.data('color-index');
            this.updateColorName(color, index);
          }.bind(this));
        }
  		
        // size点击事件
        if ($(this.selectors.variantSizeSwatch).length ) {
          $(this.selectors.variantSizeSwatch).on('change', function(evt) {
            var $el = $(evt.currentTarget);
            var size = $el.data('size-name');
            var index = $el.data('size-index');
            this.updateSizeAction(size, index);
          }.bind(this));
        }
        // 产品属性 鼠标经过
        this.optionHover();
        
        this.variants = new theme.Variants(options);
  
        this.$container
          .on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this))
          .on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this))
          .on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this))
          .on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));
  
        if ($(this.selectors.sku).length) {
          this.$container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }
        if (this.settings.inventory || this.settings.incomingInventory) {
          this.$container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }
  
        // Update individual variant availability on each selection
        if (theme.settings.dynamicVariantsEnable && document.getElementById(this.selectors.currentVariantJson)) {
          this.currentVariantObject = JSON.parse(document.getElementById(this.selectors.currentVariantJson).innerHTML);
  
          this.$variantSelectors.on('change' + this.settings.namespace, this.updateVariantAvailability.bind(this));
  
          // Set default state based on current selected variant
          this.setCurrentVariantAvailability(this.currentVariantObject, true);
        }
      },
  
      initQtySelector: function() {
        this.$container.find('.js-qty__wrapper').each(function() {
          new theme.QtySelector($(this), {
            namespace: '.product'
          });
        });
      },
  
      initAjaxProductForm: function() {
        if (theme.settings.cartType === 'drawer') {
          new theme.AjaxProduct($(this.selectors.formContainer));
        }
      },
  
      /*============================================================================
        Dynamic variant availability
          - To disable, set dynamicVariantsEnable to false in theme.liquid
      ==============================================================================*/
      setCurrentVariantAvailability: function(variant) {
        var valuesToEnable = {
          option1: [],
          option2: [],
          option3: []
        };
  
        // Disable all options to start
        this.disableVariantGroup($(this.selectors.formContainer).find('.variant-input-wrap'));
  
        // Combine all available variants
        var availableVariants = this.variantsObject.filter(function(el) {
          if (variant.id === el.id) {
            return false;
          }
  
          // Option 1
          if (variant.option2 === el.option2 && variant.option3 === el.option3) {
            return true;
          }
  
          // Option 2
          if (variant.option1 === el.option1 && variant.option3 === el.option3) {
            return true;
          }
  
          // Option 3
          if (variant.option1 === el.option1 && variant.option2 === el.option2) {
            return true;
          }
        });
  
  
        // IE11 can't handle shortform of {variant} so extra step is needed
        var variantObject = {
          variant: variant
        };
  
        availableVariants = Object.assign({}, variantObject, availableVariants);
  
        // Loop through each available variant to gather variant values
        for (var property in availableVariants) {
          if (availableVariants.hasOwnProperty(property)) {
            var item = availableVariants[property];
            var option1 = item.option1;
            var option2 = item.option2;
            var option3 = item.option3;
  
            if (option1) {
              if (valuesToEnable.option1.indexOf(option1) === -1) {
                valuesToEnable.option1.push(option1);
              }
            }
            if (option2) {
              if (valuesToEnable.option2.indexOf(option2) === -1) {
                valuesToEnable.option2.push(option2);
              }
            }
            if (option3) {
              if (valuesToEnable.option3.indexOf(option3) === -1) {
                valuesToEnable.option3.push(option3);
              }
            }
          }
        }
  
        // Have values to enable, separated by option index
        if (valuesToEnable.option1.length) {
          this.enableVariantOptionByValue(valuesToEnable.option1, 'option1');
        }
        if (valuesToEnable.option2.length) {
          this.enableVariantOptionByValue(valuesToEnable.option2, 'option2');
        }
        if (valuesToEnable.option3.length) {
          this.enableVariantOptionByValue(valuesToEnable.option3, 'option3');
        }
      },
  
      updateVariantAvailability: function(evt, value, index) {
        if (value && index) {
          var newVal = value;
          var optionIndex = index;
        } else {
          var $el = $(evt.currentTarget);
          var newVal = $el.val() ? $el.val() : evt.currentTarget.value;
          var optionIndex = $el.data('index');
        }
  
        var variants = this.variantsObject.filter(function(el) {
          return el[optionIndex] === newVal;
        });
  
        // Disable all buttons/dropdown options that aren't the current index
        $(this.selectors.formContainer).find('.variant-input-wrap').each(function(index, el) {
          var $group = $(el);
          var currentOptionIndex = $group.data('index');
  
          if (currentOptionIndex !== optionIndex) {
            // Disable all options as a starting point
            this.disableVariantGroup($group);
  
            // Loop through legit available options and enable
            for (var i = 0; i < variants.length; i++) {
              this.enableVariantOption($group, variants[i][currentOptionIndex]);
            }
          }
        }.bind(this));
      },
  
      disableVariantGroup: function($group) {
        if (theme.settings.dynamicVariantType === 'dropdown') {
          $group.find('option').prop('disabled', true)
        } else {
          $group.find('input').prop('disabled', true);
          $group.find('label').toggleClass('disabled', true);
        }
      },
  
      enableVariantOptionByValue: function(array, index) {
        var $group = $(this.selectors.formContainer).find('.variant-input-wrap[data-index="'+ index +'"]');
  
        for (var i = 0; i < array.length; i++) {
          this.enableVariantOption($group, array[i]);
        }
      },
  
      enableVariantOption: function($group, value) {
        // Selecting by value so escape it
        value = value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
  
        if (theme.settings.dynamicVariantType === 'dropdown') {
          $group.find('option[value="'+ value +'"]').prop('disabled', false);
        } else {
          var $buttonGroup = $group.find('.variant-input[data-value="'+ value +'"]');
          $buttonGroup.find('input').prop('disabled', false);
          $buttonGroup.find('label').toggleClass('disabled', false);
        }
      },
  
      /*============================================================================
        Variant change methods
      ==============================================================================*/
      // 点击切换颜色
      updateSizeAction:function(size,index){
      	
        if(!this.isSizeUpdateImg)
          	return false;
        this.updateColorSmallImg(false,true);
      },
      updateColorName: function(color, index) {
        // Updates on radio button change, not variant.js
        if( color.indexOf("-preorder") != -1 ){
           // 2021-03-18 
           var pre_order_day = "15 days";
           if($("#AddToCartForm-"+this.id).find(".pre-order-day").attr("data-day"))
          		pre_order_day = $("#AddToCartForm-"+this.id).find(".pre-order-day").attr("data-day"); 
          
        	$('#VariantColorLabel-' + this.sectionId + '-' + index).html(color.replace('-preorder','')+'<span class="pre-text">(*Pre-order. Ship in '+pre_order_day+')</span>');
        	$('#is-pre').html('<div class="preorder disflex"><div class="preorder_image"><img src="https://cdn.shopify.com/s/files/1/1873/0299/files/pre-order_674914eb-50f1-4107-aec2-00f768b222c4.svg?v=1617329947" alt="pre order"></div><div class="preorder_title">Pre-order Ship in '+pre_order_day+'.</div></div>');
        }else{
        	$('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
          	$('#is-pre').html('')
        }
        this.updateColorSmallImg(color);
      },
      // 更改颜色图片
      updateColorSmallImg:function(color,is_size)
      {
        if(!color)
          color = $(this.selectors.variantColorSwatch+":checked").data('color-name');
		var size = false;
        if( $(this.selectors.variantSizeSwatch).length && this.isSizeUpdateImg)
          size = $(this.selectors.variantSizeSwatch+":checked").data('size-name');
 
        var productMainPhotos = this.$container.find(".product__photos .product__main-photos");
		var productPhotos = this.$container.find(".product__photos");
        
         // 防止没有颜色的 但是size图片不同的情况 黄康 2021-09-09   2021-09-18 再次优化
        if(!color && size)
        {
          	// 判断是否有颜色多余的图片列表
          	if(!color)
            {
              if(productMainPhotos.find(".ProductPhotos-content[data-color='']").length <= 0)
              	color = size;
              else
                color = ""
            }
        }
        
        if(is_size)
        {
          var productMainPhotosOriginal = $("<div>"+this.$mainSliderHtml+"</div>");
          
          var neqSizeImgNum = productMainPhotos.find(".ProductPhotos-content[data-color='"+color+"'] .product-img-color-slide[data-size!='"+size+"']").length;
          var airSizeImgNum = productMainPhotos.find(".ProductPhotos-content[data-color='"+color+"'] .product-img-color-slide[data-size='']").length;
          var sizeImgNum = productMainPhotos.find(".ProductPhotos-content[data-color='"+color+"'] .product-img-color-slide[data-size='"+size+"']").length;
          var sizeImgNumOrg = productMainPhotosOriginal.find(".ProductPhotos-content[data-color='"+color+"'] .product-img-color-slide[data-size='"+size+"']").length;
          
          //console.log(neqSizeImgNum,airSizeImgNum,sizeImgNum,sizeImgNumOrg);
          if((neqSizeImgNum - airSizeImgNum) == 0 && (sizeImgNumOrg == sizeImgNum))  
          	return false;
        }
          
        // 模式切换 单颜色模式 黄康 2021-04-25
        if(this.isImageStyleNew())
        {
          productMainPhotos.find(".ProductPhotos-content").css({"display":"none"}).removeClass("ProductPhotos-content-active");
          productMainPhotos.find(".ProductPhotos-content[data-color='"+color+"']").css({"display":"block"}).addClass("ProductPhotos-content-active");
		  
          var sliderArgs = this.setSliderArgs();
          this.initColorNewSliders(sliderArgs); 
          
          
          if(!theme.config.bpSmall)
          {
           	var sliderArgs = this.setSliderArgs(); 
            if(isInitialized(this.$thumbSlider))
              	this.$thumbSlider.slick("unslick")
                
            this.$thumbSlider.slick(sliderArgs.thumbs);
            
          }
          productPhotos.find(".product__thumbs .slick-track").css({"transform":"translate3d(0px, 0px, 0px)"});
		  if(size)
		  	productPhotos.find(".product__thumb-item[data-color='"+color+"'][data-size=''],.product__thumb-item[data-color='"+color+"'][data-size='"+size+"']").eq(0).addClass("slick-current").click();
		  else
          	productPhotos.find(".product__thumb-item[data-color='"+color+"']").eq(0).addClass("slick-current").click();
        }
        
        productPhotos.find(".product__thumb-item").css({"display":"none"});
		productPhotos.find(".product__thumb-item[data-color='"+color+"']").css({"display":"block"}); 
		if(size)
		{
			productPhotos.find(".product__thumb-item[data-color='"+color+"']").css({"display":"none"}); 
			productPhotos.find(".product__thumb-item[data-color='"+color+"'][data-size=''],.product__thumb-item[data-color='"+color+"'][data-size='"+size+"']").css({"display":"block"});   
		}
        this.updateProductImgLoad();
      },
      /* 优化 产品图片展示   jq图片load 有时候会出现问题  导致 class未及时更换*/
      updateProductImgLoad:function(){
      	var photoActive = this.$container.find(".ProductPhotos-content-active");
		$.each(photoActive.find(".lazyautosizes.lazyloading"),function(k,v){
			$(this).on("load",function(){
				$(this).removeClass("lazyloading").addClass("lazyloaded");
			})
		})
      	setTimeout(function(){
			$.each(photoActive.find(".lazyautosizes.lazyloading"),function(k,v){
				$(this).removeClass("lazyloading").addClass("lazyloaded");
			})
			
		},1000)
      },
      updateCartButton: function(evt) {
        var variant = evt.variant;
  
        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            $(this.selectors.addToCart).removeClass(classes.disabled).prop('disabled', false);
            $(this.selectors.addToCartText).html(theme.strings.addToCart +' - '+ theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat));
          } else {
            // Sold out, disable the submit button and change text
            $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
            $(this.selectors.addToCartText).html(theme.strings.soldOut);
          }
        } else {
          // The variant doesn't exist, disable submit button
          $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.unavailable);
        }
      },
  
      updatePrice: function(evt) {
        var variant = evt.variant;

        var num = this.$container.find(this.selectors.qtyInput).val();
        if(!num){
          num = 1
        }
        var numPrice = variant.price * num;
        var numCompareAtPrice = variant.compare_at_price * num;
        
        if (variant) {
          // Regular price
          $(this.selectors.price).html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat)).show();
  
          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat));
            $(this.selectors.priceWrapper).removeClass('hide');
            $(this.selectors.price).addClass(classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
            $(this.selectors.priceA11y).attr('aria-hidden', 'false');
  
            var savings = variant.compare_at_price - variant.price;
  
            if (theme.settings.saveType == 'percent') {
              savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
            } else {
              savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
            }
  
            $(this.selectors.savePrice).html(theme.strings.savePrice.replace('[saved_amount]', savings));
          } else {
            $(this.selectors.priceWrapper).addClass('hide');
            $(this.selectors.price).removeClass(classes.onSale);
            $(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
            $(this.selectors.priceA11y).attr('aria-hidden', 'true');
          }
          
          
          if((this.$container.attr("data-product-sku-qty-option") && parseInt(variant[this.$container.attr("data-product-sku-qty-option")]) > 1))
          {	
          		var eachPrice = theme.Currency.formatMoney(Math.round(variant.price/ variant[this.$container.attr("data-product-sku-qty-option")],2),theme.settings.moneyFormat);
            	$(this.selectors.savePrice).parents(".price_save").addClass('hide');
            	$(this.selectors.eachPrice).html(eachPrice).parents(".price_each").removeClass('hide');
          }
          else
          {
            var eachPrice = theme.Currency.formatMoney(Math.round(variant.price/ this.$container.attr("data-product-sku-num"),2), theme.settings.moneyFormat);
            if( this.$container.attr("data-product-sku-num") > 1)
            {
              	$(this.selectors.savePrice).parents(".price_save").addClass('hide');
            	$(this.selectors.eachPrice).html(eachPrice).parents(".price_each").removeClass('hide');
            }
            else
            {
              	$(this.selectors.savePrice).parents(".price_save").removeClass('hide');
              	$(this.selectors.eachPrice).html(eachPrice).parents(".price_each").addClass('hide');
            }
          }
    
          
          if($(this.selectors.pricePoint).length > 0)
          {
            var productPoints = getPricePoints(numPrice);
            $(this.selectors.pricePoint).html(productPoints)
          }
      	  this.$container.find(this.selectors.totalPrice).find('.total_price').html(theme.Currency.formatMoney(numPrice, theme.settings.moneyFormat))
      
      	  new theme.PriceCurrency()    
          
        }
      },
  
      updateUnitPrice: function(evt) {
        var variant = evt.variant;
  
        if (variant && variant.unit_price) {
          $(this.selectors.unitPrice).html(theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat));
          $(this.selectors.unitPriceBaseUnit).text(theme.Currency.getBaseUnit(variant));
          $(this.selectors.unitWrapper).removeClass('hide').removeClass(classes.visuallyHide);
        } else {
          $(this.selectors.unitWrapper).addClass(classes.visuallyHide);
        }
      },
  
      updateSku: function(evt) {
        var variant = evt.variant;
        var newSku = '';
  
        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }
  
          $(this.selectors.sku).html(newSku);
        }
      },
  
      updateInventory: function(evt) {
        var variant = evt.variant;
  
        // If we don't track variant inventory, hide stock
        if (!variant || !variant.inventory_management) {
          this.toggleInventoryQuantity(false);
          this.toggleIncomingInventory(false);
          return;
        }
  
        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.sectionId]) {
          variantInventoryObject = window.inventories[this.sectionId][variant.id];
          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;
  
          if (quantity <= 0 || quantity > theme.settings.inventoryThreshold) {
            showInventory = false;
          }
  
          this.toggleInventoryQuantity(showInventory, quantity);
  
          if (!showInventory && variantInventoryObject.incoming) {
            showIncomingInventory = true;
          }
  
          this.toggleIncomingInventory(showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date);
        }
      },
  
      toggleInventoryQuantity: function(show, qty) {
        if (!this.settings.inventory) {
          show = false;
        }
  
        if (show) {
          $(this.selectors.inventory)
            .removeClass('hide')
            .text(theme.strings.stockLabel.replace('[count]', qty));
        } else {
          $(this.selectors.inventory).addClass('hide');
        }
      },
  
      toggleIncomingInventory: function(show, available, date) {
        if (!this.settings.incomingInventory) {
          show = false;
        }
  
        if (show) {
          var string = available ?
                       theme.strings.willNotShipUntil.replace('[date]', date) :
                       theme.strings.willBeInStockAfter.replace('[date]', date);
  
          if (!date) {
            string = theme.strings.waitingForStock;
          }
  
          $(this.selectors.incomingInventory)
            .removeClass('hide')
            .text(string);
        } else {
          $(this.selectors.incomingInventory).addClass('hide');
        }
      },
  
      /*============================================================================
        Product videos
      ==============================================================================*/
      checkIfVideos: function() {
        var $productVideos = this.$mainSlider.find(selectors.productVideo);
  
        // Stop if there are 0 videos
        if (!$productVideos.length) {
          return false;
        }
  
        var videoTypes = [];
  
        $productVideos.each(function() {
          var type = $(this).data('video-type');
  
          if (videoTypes.indexOf(type) < 0) {
            videoTypes.push(type);
          }
        });
  
        // Load YouTube API if not already loaded
        if (videoTypes.indexOf('youtube') > -1) {
          if (!theme.config.youTubeReady) {
            theme.LibraryLoader.load('youtubeSdk');
            $('body').on('youTubeReady' + this.settings.namespace, function() {
              this.loadYoutubeVideos($productVideos);
            }.bind(this));
          } else {
            this.loadYoutubeVideos($productVideos);
          }
        }
  
        // Add mp4 video players
        if (videoTypes.indexOf('mp4') > -1) {
          this.loadMp4Videos($productVideos);
        }
  
        return videoTypes;
      },
  
      loadMp4Videos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'mp4') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('video-id');
  
          videos[id] = {
            type: 'mp4',
            divId: id,
            style: $el.data('video-style')
          };
        });
      },
  
      loadYoutubeVideos: function($videos) {
        $videos.each(function() {
          var $el = $(this);
          if ($el.data('video-type') != 'youtube') {
            return;
          }
  
          var id = $el.attr('id');
          var videoId = $el.data('youtube-id');
  
          videos[id] = {
            type: 'youtube',
            id: id,
            videoId: videoId,
            style: $el.data('video-style'),
            loop: $el.data('video-loop'),
            attemptedToPlay: false,
            events: {
              onReady: function(evt) {
                onVideoPlayerReady(evt, id);
              },
              onStateChange: function(evt) {
                onVideoStateChange(evt, id);
              }
            }
          };
        });
  
        // Create a player for each YouTube video
        for (var key in videos) {
          if (videos[key].type === 'youtube') {
            if (videos.hasOwnProperty(key)) {
              var args = $.extend({}, youtubeVideoOptions, videos[key]);
  
              if (args.style === 'muted') {
                // default youtubeVideoOptions, no need to change anything
              } else {
                args.playerVars.controls = 1;
                args.playerVars.autoplay = 0;
              }
  
              youtubePlayers[key] = new YT.Player(key, args);
            }
          }
        }
  
        youtubeReady = true;
      },
  
      initVideo: function($video) {
        var videoType = $video.data('video-type');
        var divId = $video.attr('id');
  
        if (videoType === 'mp4' && videos[divId].style === 'muted') {
          this.playMp4Video(divId);
        }
  
        if (videoType === 'youtube') {
          if (youtubeReady && videos[divId].style === 'muted') {
            this.requestToPlayYoutubeVideo(divId);
          }
        }
  
        // Hacky way to trigger resetting the slider layout in modals
        if (this.inModal) {
          this.resizeSlides();
        }
      },
  
      stopVideo: function(id, type) {
        if (!id) {
          this.stopYoutubeVideo();
          this.stopMp4Video();
        }
  
        if (type === 'youtube') {
          this.stopYoutubeVideo(id);
        }
  
        if (type === 'mp4') {
          this.stopMp4Video(id);
        }
      },
  
      getVideoType: function($video) {
        return $video.data('video-type');
      },
  
      getVideoId: function($video) {
        return $video.attr('id');
      },
  
      // Sub video functions (MP4 and YouTube)
      requestToPlayYoutubeVideo: function(id, forcePlay) {
        if (!theme.config.youTubeReady) {
          return;
        }
  
        var $player = $('#' + id);
        setParentAsLoading($player);
  
        // If video is requested too soon, player might not be ready.
        // Set arbitrary timeout to request it again in a second
        if (typeof youtubePlayers[id].playVideo != 'function') {
          setTimeout(function() {
            this.playYoutubeVideo(id, forcePlay);
          }.bind(this), 1000);
          return;
        }
  
        this.playYoutubeVideo(id, forcePlay);
      },
  
      playYoutubeVideo: function (id, forcePlay) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
        if (typeof youtubePlayers[id].playVideo === 'function') {
          youtubePlayers[id].playVideo();
        }
  
        // forcePlay is sent as true from beforeSlideChange so the visibility
        // check isn't fooled by the next slide positioning
        if (!forcePlay) {
          initCheckVisibility(id);
        }
      },
  
      stopYoutubeVideo: function(id) {
        if (!theme.config.youTubeReady) {
          return;
        }
  
        if (id && youtubePlayers[id]) {
          if (typeof youtubePlayers[id].pauseVideo === 'function') {
            youtubePlayers[id].pauseVideo();
          }
          $(window).off('scroll.' + id);
        } else {
          for (key in youtubePlayers) {
            var childVideo = this.$container.find('#' + key);
            if (childVideo.length && typeof youtubePlayers[key].pauseVideo === 'function') {
              youtubePlayers[key].pauseVideo();
              $(window).off('scroll.' + key);
            }
          }
        }
      },
  
      playMp4Video: function(id) {
        var $player = $('#' + id);
        setParentAsLoaded($player);
  
        var playPromise = $player[0].play();
  
        if (playPromise !== undefined) {
          playPromise.then(function() {})
          .catch(function(error) {
            // Likely low power mode on iOS, show controls
            $player[0].setAttribute('controls', '');
            $player.closest(selectors.videoParent).attr('data-video-style', 'unmuted');
          });
        }
      },
  
      stopMp4Video: function(id) {
        if (id) {
          $('#' + id)[0].pause();
        } else {
          // loop through all mp4 videos to stop them
          for (var key in videos) {
            var childVideo = this.$container.find('#' + key);
            if (childVideo.length && videos[key].type === 'mp4') {
              var player = $('#' + videos[key].divId)[0];
              if (player && typeof player.pause === 'function') {
                player.pause();
              }
            }
          }
        }
      },
  
      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function() {
        var $container = $(this.selectors.imageContainer, this.$container);
        var imageZoom = new theme.Photoswipe($container[0], this.sectionId);
      },
  
      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }
  
        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.$firstProductImage[0].currentSrc;
  
        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },
  
      updateVariantImage: function(evt) {
        var variant = evt.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
        var $newImage = $('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));
  
        // No image, bail
        if (typeof imageIndex === 'undefined') {
          return;
        }
  		if(!this.isImageStyleNew())
        	this.$mainSlider.slick('slickGoTo', imageIndex);
      },
  
      initImageSwitch: function() {
        if (!$(this.selectors.photoThumbs).length) {
          return;
        }
  
        $(this.selectors.photoThumbs)
          .on('click', function(evt) {
            evt.preventDefault();
          })
          .on('focus', function(evt) {
            if (!this.settings.slickThumbInitialized) { return }
            var index = $(evt.currentTarget).data('index');
            if (index !== undefined) {
              this.$thumbSlider.slick('slickGoTo', index);
            }
          }.bind(this))
          .on('keydown', function(evt) {
            if (evt.keyCode === 13) {
              this.$container.find(selectors.currentSlide).focus();
            }
          }.bind(this));
      },
  
      createImageCarousels: function() {
        if (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2) {
          // Single product image. Init video if it exists
          var $video = $(this.selectors.productImageMain).find(selectors.productVideo);
          if ($video.length) {
            this.initVideo($video);
          }
          return;
        }
  
        this.settings.hasMultipleImages = true;
        this.settings.has3d = this.$container.find(this.selectors.media).length;
  
        // Set starting slide (for both sliders)
        var $activeSlide = this.$mainSlider.find('.starting-slide');
        var startIndex = this._slideIndex($activeSlide);
        var isArrow = true;
        if(getWindowRealWidth()<1023){
        	isArrow = false;
        }
        
  
        // Lame way to prevent duplicate event listeners
        this.$mainSlider.off('init');
        this.$mainSlider.off('beforeChange');
        this.$mainSlider.on('init', this.mainSlideInit.bind(this));
        this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));
        this.$thumbSlider.on('init', this.thumbSlideInit.bind(this));
  
        // Default (mobile) slider settings
        this.mainSliderArgs = {
          infinite: this.settings.has3d ? false : true,
          arrows: isArrow,
          dots: false,
          centerMode: true,
          adaptiveHeight: true,
          initialSlide: startIndex,
          appendDots: this.selectors.dotsContainer
        };
  
        this.thumbSliderArgs = {
          accessibility: false,
          initialSlide: startIndex
        };
  
        // Init sliders normally
        var sliderArgs = this.setSliderArgs();
        this.initSliders(sliderArgs);
  
        // Re-init slider when a breakpoint is hit
        $('body').on('matchSmall matchLarge', function() {
          var sliderArgs = this.setSliderArgs();
          this.initSliders(sliderArgs);
        }.bind(this));
        
        // 尺寸更新 修改产品图片展示规则 黄康 2021-08-25
        $(window).resize(function(){
            var WindowRealWidth = getWindowRealWidth();
            var sliderArgs = this.setSliderArgs();	
            this.initSliders(sliderArgs);
        }.bind(this));
  
        // Too many thumbnails can cause the AOS calculations to be off
        // so refresh that when the slider is ready
        if (AOS) {
          AOS.refresh();
        }
      },
  
      initSliders: function(args) {
        this.destroyImageCarousels();
		// 模式切换 单颜色模式 黄康 2021-04-25
        if(this.isImageStyleNew())
          this.initColorNewSliders(args);
        else
          this.$mainSlider.slick(args.main); 
		
        if (!theme.config.bpSmall && !isInitialized(this.$thumbSlider)) {
            this.$thumbSlider.slick(args.thumbs); 
          
          	/* 根据尺寸切换图片 */
            var size = false;
            if( $(this.selectors.variantSizeSwatch).length && this.isSizeUpdateImg)
              size = $(this.selectors.variantSizeSwatch+":checked").data('size-name');
          	if(size)
        	{
              var nowSlider = this.$mainSlider.find(".ProductPhotos-content-active");
              var nowSliderColor = nowSlider.attr("data-color");
              this.$thumbSlider.find(".product__thumb-item[data-color='"+nowSliderColor+"']").css({"display":"none"}); 
			  this.$thumbSlider.find(".product__thumb-item[data-color='"+nowSliderColor+"'][data-size=''],.product__thumb-item[data-color='"+nowSliderColor+"'][data-size='"+size+"']").css({"display":"block"});  
            }
          	/* 根据尺寸切换图片end */
        }          
        this.settings.slickMainInitialized = true;
      },
  	  initColorNewSliders: function(args) {
        
        if(!this.isImageStyleNew())
          return false;
        
        var nowSlider = this.$mainSlider.find(".ProductPhotos-content-active")
        var thumbSliderItem = this.$thumbSlider.find(".product__thumb-item");
        args.main.appendDots = this.selectors.mainSlider+" .ProductPhotos-content-active .product__photo-dots";
        args.main.initialSlide = false;
        if(isInitialized(nowSlider.find(".ProductPhotos-color"))){
          	nowSlider.find(".ProductPhotos-color").slick("unslick");
         	$('.page-content--product .medium-up--one-half').eq(1).css({"height":"fit-content"});

        }
        
        /* 根据尺寸切换图片 */
        var size = false;
        //console.log("initColorNewSliders");
        var nowSliderColor = nowSlider.attr("data-color");
        
        if( $(this.selectors.variantSizeSwatch).length && this.isSizeUpdateImg)
          size = $(this.selectors.variantSizeSwatch+":checked").data('size-name');
        if(size)
        {
         	 var nowSliderHtml = $("<div>"+this.$mainSliderHtml+"</div>").find(".ProductPhotos-content[data-color='"+nowSliderColor+"']").html();
          	 nowSlider.html(nowSliderHtml);
             $.each(nowSlider.find(".product-img-color-slide"),function(k,v){
               	var dataSize = $(this).attr("data-size");
				if(dataSize && dataSize != size)
                {
                  nowSlider.find(".product-img-color-slide").eq($(this).index()).remove();
                }
             })
		}
        if(nowSlider.find(".product-img-color-slide").eq(0).find(".image-wrap>img").hasClass("lazyloading"))
          nowSlider.find(".product-img-color-slide").eq(0).find(".image-wrap>img").removeClass("lazyloading").addClass("lazyloaded");
        
        /* 根据尺寸切换图片 end */
        if(getWindowRealWidth() <= 1023){
          if(getWindowRealWidth()>=767){
            var colorH = nowSlider.height();
            $('.page-content--product .medium-up--one-half').eq(1).css({"height":colorH});
          }
          if(!isInitialized(nowSlider.find(".ProductPhotos-color"))){
                nowSlider.find(".ProductPhotos-color").slick(
                args.main
                );
                if(getWindowRealWidth()>=767){
                  if(getWindowRealWidth()<1024){
                    colorH;
                  }else{
                    colorH = 'auto';
                  }
                  $('.page-content--product .medium-up--one-half').eq(1).css({"height":colorH});
                }
          
          }else{
            if(isInitialized(nowSlider.find(".ProductPhotos-color"))){
              nowSlider.find(".ProductPhotos-color").slick("unslick");
            }


          }
        }
        nowSlider.find(".ProductPhotos-color").on("beforeChange",function(event, slick, currentSlide, nextSlide){
           var nowIndex = nowSlider.find(".slick-slide").eq(nextSlide).attr("data-index")

           thumbSliderItem.parent().find(".product__thumb-item[data-index='"+nowIndex+"']").click();

        });

      },
      
      // 产品页 add to cart 悬浮定位的问题
      setProductSuspensionNav:function(){
        var $container = this.$container;
        var conTop = $container.offset().top
        var conH = $container.outerHeight()
        var scrollTop = $container.find('.quick_false').outerHeight()
        var formTop = $container.find('.product-single__form').outerHeight(true)
        var addToCart = $('.suspension-nav')
        if(getWindowRealWidth()>768){
          if($(document).scrollTop() >= (conTop + conH) ){
            addToCart.css('display','flex');
          }else{
            addToCart.css('display','none');
          }
        }else{
          if($(document).scrollTop() >= (scrollTop + formTop) ){
            addToCart.css('display','flex');
          }else{
            addToCart.css('display','none');
          }
        }

      }, 
       // 产品属性 鼠标经过
	  optionHover:function(){
//        console.log("optionHover")
		  var $container = this.$container;
		  $container.find(".variant-wrapper .variant-input").hover(function(){
				var variantWrapper = $(this).parents(".variant-wrapper")
				var value = $(this).data('value');
				variantWrapper.find('.variant__label .variant__label-info span').text(`${value}`);
				variantWrapper.find('.variant-input label').removeClass(classes.optionAction)
				$(this).find('label').addClass(classes.optionAction)
// 				variantWrapper.find(".variant-input-wrap input[type=radio]:checked+label").addClass(classes.optionAction)
		   },function(){
				var variantWrapper = $(this).parents(".variant-wrapper")
				var value = variantWrapper.find("input[type=radio]:checked").parents(".variant-input").data('value');
				variantWrapper.find('.variant__label .variant__label-info span').text(`${value}`);
				variantWrapper.find('.variant-input label').removeClass(classes.optionAction)
// 				variantWrapper.find(".variant-input-wrap input[type=radio]:checked+label").addClass(classes.optionAction)
		   })
	  },   
      setSliderArgs: function() {
        var args = {};
  
        var thumbnailsVertical = this.settings.thumbVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;
        var thumbArrows = this.settings.thumbArrows = this.$thumbSlider.data('arrows');
  
        var slidesToShow = thumbnailsVertical && thumbArrows ? 1 :
                           (thumbnailsVertical ? 3 : 5);
  
        if (theme.config.bpSmall) {
          if(!this.isImageStyleNew())
          {
          	args.main = this.mainSliderArgs;
          }
          else
          {
            args.main = $.extend({}, this.mainSliderArgs, {
              touchThreshold:10
            });
          }
          args.thumbs = this.thumbSliderArgs;
        } else {
          if(!this.isImageStyleNew())
          {
             args.main = $.extend({}, this.mainSliderArgs, {
              asNavFor: this.selectors.thumbSlider,
              adaptiveHeight: thumbnailsVertical ? false : true,
              dots: true,
              infinite: false,
              fade: true
            });
            args.thumbs = $.extend({}, this.thumbSliderArgs, {
              asNavFor: this.selectors.mainSlider,
              slidesToShow: 1, 
              slidesToScroll: 1,
              arrows: thumbArrows,
              dots: false,
              vertical: thumbnailsVertical,
              verticalSwiping: thumbnailsVertical,
              focusOnSelect: true,
              infinite: false,
              customHeightMatching: thumbArrows ? false : thumbnailsVertical,
              customSlideAdvancement: true
            });
          }
          else
          {
            args.main = $.extend({}, this.mainSliderArgs, {
              adaptiveHeight: thumbnailsVertical ? false : true,
              dots: true,
              infinite: false,
              fade: true
            });
            args.thumbs = $.extend({}, this.thumbSliderArgs, {
              slidesToShow: 1, 
              slidesToScroll: 1,
              arrows: thumbArrows,
              dots: false,
              vertical: thumbnailsVertical,
              verticalSwiping: thumbnailsVertical,
              focusOnSelect: true,
              infinite: false,
              customHeightMatching: thumbArrows ? false : thumbnailsVertical,
              customSlideAdvancement: true
            });
          }
        }
  
        return args;
      },
  
      destroyImageCarousels: function() {
        if (this.$mainSlider && this.settings.slickMainInitialized) {
          if(isInitialized(this.$mainSlider))
          	this.$mainSlider.slick('unslick');
          this.settings.slickMainInitialized = false;
        }
  
        if (this.$thumbSlider && this.settings.slickThumbInitialized) {
          if(isInitialized(this.$thumbSlider))
          	this.$thumbSlider.slick('unslick');
          this.settings.slickThumbInitialized = false;
        }
  
        this.settings.slickMainInitialized = false;
        this.settings.slickThumbInitialized = false;
      },
  
      mainSlideInit: function(event, slick) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $video = $currentSlide.find(selectors.productVideo);
  
        if (!$video.length) {
          return;
        }
  
        this.initVideo($video);
      },
  
      thumbSlideInit: function(event, slick) {
        this.settings.slickThumbInitialized = true;
  
        // Check if we need to hide the arrows
        if (this.settings.thumbArrows) {
          this.$thumbSlider.on('setPosition', this.thumbSlideArrowVisibility.bind(this));
        }
      },
  
      thumbSlideArrowVisibility: function(event, slick) {
        var $slider = slick.$slider;
        var $arrows = $slider.find('.slick-arrow');
        var showArrows = false;
  
        if (this.settings.thumbVertical) {
          var $trackHeight = $slider.find('.slick-track').height();
          if ($trackHeight >= $slider.height()) {
            showArrows = true;
          }
        } else {
          var $trackWidth = $slider.find('.slick-track').width();
          if ($trackWidth >= $slider.width()) {
            showArrows = true;
          }
        }
  
        if (showArrows) {
          $arrows.removeClass('hide');
        } else {
          $arrows.addClass('hide');
        }
      },
  
      beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
        var $slider = slick.$slider;
        var $currentSlide = $slider.find(selectors.currentSlide);
        var $prevVideo = $currentSlide.find('.product__video');
        var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
        var $nextVideo = $nextSlide.find('.product__video');
  
        // Pause any existing slide video
        if (currentSlide !== nextSlide && $prevVideo.length) {
          var prevVideoType = this.getVideoType($prevVideo);
          var prevVideoId = this.getVideoId($prevVideo);
  
          if (prevVideoId) {
            this.stopVideo(prevVideoId, prevVideoType);
          }
        }
  
        // Prep next slide video
        if ($nextVideo.length) {
          var nextVideoType = this.getVideoType($nextVideo);
          var nextVideoId = this.getVideoId($nextVideo);
  
          // Prep YouTube with a backup in case API isn't ready
          if (nextVideoId && nextVideoType === 'youtube') {
            if (youtubeReady) {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.requestToPlayYoutubeVideo(nextVideoId, true);
              }
            } else {
              $('body').on('youTubeReady' + this.settings.namespace, function() {
                if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                  this.requestToPlayYoutubeVideo(nextVideoId, true);
                }
              }.bind(this))
            }
          }
  
          // Autoplay muted MP4 videos
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
            if (nextVideoType === 'mp4') {
              this.playMp4Video(nextVideoId);
            }
          }
  
          // Set unmuted videos to loaded state
          if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
            setParentAsLoaded($('#' + nextVideoId));
          }
        }
  
        // Pause any existing media
        var $currentMedia = $currentSlide.find(this.selectors.media);
        if ($currentMedia.length) {
          $currentMedia.trigger('mediaHidden');
        }
  
        // Prep next slide media
        var $nextMedia = $nextSlide.find(this.selectors.media);
        if ($nextMedia.length) {
          $nextMedia.trigger('mediaVisible');
          $nextSlide.find('.shopify-model-viewer-ui__button').attr('tabindex', 0);
          $nextSlide.find('.product-single__close-media').attr('tabindex', 0);
        }
      },
  
      resizeSlides: function() {
        if (!this.settings.hasMultipleImages) {
          return;
        }
  
        $(window).trigger('resize.slick');
        setTimeout(function() {
          if (this.$mainSlider && this.settings.slickMainInitialized) {
            this.$mainSlider.slick('setPosition');
          }
          if (this.$thumbSlider && this.settings.slickThumbInitialized) {
            this.$thumbSlider.slick('setPosition');
          }
        }.bind(this), 500); // same timing as modal open transition
      },
  
      _slideIndex: function($el) {
        return $el.data('index');
      },
  
      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function() {
        
        if (!this.settings.modalInit) {
          var ajaxView = false
          
          if(typeof(gaDataDeploy) == "object")
              gaDataDeploy.elementClick(true).collectionEvent($("div.js-modal-open-quick-modal-"+this.sectionId));     
              
          if(ajaxView)
          {
            var url = this.$container.data('product-url');
            
            this.settings.modalInit = true;
            var that = this
            var qucikView = $(document).find("#QuickShopModal-"+that.sectionId);
            qucikView.find(".page-loading .page-loading-progress").css("width","40%");
            
            $.get(url + '?view=qiuckShopView',function(data){
              
			  qucikView.find(".page-loading .page-loading-progress").css("width","100%");
              
              setTimeout(function(){
              	quickViewUpdate(data);
                that.openModalProductAfter();
              },500)
              
              function quickViewUpdate(data)
              {
                var modalHtml = $("<div>"+data+"</div>").find("#ProductSection-"+that.sectionId).html();
                qucikView.find(".modal__centered-content").find("#ProductSection-"+that.sectionId).html(modalHtml)
                qucikView.find(".modal__centered-content").find("#ProductSection-"+that.sectionId) .find(".product-recommend-box").remove()

                $("#ProductSection-"+that.sectionId).find(".product__main-photos,.product__thumbs").addClass("aos-init").addClass("aos-animate");
                //var themeProduct = new theme.Product("#ProductSection-"+that.sectionId);
                //themeProduct.settings.modalInit = true;
                new theme.AjaxProduct($("#AddToCartForm-"+that.sectionId));

                that.$mainSlider = $(that.selectors.mainSlider);
                that.$thumbSlider = $(that.selectors.thumbSlider);
                that.$firstProductImage = that.$mainSlider.find('img').first();

                that.formSetup();
                if (Shopify.PaymentButton) {
                  Shopify.PaymentButton.init();
                }
                that.productSetup();
                that.loadModalContent();
                that.createImageCarousels();
                that.customMediaListners();
              }
            })
          }
          else
          {
            var $formHolder = $(this.selectors.modalFormHolder);
            var url = $formHolder.data('url');
            var template = $formHolder.data('template');

            // If no alt template, use stripped down ajax version
            if (!template) {
              url = url + '?view=ajax';
            }
          
            $formHolder.load(url + ' #AddToCartForm-' + this.sectionId, function() {
              if (typeof($formHolder.attr("data-code")) !== "undefined"){
                var ProductCode = $formHolder.attr("data-code")
                var PrductCodeDom = `<input type="hidden" name="discount-code" value="${ProductCode}">`
                //console.log($formHolder.find('.product-single__form'))
                $formHolder.find('.product-single__form').prepend(PrductCodeDom)
              }
              $formHolder.addClass('is-active');
              this.formSetup();
              if (Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }
              this.openModalProductAfter();
              this.sizeGuide()
            }.bind(this));
            this.productSetup();
            this.loadModalContent();
            this.createImageCarousels();
            this.customMediaListners();
            this.settings.modalInit = true;
          }
          
        }
        this.resizeSlides();
  
        // Add product id to recently viewed array
        this.addIdToRecentlyViewed();
      },
      // 打开quick view之后  
      openModalProductAfter:function(){
        
        //console.log("openModalProductAfter",this.sectionId)
        if(typeof(gaDataDeploy) == "object")
        {
         	gaDataDeploy.productDetailDeploy(this.sectionId); 
          	gaDataDeploy.elementClick(true).productDetailEvent($("div.product-section#ProductSection-"+this.sectionId)); 
        }
      },  
      closeModalProduct: function() {
        this.stopVideo();
        $('body').off(this.settings.namespace);
        $(window).off(this.settings.namespace);
      },
  
      loadModalContent: function() {
        // Load videos if they exist
        var videoTypes = this.checkIfVideos();
  
        // Lazyload mp4 videos
        if (videoTypes && videoTypes.indexOf('mp4') > -1) {
          this.$modal
            .find('.product__video[data-video-type="mp4"]')
            .find('.product__video-src')
            .each(function(i, video) {
              var $el = $(video);
              var src = $el.attr('src');
              var type = $el.attr('type')
              var newEl = document.createElement('source');
              newEl.src = src;
              newEl.type = type;
              $el.after(newEl);
            }.bind(this));
        }
      },
  
      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function() {
        var $modelViewerElements = $(
          this.selectors.media,
          this.$container
        );
  
        if ($modelViewerElements.length < 1) return;
  
        theme.ProductMedia.init($modelViewerElements, this.sectionId);
      },
  
      initShopifyXrLaunch: function() {
        var self = this;
        $(document).on('shopify_xr_launch', function() {
          var $currentMedia = $(
            self.selectors.productMediaWrapper +
              ':not(.' +
              classes.hidden +
              ')',
            self.$container
          );
          $currentMedia.trigger('xrLaunch');
        });
      },
  
      customMediaListners: function() {
        $('body').on('click', this.selectors.closeMedia, function() {
          this.$mainSlider
            .find(selectors.currentSlide)
            .find(this.selectors.media)
            .trigger('mediaHidden');
        }.bind(this));
  
        this.$container.find('model-viewer')
          .on('shopify_model_viewer_ui_toggle_play', function(evt) {
            this.mediaLoaded(evt);
          }.bind(this))
          .on('shopify_model_viewer_ui_toggle_pause', function(evt) {
            this.mediaUnloaded(evt);
          }.bind(this));
      },
  
      mediaLoaded: function(evt) {
        this.$container.find(this.selectors.closeMedia).removeClass('hide');
        this.toggleSliderSwiping(false);
      },
  
      mediaUnloaded: function(evt) {
        this.$container.find(this.selectors.closeMedia).addClass('hide');
        this.toggleSliderSwiping(true);
      },
  
      toggleSliderSwiping: function(enable) {
        if (this.$mainSlider && this.settings.slickMainInitialized) {
          this.$mainSlider.slick('slickSetOption', 'swipe', enable);
          this.$mainSlider.slick('slickSetOption', 'draggable', enable);
          this.$mainSlider.slick('slickSetOption', 'touchMove', enable);
          this.$mainSlider.slick('slickSetOption', 'accessibility', enable);
        }
      },
  
      onUnload: function() {
        this.$container.off(this.settings.namespace);
        $('body').off(this.settings.namespace);
        this.destroyImageCarousels();
        theme.ProductMedia.removeSectionModels(this.sectionId);
      }
    });
  
    return Product;
  })();
      
      
  theme.Recommendations = (function() {
  
    function Recommendations(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
  
      this.selectors = {
        recommendations: '#Recommendations-' + sectionId,
        placeholder: '.product-recommendations-placeholder',
        sectionClass: ' .product-recommendations',
        productResults: '.grid-product'
      };
  
      this.init();
    }
  	//产品页推荐产品
    Recommendations.prototype = $.extend({}, Recommendations.prototype, {
      init: function() {
        var $section = $(this.selectors.recommendations);
  
        if (!$section.length || $section.data('enable') === false) {
          return;
        }
  
        var $placeholder = $section.find(this.selectors.placeholder);
        var id = $section.data('product-id');
        var limit = $section.data('limit');
  
        var url = '/recommendations/products?section_id=product-recommendations&limit='+ limit +'&product_id=' + id;
  
        $placeholder.load(url + this.selectors.sectionClass, function(data) {
          theme.reinitProductGridItem($section);
          this.updateVariantInventory($section);
  		  new theme.Collection();
          // If no results, hide the entire section
          if ($(data).find(this.selectors.sectionClass).find(this.selectors.productResults).length === 0) {
            $section.addClass('hide');
          }
          this.recommendSlick()
          
          //产品页推荐产品加载更多色块
          $section.find(".next-color").click(function(){
            console.log(111);
            var lumpDistance = Math.floor(($(this).parents('.grid-product__meta').find('.grid-product__colors-content').scrollLeft())/colorSwatchW);
            var num = lumpDistance + scrollNum
            var distance = num * colorSwatchW;
            $(this).parents('.grid-product__meta').find('.grid-product__colors-content').animate({scrollLeft:distance},400);
            var currentScrollLeft = $(this).parents('.grid-product__meta').find('.grid-product__colors-content').scrollLeft();
            var scrollWidth = $(this).parents('.grid-product__meta').find('.grid-product__colors').width(); // 内容的总宽度
            var clientWidth = $(this).parents('.grid-product__meta').find('.grid-product__colors-box').width(); // 可见区域的宽度
            var isAtRightEnd = currentScrollLeft + clientWidth >= scrollWidth;
            console.log(currentScrollLeft,scrollWidth,clientWidth);
            // 输出结果
            if (isAtRightEnd) {
                $(this).css('display','none')
            } else {
            }
          })
          $section.find(".btn-plus").click(function(){
              $(this).parents('.grid-product__colors-box').removeClass('erweitern')
          })
          
          
        }.bind(this));
      },
  
      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateVariantInventory: function($section) {
        window.inventories = window.inventories || {};
  
        $section.find('.js-product-inventory-data').each(function() {
          var $el = $(this);
          var sectionId = $el.data('section-id');
          window.inventories[sectionId] = {};
          $('.js-variant-inventory-data', $el).each(function() {
            var $child = $(this);
            window.inventories[sectionId][$child.data('id')] = {
              'quantity': $child.data('quantity'),
              'incoming': $child.data('incoming'),
              'next_incoming_date': $child.data('date')
            }
          });
        });
      },
      recommendSlick:function(){
        var num
        function ProductSlick(SlickDom){
          if(getWindowRealWidth()>768){
            num = 4;
          }else{
            num=2;
          }
          SlickDom.slick({
            infinite: true,
            slidesToShow: num,
            slidesToScroll: num,
            arrows:true,
            draggable:true,
            dots:true,
            prevArrow:'<button type="button" class="slick-prev"><svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon"><path d="M1.04907e-06 7L12 0.071798L12 13.9282L1.04907e-06 7Z" fill="#D9D9D9"/></svg></button>',
            nextArrow:'<button type="button" class="slick-next"><svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon"><path d="M12 7L-6.52533e-07 13.9282L-4.68497e-08 0.0717964L12 7Z" fill="#D9D9D9"/></svg></button>',

          })
        }
        
        var slider  = $(".Recommendations-collection-product .product-recommendations-placeholder .product-recommendations .grid.grid--uniform");
        
        function isInitialized(slider) {
          return slider.length && slider.hasClass('slick-initialized');
        }
        //是否执行slick
        function isSlick(slider){
          if(slider.hasClass('slick-initialized')){
            slider.slick("unslick")
          }
            ProductSlick(slider)
        }
        //计算图片高度 
        function TopHeight(slider){
          var imgH =  slider.find(".grid__item.grid-product").eq(1).find(".image-wrap").outerHeight();
          slider.find(".slick-arrow").css("top",parseInt(imgH / 2));
        }  
        //宽度发生变化时执行
        $(window).resize(function() { 
            isSlick(slider)
            TopHeight(slider)
        })  
        
        var length =  slider.find(".grid__item.mm-grid-item").length;
          if(length>4){
            isSlick(slider)
          }
          TopHeight(slider)
        //加载更多按钮点击
        $('.Recommendations-load-btn').click(function(){
         
          $(this).siblings('.Recommendations-collection-product').find(".grid__item.mm-grid-item").show()
          $(this).css("display","none")
        })
        
       	// ga埋点
        function gaDeploy()
		{
			if(typeof(gaDataDeploy) == "object")
			{
				var nowCollectionItem = $(gaDataDeploy.config.productRecommend.box);
				var recommendDeploy = gaDataDeploy.productListDeploy(nowCollectionItem,gaDataDeploy.config.productRecommend.listName);
				slider.on("afterChange",function(event, slick, currentSlide, nextSlide){
					recommendDeploy.itemShowAction();
				})	
			}
		}
		gaDeploy(); 
        
      }
    });
  
    return Recommendations;
  })();
  
  theme.CollectionHeader = (function() {
  
    var selectors = {
      hero: '.collection-hero',
      parallaxContainer: '.parallax-container'
    };
  
    function CollectionHeader(container) {
      var $container = $(container);
      this.namespace = '.collection-header';
  
      var $heroImageContainer = this.$heroContainer = $container.find(selectors.hero);
      if ($heroImageContainer.length) {
        this.checkIfNeedReload();
  
        if ($container.data('parallax')) {
          var $parallaxContainer = $container.find(selectors.parallaxContainer);
          var args = {
            namespace: this.namespace
          };
          theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
        }
      } else {
        // Prevent 'Overlay header over collection' header setting
        // from breaking layout. Required because settings from two
        // different sections rely on each other on page load.
        theme.headerNav.disableOverlayHeader();
      }
    }
  
    CollectionHeader.prototype = $.extend({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function() {
        if (!Shopify.designMode) {
          return;
        }
  
        if (!theme.settings.overlayHeader) {
          return;
        }
        var $header = $('.header-wrapper');
        if (!$header.hasClass('is-light') && !$('.header-wrapper').hasClass('header-wrapper--sticky')) {
          location.reload();
        }
      },
  
      onUnload: function() {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
      }
    });
  
    return CollectionHeader;
  })();
  
  theme.CollectionSidebar = (function() {
    var drawerStyle = false;
  
    function CollectionSidebar(container) {
      this.$container = $(container);
      this.init();
    }
  
    CollectionSidebar.prototype = $.extend({}, CollectionSidebar.prototype, {
      init: function() {
        // Force close the drawer if it exists
        this.onUnload();
  
        drawerStyle = this.$container.data('style') === 'drawer';
        theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
      },
  
      forceReload: function() {
        this.init();
      },
  
      onSelect: function() {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }
  
          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
      },
  
      onDeselect: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },
  
      onUnload: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      }
    });
  
    return CollectionSidebar;
  })();
  
  theme.Collection = (function() {
  
    var selectors = {
      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',
      sortSelect: '#SortBy',
      sectionId:'',
      moveAttr:"moveing"   //移动中的 attr 标示
    };
  
    var data = {
      sortBy: 'data-default-sortby'
    };
  
    function Collection(container) {
      this.container = container;
      this.sectionId = $(container).attr('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
  
      this.init();
    }
  
    Collection.prototype = $.extend({}, Collection.prototype, {
      init: function() {
        // init is called on load and when tags are selected
        this.$container = $(this.container);
        var sectionId = this.sectionId = this.$container.attr('data-section-id');
        this.namespace = '.collection-' + sectionId;
  		selectors.sectionId = sectionId
        this.$sortSelect = $(selectors.sortSelect);
        this.$sortSelect.on('change', this.onSortChange.bind(this));
        this.defaultSort = this.getDefaultSortValue();
  
        this.initParams();
        
        selectors.sectionId = sectionId	
        
        this.colorSwatchHovering();
  
        theme.reinitSection('collection-sidebar');
        this.scrollColor();
        this.productReviewUpdate();
      },
  	  // ajax 产品评论 语言包问题
      productReviewUpdate:function(){
      		var jdgmText = $(".jdgm-prev-badge__text");
            var jdgmTextNew = ""
            jdgmText.each(function(){
                var parentsObj = $(this).parents(".jdgm-prev-badge")
                var productReviewNum = parentsObj.attr("data-number-of-reviews");
                if(productReviewNum > 0 )
                {
                	if(productReviewNum > 1)
                        jdgmTextNew = productReviewNum + " " + "Rezensionens"
                    else
                		jdgmTextNew = productReviewNum + " " + "Rezensionen"
                }
                else
                {
                	jdgmTextNew = "No Rezensionen"
                }
                $(this).text(jdgmTextNew);
            })
      },
      initParams: function() {
        this.queryParams = {};
  
        if (location.search.length) {
          var aKeyValue;
          var aCouples = location.search.substr(1).split('&');
          for (var i = 0; i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
              this.queryParams[
                decodeURIComponent(aKeyValue[0])
              ] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }
      },
  	  
      getSortValue: function() {
        return this.$sortSelect.val() || this.defaultSort;
      },
  
      getDefaultSortValue: function() {
        return this.$sortSelect.attr(data.sortBy);
      },
  
      onSortChange: function() {
        this.queryParams.sort_by = this.getSortValue();
  
        if (this.queryParams.page) {
          delete this.queryParams.page;
        }
  
        window.location.search = $.param(this.queryParams);
      },
  
      

      // 色块点击事件
      colorSwatchHovering: function() {
        
		$(selectors.colorSwatch).click(function(evt){
			
			// 优先判断色块是否在move中
			if($(this).parents(".grid-product__colors-content").attr(selectors.moveAttr))
            	return false;
			
			// 色块点击移动
			var collectionBox = $("div[data-section-type='collection-template'][data-section-id='"+selectors.sectionId+"']");
			var colorSwatchW =  collectionBox.find(".grid-product__colors-box .grid-product__colors>a").outerWidth(true)
			!colorSwatchW && (colorSwatchW = 26);
			var index = ($(this).index())+1;
			var distances = (index-2) * colorSwatchW;
			if(index>1)
			  $(this).parents('.grid-product__colors-content').animate({scrollLeft:distances},400);

        
			var $colorImage = $(selectors.colorSwatchImage);
			if (!$colorImage.length)
			  	return false;
           
			// 色块对应图片更新
            $(this).siblings().each(function(){
            	var id = $(this).data('variant-id');
              	var image = $(this).data('variant-image');
              	$('.grid-product__color-image--' + id).css('background-image', 'url(' + image + ')').removeClass('is-active');
                $(this).removeClass("is-active");
            });
            
            var id = $(this).data('variant-id');
            var image = $(this).data('variant-image');
            $('.grid-product__color-image--' + id).css('background-image', 'url(' + image + ')').addClass('is-active');

            $(this).addClass("is-active");
            $(this).parents(".grid-product__meta").find(".grid-product__link ").attr("href",$(this).attr("data-src"));
        });
      },
      //点击按钮向右滚动一个色块的距离  
      scrollColor:function (){
        var collectionBox = $("div[data-section-type='collection-template'][data-section-id='"+selectors.sectionId+"']");
        var scrollNum = 2; // 点击一次滚动的数量
        var colorSwatchW =  collectionBox.find(".grid-product__colors-box .grid-product__colors>a").outerWidth(true)
        
        !colorSwatchW && (colorSwatchW = 26);
        
        collectionBox.find(".next-color").click(function(){
          var lumpDistance = Math.floor(($(this).parents('.grid-product__meta').find('.grid-product__colors-content').scrollLeft())/colorSwatchW);
          var num = lumpDistance + scrollNum
          var distance = num * colorSwatchW;
          $(this).parents('.grid-product__meta').find('.grid-product__colors-content').animate({scrollLeft:distance},400);
          var currentScrollLeft = $(this).parents('.grid-product__meta').find('.grid-product__colors-content').scrollLeft();
          var scrollWidth = $(this).parents('.grid-product__meta').find('.grid-product__colors').width(); // 内容的总宽度
          var clientWidth = $(this).parents('.grid-product__meta').find('.grid-product__colors-box').width(); // 可见区域的宽度
          var isAtRightEnd = currentScrollLeft + clientWidth >= scrollWidth;
          console.log(currentScrollLeft,scrollWidth,clientWidth);
          // 输出结果
          if (isAtRightEnd) {
              $(this).css('display','none')
          } else {
          }
        })
        
        this.scrollMouseColor();
       
      },
            // pc 鼠标触摸滚动
      scrollMouseColor:function()
      {
        var collectionBox = $("div[data-section-type='collection-template'][data-section-id='"+selectors.sectionId+"']");
        var mouseStart = false;
        var touchstartX = 0;
        var touchstartY = 0;
        var touchmoveUpX = 0;
        var touchmoveUpY = 0;
        var touchendX = 0;
        var touchendY = 0; 
        //触摸事件 初始化
        function itemScrollInit()
        {
          touchstartX = 0;
          touchstartY = 0;
          touchmoveUpX = 0;
          touchmoveUpY = 0;
          touchendX = 0;
          touchendY = 0;
        }

        collectionBox.find(".grid-product__colors-content").on("mousedown",function(e){
          itemScrollInit();
          mouseStart = true;
          touchstartX = e.pageX;
          touchstartY = e.pageY
          //console.log("mousedown",e.pageX, e.pageY);
        })
        collectionBox.find(".grid-product__colors-content").on("mousemove",function(e){
          if(!mouseStart || e.which !== 1)
            return false;

          var touchmoveX = parseInt(e.pageX);
          var touchmoveY = parseInt(e.pageY);
          moveDistanceX =  touchmoveUpX ? touchmoveX - touchmoveUpX :  touchmoveX - touchstartX;
          moveDistanceY =  touchmoveUpY ? touchmoveY - touchmoveUpY :  touchmoveY - touchstartY;
          touchmoveUpX = 	touchmoveX;
          touchmoveUpY = 	touchmoveY;			
          //console.log("mousemove",e.pageX, e.pageY);

          if(Math.abs(moveDistanceX) > Math.abs(moveDistanceY))
          {
            e.preventDefault();	
            if(!$(this).attr(selectors.moveAttr))
            	$(this).attr(selectors.moveAttr, 'true');
            colorContentScroll(this,moveDistanceX);
          }

        })
        $("body").on("mouseup",function(e){
          mouseStart = false
          setTimeout(function(){
            collectionBox.find(".grid-product__colors-content").removeAttr(selectors.moveAttr);
          },10)
        })

        function colorContentScroll(that,x)
        {
          var x = Math.floor($(that).scrollLeft()) - x;
          $(that).scrollLeft(x);
        }

      },
      
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
  
      onUnload: function() {
        $(window).off(this.namespace);
        this.$container.off(this.namespace);
        $(selectors.colorSwatch).off(this.namespace);
      }
    });
  
    return Collection;
  })();
  
  theme.HeaderSection = (function() {
  
    var selectors = {
      drawer: '#NavDrawer',
      mobileSubNavToggle: '.mobile-nav__toggle-btn',
      hasSublist: '.mobile-nav__has-sublist',
      disclosureLocale: '[data-disclosure-locale]',
      disclosureCurrency: '[data-disclosure-currency]'
    };
  
    var classes = {
      navExpanded: 'mobile-nav--expanded'
    };
  
    function Header(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
  
      // Reload any slideshow if when the header is reloaded to make sure the
      // sticky header works as expected
      theme.reinitSection('slideshow-section');
  
      this.initDrawers();
      theme.headerNav.init();
      theme.announcementBar.init();
  
      this.cache = {};
      this.cacheSelectors();
  
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure = new theme.Disclosure(
          this.cache.$localeDisclosure
        );
      }
  
      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure = new theme.Disclosure(
          this.cache.$currencyDisclosure
        );
      }
  
      // Set a timer to resize the header in case the logo changes size
      if (Shopify.designMode) {
        setTimeout(function() {
          $('body').trigger('resize');
        }, 500);
      }
    }
  
    Header.prototype = $.extend({}, Header.prototype, {
      cacheSelectors: function() {
        this.cache = {
          $localeDisclosure: this.$container.find(selectors.disclosureLocale),
          $currencyDisclosure: this.$container.find(selectors.disclosureCurrency)
        };
      },
  
      initDrawers: function() {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
        if (theme.settings.cartType === 'drawer') {
          new theme.CartDrawer();
        }
  
        this.drawerMenuButtons();
      },
  
      drawerMenuButtons: function() {
        $(selectors.drawer).find('.js-drawer-close').on('click', function(evt){
          evt.preventDefault();
          theme.NavDrawer.close();
        });
  
        var $mobileSubNavToggle = $(selectors.mobileSubNavToggle);
  
        $mobileSubNavToggle.attr('aria-expanded', 'false');
        $mobileSubNavToggle.each(function (i, el) {
          var $el = $(el);
          $el.attr('aria-controls', $el.attr('data-aria-controls'));
        });
  
        $mobileSubNavToggle.on('click', function() {
          var $el = $(this);
          var currentlyExpanded = $el.attr('aria-expanded');
          var toggleState = false;
  
          // Updated aria-expanded value based on state pre-click
          if (currentlyExpanded === 'true') {
            $el.attr('aria-expanded', 'false');
          } else {
            $el.attr('aria-expanded', 'true');
            toggleState = true;
          }
  
          // Toggle class that expands/collapses sublist
          $el.closest(selectors.hasSublist).toggleClass(classes.navExpanded, toggleState);
        });
      },
  
      onBlockSelect: function(evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId);
      },
  
      onDeselect: function() {
        theme.announcementBar.onBlockDeselect();
      },
  
      onUnload: function() {
        theme.NavDrawer.close();
        theme.headerNav.unload();
        theme.announcementBar.unload();
  
        if (this.cache.$localeDisclosure.length) {
          this.localeDisclosure.unload();
        }
  
        if (this.cache.$currencyDisclosure.length) {
          this.currencyDisclosure.unload();
        }
      }
    });
  
    return Header;
  
  })();
  
  theme.FooterSection = (function() {
  
    var selectors = {
      disclosureLocale: '[data-disclosure-locale]',
      disclosureCurrency: '[data-disclosure-currency]'
    };
  
    function Footer(container) {
      var $container = this.$container = $(container);
  
      this.cache = {};
      this.cacheSelectors();
  
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure = new theme.Disclosure(
          this.cache.$localeDisclosure
        );
      }
  
      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure = new theme.Disclosure(
          this.cache.$currencyDisclosure
        );
      }
    }
  
    Footer.prototype = $.extend({}, Footer.prototype, {
      cacheSelectors: function() {
        this.cache = {
          $localeDisclosure: this.$container.find(selectors.disclosureLocale),
          $currencyDisclosure: this.$container.find(selectors.disclosureCurrency)
        };
      },
  
      onUnload: function() {
        if (this.cache.$localeDisclosure.length) {
          this.localeDisclosure.unload();
        }
  
        if (this.cache.$currencyDisclosure.length) {
          this.currencyDisclosure.unload();
        }
      }
    });
  
    return Footer;
  })();
  
  theme.FeaturedContentSection = (function() {
  
    function FeaturedContent() {
      $('.rte').find('a:not(:has(img))').addClass('text-link');
    }
  
    return FeaturedContent;
  })();
  
  theme.slideshows = {};
  
  theme.SlideshowSection = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function SlideshowSection(container) {
      var $container = this.$container = $(container);
      var $section = $container.parent();
      var sectionId = $container.attr('data-section-id');
      var slideshow = this.slideshow = '#Slideshow-' + sectionId;
      this.namespace = '.' + sectionId;
  
      var $imageContainer = $(container).find('.hero');
      if ($imageContainer.length) {
        theme.loadImageSection($imageContainer);
      }
  
      this.init();
  
      if ($container.data('parallax')) {
        var args = {
          namespace: this.namespace
        };
        theme.parallaxSections[this.namespace] = new theme.Parallax($container.find(selectors.parallaxContainer), args);
      }
    }
  
    SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
      init: function() {
        // Prevent slideshows from initializing on top of themselves
        this.onUnload();
  
        var $slideshow = $(this.slideshow);
        var args = {
          autoplay: $slideshow.data('autoplay'),
          arrows: $slideshow.data('arrows'),
          dots: $slideshow.data('dots'),
          fade: true,
          speed: 500 // same as $slideshowImageAnimationSpeed in CSS
        };
  
        theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);
      },
  
      forceReload: function() {
        this.init();
      },
  
      onUnload: function() {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
        if (theme.slideshows[this.slideshow]) {
          theme.slideshows[this.slideshow].destroy();
          delete theme.slideshows[this.slideshow];
        }
      },
  
      onSelect: function() {
        $(this.slideshow).slick('slickPause');
      },
  
      onDeselect: function() {
        $(this.slideshow).slick('slickPlay');
      },
  
      onBlockSelect: function(evt) {
        var $slideshow = $(this.slideshow);
  
        // Ignore the cloned version
        var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
  
        // Go to selected slide, pause autoplay
        $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
      },
  
      onBlockDeselect: function() {
        $(this.slideshow).slick('slickPlay');
      }
    });
  
    return SlideshowSection;
  })();
  
  theme.VideoSection = (function() {
    var youtubeReady;
    var videos = [];
    var youtubePlayers = [];
    var youtubeVideoOptions = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        branding: 0,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        quality: 'hd720',
        rel: 0,
        showinfo: 0,
        wmode: 'opaque'
      }
    };
  
    var vimeoReady = false;
    var vimeoVideoOptions = {
      byline: false,
      title: false,
      portrait: false,
      loop: true
    };
  
    var selectors = {
      videoParent: '.video-parent-section'
    };
  
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    };
  
    function videoSection(container) {
      var $container = this.$container = $(container);
      var sectionId = this.sectionId = $container.attr('data-section-id');
      var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
      this.namespace = '.' + youtubePlayerId;
      var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
      var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
      var mp4Video = 'Mp4Video-' + this.sectionId;
  
      var $youtubeDiv = $('#' + youtubePlayerId);
      var $vimeoDiv = $('#' + vimeoPlayerId);
      var $mp4Div = $('#' + mp4Video);
  
      this.vimeoPlayer = [];
  
      if ($youtubeDiv.length) {
        this.youtubeVideoId = $youtubeDiv.data('video-id');
        this.initYoutubeVideo();
      }
  
      if ($vimeoDiv.length) {
        this.vimeoVideoId = $vimeoDiv.data('video-id');
        this.initVimeoVideo();
      }
  
      if ($mp4Div.length) {
        setParentAsLoaded($mp4Div);
  
        startMp4Playback(mp4Video).then(function() {
          // Video played as expected, don't do anything
        }).catch(function(error) {
          // Video cannot be played with autoplay, so let
          // user interact with video element itself
          setVideoToBeInteractedWith($mp4Div);
        })
      }
    }
  
    function startMp4Playback(mp4Video) {
      return document.querySelector('#' + mp4Video).play();
    }
  
    function onVideoPlayerReady(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      youtubePlayers[playerId] = evt.target; // update stored player
      var player = youtubePlayers[playerId];
  
      setParentAsLoading($player);
  
      youtubePlayers[playerId].mute();
  
      // Remove from tabindex because YouTube iframes are annoying and you can focus
      // on the YouTube logo and it breaks
      $player.attr('tabindex', '-1');
  
      // Add out of view pausing
      videoVisibilityCheck(playerId);
      $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
    }
  
    function videoVisibilityCheck(id) {
      var playerId;
  
      if (typeof id === 'string') {
        playerId = id;
      } else {
        // Data comes in as part of the scroll event
        playerId = id.data ? id.data.id : false;
      }
  
      if (playerId) {
        if (theme.isElementVisible($('#' + playerId))) {
          playVisibleVideo(playerId);
        } else {
          pauseHiddenVideo(playerId);
        }
      }
    }
  
    function playVisibleVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }
    }
  
    function pauseHiddenVideo(id) {
      if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
        youtubePlayers[id].pauseVideo();
      }
    }
  
    function onVideoStateChange(evt, id) {
      var $player = $('#' + id);
      var playerId = $player.attr('id');
      var player = youtubePlayers[playerId];
  
      switch (evt.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (videos[playerId].attemptedToPlay) {
            setParentAsLoaded($player);
            setVideoToBeInteractedWith($player);
          }
          break;
        case 0: // ended
          player.playVideo();
          break;
        case 1: // playing
          setParentAsLoaded($player);
          break;
        case 3: // buffering
          videos[playerId].attemptedToPlay = true;
          break;
      }
    }
  
    function setParentAsLoading($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.loading);
    }
  
    function setParentAsLoaded($el) {
      $el
        .closest(selectors.videoParent)
        .removeClass(classes.loading)
        .addClass(classes.loaded);
    }
  
    function setVideoToBeInteractedWith($el) {
      $el
        .closest(selectors.videoParent)
        .addClass(classes.interactable);
    }
  
    videoSection.prototype = $.extend({}, videoSection.prototype, {
      initYoutubeVideo: function() {
        videos[this.youtubePlayerId] = {
          id: this.youtubePlayerId,
          videoId: this.youtubeVideoId,
          type: 'youtube',
          attemptedToPlay: false,
          events: {
            onReady: function(evt) {
              onVideoPlayerReady(evt, this.youtubePlayerId);
            }.bind(this),
            onStateChange: function(evt) {
              onVideoStateChange(evt, this.youtubePlayerId);
            }.bind(this)
          }
        };
  
        if (!youtubeReady) {
          theme.LibraryLoader.load('youtubeSdk');
          $('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
        } else {
          this.loadYoutubeVideo();
        }
      },
  
      loadYoutubeVideo: function() {
        var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
        args.playerVars.controls = 0;
        youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);
  
        youtubeReady = true;
      },
  
      initVimeoVideo: function() {
        videos[this.vimeoPlayerId] = {
          divId: this.vimeoPlayerId,
          id: this.vimeoVideoId,
          type: 'vimeo'
        };
  
        var $player = $('#' + this.vimeoPlayerId);
        setParentAsLoading($player);
  
        // Button to play video on mobile
        this.$vimeoTrigger.on('click', + this.namespace, function(evt) {
          // $(evt.currentTarget).addClass('hide');
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        }.bind(this));
  
        if (!vimeoReady) {
          window.loadVimeo();
          $('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
        } else {
          this.loadVimeoVideo();
        }
      },
  
      loadVimeoVideo: function() {
        var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
        this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);
  
        vimeoReady = true;
  
        // Only autoplay on larger screens
        if (!theme.config.bpSmall) {
          this.requestToPlayVimeoVideo(this.vimeoPlayerId);
        } else {
          var $player = $('#' + this.vimeoPlayerId);
          setParentAsLoaded($player);
        }
      },
  
      requestToPlayVimeoVideo: function(id) {
        // The slider may initialize and attempt to play the video before
        // the API is even ready, because it sucks.
  
        if (!vimeoReady) {
          // Wait for the trigger, then play it
          $('body').on('vimeoReady' + this.namespace, function() {
            this.playVimeoVideo(id);
          }.bind(this))
          return;
        }
  
        this.playVimeoVideo(id);
      },
  
      playVimeoVideo: function(id) {
        this.vimeoPlayer[id].play();
        this.vimeoPlayer[id].setVolume(0);
  
        var $player = $('#' + id);
        setParentAsLoaded($player);
      },
  
      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        var playerId = 'YouTubeVideo-' + sectionId;
        youtubePlayers[playerId].destroy();
        $(window).off('scroll' + this.namespace);
        $('body').off('vimeoReady' + this.namespace);
      }
    });
  
    return videoSection;
  })();
  
  theme.BackgroundImage = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function backgroundImage(container) {
      var $container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.namespace = '.' + sectionId;
  
      if (!$container.length) {
        return;
      }
  
      if ($container.data('parallax')) {
        var $parallaxContainer = $container.find(selectors.parallaxContainer);
        var args = {
          namespace: this.namespace,
          desktopOnly: true
        };
  
        theme.parallaxSections[this.namespace] = new theme.Parallax($parallaxContainer, args);
      }
    }
  
    backgroundImage.prototype = $.extend({}, backgroundImage.prototype, {
      onUnload: function(evt) {
        theme.parallaxSections[this.namespace].destroy();
        delete theme.parallaxSections[this.namespace];
      }
    });
  
    return backgroundImage;
  })();
  
  theme.Testimonials = (function() {
    var slideCount = 0;
    var defaults = {
      accessibility: true,
      arrows: false,
      dots: true,
      autoplay: false,
      touchThreshold: 20,
      slidesToShow: 3,
      slidesToScroll: 3
    };
  
    function Testimonials(container) {
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      var wrapper = this.wrapper = '.testimonials-wrapper';
      var slider = this.slider = '#Testimonials-' + sectionId;
      var $slider = $(slider);
  
      this.sliderActive = false;
      var mobileOptions = $.extend({}, defaults, {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      });
  
      slideCount = $slider.data('count');
  
      // Override slidesToShow/Scroll if there are not enough blocks
      if (slideCount < defaults.slidesToShow) {
        defaults.slidesToShow = slideCount;
        defaults.slidesToScroll = slideCount;
      }
  
      $slider.on('init', this.a11y.bind(this));
  
      if (theme.config.bpSmall) {
        this.init($slider, mobileOptions);
      } else {
        this.init($slider, defaults);
      }
  
      $('body').on('matchSmall', function() {
        this.init($slider, mobileOptions);
      }.bind(this));
  
      $('body').on('matchLarge', function() {
        this.init($slider, defaults);
      }.bind(this));
    }
  
    Testimonials.prototype = $.extend({}, Testimonials.prototype, {
      onUnload: function() {
        $(this.slider, this.wrapper).slick('unslick');
      },
  
      onBlockSelect: function(evt) {
        // Ignore the cloned version
        var $slide = $('.testimonials-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
        var slideIndex = $slide.data('slick-index');
  
        // Go to selected slide, pause autoplay
        $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
      },
  
      init: function(obj, args) {
        if (this.sliderActive) {
          obj.slick('unslick');
          this.sliderActive = false;
        }
  
        obj.slick(args);
        this.sliderActive = true;
  
        if (AOS) {
          AOS.refresh();
        }
      },
  
      a11y: function(event, obj) {
        var $list = obj.$list;
        var $wrapper = $(this.wrapper, this.$container);
  
        // Remove default Slick aria-live attr until slider is focused
        $list.removeAttr('aria-live');
  
        // When an element in the slider is focused set aria-live
        $wrapper.on('focusin', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.attr('aria-live', 'polite');
          }
        });
  
        // Remove aria-live
        $wrapper.on('focusout', function(evt) {
          if ($wrapper.has(evt.target).length) {
            $list.removeAttr('aria-live');
          }
        });
      }
    });
  
    return Testimonials;
  })();
  
  theme.NewsletterPopup = (function() {
    function NewsletterPopup(container) {

      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
      this.cookieName = 'newsletter-' + sectionId;
      var isSubmit = false;
  
      if (!$container.length) {
        return;
      }
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      this.data = {
        secondsBeforeShow: $container.data('delay-seconds'),
        daysBeforeReappear: $container.data('delay-days'),
        cookie: Cookies.get(this.cookieName),
        testMode: $container.data('test-mode')
      };
  
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      
      // 判断 订阅状态
      this.newsletterMessagePopup();
      
      // Open modal if errors or success message exist
      if ($container.find('.errors').length || $container.find('.note--success').length) {
        if(typeof(gaDataDeploy) == "object")
        {
          if($container.find('.note--success').length)
              gaDataDeploy.elementClick(true).NewsletterPopupSignUpEvent();
        }
        this.openModal();
      }
  
      // Set cookie as opened if success message
      if ($container.find('.note--success').length) {
        this.closePopup(true);
        return;
      }
  
      
      
      
      /* 点击去个人账户中心   添加点击过后的cook  */
      var that = this
      $('#NewsletterPopup-newsletter-popup .prompt-messages').click(function(){
        that.closePopup(true);
        return ;
      })

      $('.newsletter-popup-register-succeed .newsletter-popup-register-succeed-box a').click(function(){
        that.closePopup(true);
        return ;
      })
      
      
      
      $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));
  
      if (!this.data.cookie || this.data.testMode) {
        this.initPopupDelay();
      }
      
      // 转盘事件
      // 记录是否点击提交
      $container.find(".newsletter-popup-btn").click(function(){
      	isSubmit = true
      }) 
      $('body').on('modalClose.' + $container.attr('id'),function(){
        if(!isSubmit && typeof(spinModalOpen) == "function")
        {
         	setTimeout(function(){
                spinModalOpen()
            },600) 
        }
      });
      // 转盘事件 end 
    }
  
    NewsletterPopup.prototype = $.extend({}, NewsletterPopup.prototype, {
      initPopupDelay: function() {
        setTimeout(function() {
          this.openModal();
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
  
      closePopup: function(success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode) {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
  
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
      },
      
      
      
       // 订阅弹框的展示块判断   
      //已经订阅的账号不会再次弹出弹框
      newsletterMessagePopup:function(){
         var newsletterMessage = "";
         if(getUrlParam("form_type") == "customer"){
           var login = '<a href="/account/login"> Login Now</a>';
           newsletterMessage = `Diese E-Mail-Adresse hat sich angemeldet. ${login}`;
         }

          var newsletterPo = getUrlParam("contact%5Bcontext%5D");
          var newsletterPo2 = getUrlParam('contact%5Btags%5D')
          var newsletterPo3 = getUrlParam('contact%5Bcontext%5D')
          var mod = location.hash;
          var anchorPoint = mod.replace("#","");
          var newsletterErrorObj
          if(newsletterPo == "footer")
          {
             var newsletterErrorObj = $(".footerSubscribeContent").find(".NewsletterPopupError");
             newsletterErrorObj.html(newsletterMessage);
             this.closePopup(true);
          }
          else if(newsletterPo == "popup")
          {
            $('.newsletter .lose').append('<div class="note--success"></div>'); 
            $('.newsletter .lose').css('display','block')
            $('.newsletter .succeed').css('display','none')
            this.closePopup(true);
          }
          else if(newsletterPo == "newsletter-page"){
             var newsletterErrorObj = $(".pageSubscribeContent").find(".NewsletterPopupError");
             newsletterErrorObj.html(newsletterMessage);
             this.closePopup(true);
          }
          else if((getUrlParam("customer_posted")=="true" && anchorPoint == "NewsletterPopup-form-success") || (getUrlParam("customer_posted")=="true" && anchorPoint == "NewsletterPopup-form"))
          {
            $('.newletter_success .success_from').append('<div class="note--success"></div>'); 
           	this.closePopup(true);
          } 
          
      },
  
      onLoad: function() {
        this.openModal();
      },
  
      onSelect: function() {
        this.openModal();
      },
  
      onDeselect: function() {
        this.modal.close();
      },
  	  openModal:function(){
        if(typeof(gaDataDeploy) == "object")
        { 
      		gaDataDeploy.elementClick(true).NewsletterOpenEvent();
        }
        this.modal.open();
      },
      onUnload: function() {}
    });
  
    return NewsletterPopup;
  })();
  
  theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
  
    var errors = {
      addressNoResults: theme.strings.addressNoResults,
      addressQueryLimit: theme.strings.addressQueryLimit,
      addressError: theme.strings.addressError,
      authError: theme.strings.authError
    };
  
    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '[data-map-overlay]'
    };
  
    var classes = {
      mapError: 'map-section--load-error',
      errorMsg: 'map-section__error errors text-center'
    };
  
    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
  
      $(selectors.section).addClass(classes.mapError);
      $(selectors.map).remove();
      $(selectors.mapOverlay).after(
        '<div class="' +
          classes.errorMsg +
          '">' +
          theme.strings.authError +
          '</div>'
      );
    };
  
    function Map(container) {
      this.$container = $(container);
      this.sectionId = this.$container.attr('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.$map = this.$container.find(selectors.map);
      this.key = this.$map.data('api-key');
  
      if (!this.key) {
        return;
      }
  
      // Lazyload API
      this.checkVisibility();
      $(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
    }
  
    function initAllMaps() {
      // API has loaded, load all Map instances in queue
      $.each(mapsToLoad, function(index, instance) {
        instance.createMap();
      });
    }
  
    function geolocate($map) {
      var deferred = $.Deferred();
      var geocoder = new google.maps.Geocoder();
      var address = $map.data('address-setting');
  
      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          deferred.reject(status);
        }
  
        deferred.resolve(results);
      });
  
      return deferred;
    }
  
    Map.prototype = $.extend({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
  
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
              $.getScript(
                'https://maps.googleapis.com/maps/api/js?key=' + this.key
              ).then(function() {
                apiStatus = 'loaded';
                initAllMaps();
              });
            }
          }
        }
      },
  
      createMap: function() {
        var $map = this.$map;
  
        return geolocate($map)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
  
              var map = (this.map = new google.maps.Map($map[0], mapOptions));
              var center = (this.center = map.getCenter());
  
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
  
              google.maps.event.addDomListener(
                window,
                'resize',
                $.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  $map.removeAttr('style');
                })
              );
            }.bind(this)
          )
          .fail(function() {
            var errorMessage;
  
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
  
            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              $map
                .parent()
                .addClass(classes.mapError)
                .html(
                  '<div class="' +
                    classes.errorMsg +
                    '">' +
                    errorMessage +
                    '</div>'
                );
            }
          });
      },
  
      checkVisibility: function() {
        if (theme.isElementVisible(this.$container, 600)) {
          this.prepMapApi();
          $(window).off(this.namespace);
        }
      },
  
      onUnload: function() {
        if (this.$map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        google.maps.event.clearListeners(this.map, 'resize');
      }
    });
  
    return Map;
  })();
  
  theme.Blog = (function() {
  
    function Blog(container) {
      this.tagFilters();
    }
  
    Blog.prototype = $.extend({}, Blog.prototype, {
      tagFilters: function() {
        var $filterBy = $('#BlogTagFilter');
  
        if (!$filterBy.length) {
          return;
        }
  
        $filterBy.on('change', function() {
          location.href = $(this).val();
        });
      },
  
      onUnload: function() {
  
      }
    });
  
    return Blog;
  })();
  
  // select 旋转框优化
  theme.customSelect = (function(){
	customSelectList = [];
	function customSelect($el,call)
	{
		this.$el = $el;
        this.call = call;
		this.config = {
			 customSelectTitle:".custom-select-title",
			 customSelectTitleOpenClass:"is-open",
			 customSelectList:".custom-select-list",
			 customSelectItem:".custom-select-item:not(.custom-select-title)",
			 customSelectItemActiveClass:"is-active",
			 customSelectItemActive:".custom-select-item.is-active",
		} 
		this.$customSelectTitle = $el.find(this.config.customSelectTitle);
		this.$customSelectList = $el.find(this.config.customSelectList);
		this.$customSelectItem = $el.find(this.config.customSelectItem);
		
		this.init();
        customSelectList.push(this);
	}
	
	customSelect.prototype = $.extend({}, customSelect.prototype, {
		init : function(){
			var that = this
			this.$customSelectList.hide();
			this.$customSelectTitle.show();
			this.$customSelectTitle.click(function(){
				if($(this).hasClass(that.config.customSelectTitleOpenClass))
					that.close();
				else
				{
					$.each(customSelectList,function(){
						this.close();
					})
					that.open();
				}
			})
			
			this.$customSelectItem.click(function(){
				that.itemClickAfter(this);
			})
			this.$el.find(this.config.customSelectItemActive).click();
		},
		open : function(){
			this.$customSelectList.slideDown(150);
			this.$customSelectTitle.addClass(this.config.customSelectTitleOpenClass);
		},
		itemClickAfter:function(obj){
			$(obj).parent().find(this.config.customSelectItem).removeClass(this.config.customSelectItemActiveClass);
			$(obj).addClass(this.config.customSelectItemActiveClass);
			var value = $(obj).attr("data-value") ? $(obj).attr("data-value") : $(obj).html();
			this.$customSelectTitle.html(value);
			this.close();
			
			// 阻止a跳转
			this.$customSelectTitle.find("a").click(function(event){
				event.preventDefault();
			})
            if(typeof this.call == "function")
              	this.call(value);
		},
		close : function(){
			this.$customSelectList.slideUp(150);
			this.$customSelectTitle.removeClass(this.config.customSelectTitleOpenClass);
		}
	
	
	})
	return customSelect;
  })();
  
  //手机端 国家或者币种选择 抽屉
  theme.countryCurrencyDrawers = (function(){
	function countryCurrencyDrawers()
	{
		this.config = {
			countryCurrencyId:"country-currency-box",
			countryCurrencyOpenButton:".silder-currency",
			countryCurrencyCloseButton:"#country-currency-box .country-currency-box-close",
			countryCurrencyBox:"#country-currency-box",
		} 
		this.drawer = new theme.Drawers(this.config.countryCurrencyId, 'country-currency');
		this.init();
	}
	
	countryCurrencyDrawers.prototype = $.extend({}, countryCurrencyDrawers.prototype, {
		init : function(){
			var that = this;
			$(this.config.countryCurrencyOpenButton).click(function(){
                theme.NavDrawer.close();
				that.drawer.open();
			})
			$(this.config.countryCurrencyCloseButton+", #MainContent").click(function(){
                if($(that.config.countryCurrencyBox).hasClass("drawer--is-open"))
                {
                  that.drawer.close();
                  theme.NavDrawer.open();
                }
			})
			
		}
	})
	return countryCurrencyDrawers;
  })();	

// pc切换国家修改币种
	theme.rightCountry = (function(){
	function rightCountry()
	{
		this.config = {
			countryCurrencyId:"right-country",
			countryCurrencyOpenButton:".announcement-bar .state .doubly-wrapper",
			countryCurrencyCloseButton:"#right-country .country-currency-box-close",
			countryCurrencyBox:"#right-country",
		} 
		this.drawer = new theme.Drawers(this.config.countryCurrencyId,'right-country');
		this.init();
	}
	
	rightCountry.prototype = $.extend({}, rightCountry.prototype, {
		init : function(){
			var that = this;
			$(this.config.countryCurrencyOpenButton).click(function(){
                
              	if($(that.config.countryCurrencyBox).hasClass("drawer--is-open")){
                    that.drawer.close();
                    $('#right-country').removeClass('transition');
                    $('.header-sticky-wrapper').css({"z-index":""})
                }else{
                  theme.NavDrawer.close();
    				that.drawer.open();
                	$('#right-country').addClass('transition');
                     $('.header-sticky-wrapper').css({"z-index":"26"})
                }
			})
            $('.state').hover(
              function() { // 鼠标移入
                setTimeout(function() {
                  if ($(that.config.countryCurrencyBox).hasClass("drawer--is-open")) {
                  } else {
                    theme.NavDrawer.close();
                    that.drawer.open();
                    $('#right-country').addClass('transition');
                    $('.header-sticky-wrapper').css({"z-index":"26"})
                    
                  }
                }, 200); // 延迟 200 毫秒执行
              },
              function() { // 鼠标移出
                
              }
            )

            $(document).on('mouseover', function(event) {
              if ($(window).width() >= 1280){
                if (!$(event.target).closest('#right-country').length && !$(event.target).closest('.state').length){
                  if ($(that.config.countryCurrencyBox).hasClass("drawer--is-open")) {
                    that.drawer.close();
                    $('#right-country').removeClass('transition');
                    $('.header-sticky-wrapper').css({"z-index":""})
                  }
                else{
                  
                }
               }
             }
             })
             
            $('.site-header .header-layout--center .header-item--icons .site-nav__icons .site-nav .current_country').click(function(){
              	theme.NavDrawer.close();
				that.drawer.open();
              	$('#right-country').addClass('transition');
                $('.header-sticky-wrapper').css({"z-index":"26"})
            })
            $('.announcement-bar .state .site-nav .current_country').click(function(){
              	theme.NavDrawer.close();
				that.drawer.open();
              	$('#right-country').addClass('transition');
                $('.header-sticky-wrapper').css({"z-index":"26"})
            })
            
			$(this.config.countryCurrencyCloseButton+", #MainContent").click(function(){
                if($(that.config.countryCurrencyBox).hasClass("drawer--is-open"))
                {
                  that.drawer.close();
                  $('#right-country').removeClass('transition');
                  $('.header-sticky-wrapper').css({"z-index":""})
                }
			})
			
		}
	})
	return rightCountry;
  })();




//搜索 抽屉
  theme.searchDrawers = (function(){
    var isturn = false;
	function searchDrawers()
	{
		this.config = {
          countryCurrencyId:"search-box",
          countryCurrencyOpenButton:".silder-search",
          countryCurrencyCloseButton:"#search-box .search_close_close",
          qText:"#HeaderSearchForm input[name='q']",
          searchForm:"#HeaderSearchForm "
		} 
		this.drawer = new theme.Drawers(this.config.countryCurrencyId);
		this.init();
	}
	
	searchDrawers.prototype = $.extend({}, searchDrawers.prototype, {
		init : function(){
			var that = this;
			$(this.config.countryCurrencyOpenButton).click(function(){
				that.drawer.open();
              	if(!isturn){
                   that.search('Pillowcase',"now");
                   isturn = true;
                }
			})
			$(this.config.countryCurrencyCloseButton).click(function(){

                  that.drawer.close();
			})
            $("#HeaderSearchForm input[name='q']").keyup(function(){
              var q = $(this).val();
              if(q == "")
                  return false;
                  that.search(q);
            })



            $('.trending-search .left').click(function(){
              var text = $(this).text();
              if(text =="Blitzangebot" || text=="Cyber-Montag" || text=="Ausverkauf" ){
                return
              }else{
                $("#HeaderSearchForm input[name='q']").val(text);
                that.search(text);
              }

            })
            
            
            var searchOrderId = 0;
          	//判断是否长时间输入文字
			function headerSearchFormUpdate(qq)
			{
				var q = $(that.config.qText).val()
				if(qq == q && q != "")
				{
				  that.search(q);
				}
			}
			// 文字更改 触发 判断是否更新
			$(this.config.qText).on("input propertychange",function(){
              	var q = $(that.config.qText).val()
				setTimeout(function(){
					headerSearchFormUpdate(q);
				},800)
            })
						
            $(this.config.searchForm).submit(function(){
            	var q = $(that.config.qText).val()
                if(q==""){
                    $('.predictive-results .trending-search p:first .left').click()
                    return false
                }
            })
			
		},
      search:function(q,a){
      	var a = a;
        var that = $("#HeaderSearchForm input[name='q']");
        that.parents(".site-header__search-container").find(".predictive-results").find("#PredictiveResults").html("");
        searchOrderId = randInt(100000,999999);
        var searchOrderIdNow = searchOrderId;
        // product
        var pageView = a == 'now' ? "recommend" : "ajax"
          $.get("/search",{"view":pageView,"q": q, "type": "product"},function(data){
              if(searchOrderIdNow != searchOrderId)
              return false;
          data=data.replace('class="Segment__Content"','class="Segment__Content swiper-container-search"');
          data=data.replace('class="Grid"','class="Grid swiper-wrapper"');
          re = new RegExp('class="productItem"',"g");
          data=data.replace(re,'class="productItem swiper-slide"');
          if(a == 'now'){
              reg = /\d+ results/g;
              data=data.replace(reg,'Trending Products');
          };

          that.parents(".site-header__search-container").find(".predictive-results").removeClass("hide");
          that.parents(".site-header__search-container").find(".predictive-results").find("#PredictiveResults").append(data);


          // 获取请求是否有数据
          var result = $('.productItem').length;
          if(result==0){
            $('.swiper-pagination').css({"display":"none"});
            $('.Segment').css({"display":"none"});
            $('.useless').css({"display":"block"});
          }else{
            $('.swiper-pagination').css({"display":"block"});
            $('.Segment').css({"display":"block"});
            $('.useless').css({"display":"none"});
          }



          var slide_num=2;
          if(slide_num > 0)
          {
            var swiper = new Swiper('.swiper-container-search', {
            
                slidesPerView: slide_num,
                spaceBetween: 20,
                slidesPerGroup : slide_num,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });
            //ga 埋点
            if(typeof(gaDataDeploy) == "object")
            {
              var searchDrawer = gaDataDeploy.config.searchDrawer.box;
              var searchDrawerListName = gaDataDeploy.config.searchDrawer.recommendlistName;
              if(pageView == "ajax")
                searchDrawerListName = gaDataDeploy.config.searchDrawer.listName;
              searchDrawerListName += q
              var searchPopupGaDataDeploy = gaDataDeploy.productListDeploy(searchDrawer,searchDrawerListName);
              swiper.on('slideChange',function(){
                  searchPopupGaDataDeploy.itemShowAction();
              })
            }
          }


        })
      }
	})
	return searchDrawers;
  })();


  //根据用户访问地址更新币种
  theme.updateCurrencyData = (function(){
    var that;
    var country = "";
	function updateCurrencyData()
	{
		this.config = {
		  doublyCurrencies:".header-layout select[name='doubly-currencies']",
          doublySwitchCookieName : "_g1606901417",
          isSelectDoublySwitchCookieName : "doubly_switch_selected", // 自动跳转币种
          isSelectCountryCookieName : "auto_country_selected", // 自动跳转国家
          mbCurrency:"#country-currency-box .currency-box .custom-select-item"
		} 
        that = this;
		this.init();
	}
	
	updateCurrencyData.prototype = $.extend({}, updateCurrencyData.prototype, {
		init : function(){
          	if(!Cookies.get(this.config.isSelectDoublySwitchCookieName)){
              // 自动跳转国家
              if(!Cookies.get(this.config.isSelectCountryCookieName))
              {
                $.get("https://get.geojs.io/v1/ip/country",function(country){
                  country = $.trim(country);
//                   console.log("country",country);
                  if(country=='DE'){
                      Cookies.set(that.config.isSelectCountryCookieName,"true",{ path: '/'});
                      window.location.replace("http://www.mommesilk.de");
                  }else if($.inArray(country, ["UK","GB"]) >= 0){
                      Cookies.set(that.config.isSelectCountryCookieName,"true",{ path: '/'});
                      window.location.replace("http://www.mommesilk.co.uk");
                  }
                })
              }
             
              if($(".doubly-wrapper").length)
                 this.updateCurrencyDataInterval = setInterval(that.updateCurrencyDataAction,1000);
    	   }
		},
		//更新币种
		updateCurrencyDataAction:function()
		{
			var doublyCurrencies = $(that.config.doublyCurrencies);
			var doublySwitchCookieName = "_g1606901417";
			var isSelectDoublySwitchCookieName = "doubly_switch_selected"; 
			if(doublyCurrencies.length)
			{
				if(!Cookies.get(that.config.isSelectDoublySwitchCookieName))
				{
                  	if(country)
                    {
                      	updateCurrencyDataGoAction(country);
                    }
                  	else
                    {
                      	$.get("https://get.geojs.io/v1/ip/country",function(country){
							updateCurrencyDataGoAction(country);
						})
                    }
				}
				clearInterval(that.updateCurrencyDataInterval);
			}
          
          	// 切换币种
            function updateCurrencyDataGoAction(country)
          	{
          		country = $.trim(country);
                var currency = that.byCountryGetCurrency(country);
//                 console.log(country,currency)
                // mb也有币种选择  所以我们优先使用模拟触发mb的币种选择
                if($(that.config.mbCurrency).length)
                {
                  $(that.config.mbCurrency+"[data-value='"+currency+"']").click()
                }
                else
                {
                  doublyCurrencies.val(currency).trigger('change');
                  doublyCurrencies.parent().find(".currency-switcher .current").html(currency);
                  doublyCurrencies.parent().find(".doubly-nice-select.currency-switcher .notranslate").removeClass("selected focus");
                  doublyCurrencies.parent().find(".doubly-nice-select.currency-switcher .notranslate[data-value='"+currency+"']").addClass("selected focus");
                }
                Cookies.set(isSelectDoublySwitchCookieName,"true",{ path: '/'});
          	}
		},
		byCountryGetCurrency:function(country)
		{
			var EUR_country = ["DE","AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE"];
			var currency = "USD"
            if(country == "US")
              	currency = "USD";	
			else if($.inArray(country, EUR_country) >= 0)
				currency = "EUR"
			else if($.inArray(country, ["UK","GB"]) >= 0)
				currency = "GBP"
			else if($.inArray(country, ["CA"]) >= 0)
				currency = "CAD"
			else if($.inArray(country, ["AU"]) >= 0)
				currency = "AUD"
			
			return currency;
		}
	})
	return updateCurrencyData;
  })(); 

  // 关于币种的问题
  theme.PriceCurrency = (function(){
		var currency = "select[name='doubly-currencies']";

        function PriceCurrency(){
        	this.init();
        }
        
        PriceCurrency.prototype = $.extend({}, PriceCurrency.prototype, {
      		init: function() {
              	var $currency = $("select[name='doubly-currencies']");
                //console.log($currency)
            	$currency.trigger('change');
            },
        })
		return PriceCurrency;
  })();
  // 用户 召回弹窗
  theme.CustomerRecall = (function(){
	  	/**
	   	 * 用户访问页面数超过 3 个, 静默页面是product 且超过 30秒
	     * 弹窗未填写 安静 7天
	     * 填写完成 不在弹出
	     */
		var selectors = {
          "box" : ".popup-recall-big-box",
          "time" : "data-time",
          "page" : "data-page",
		  "expiry" : 7,
          "page_num_session" : "customer_page_num2131s12",
          "silence_session" : "customer_silence_time23e23",  // 静默最后开始时间 每个页面打开都会更新一次
		  "recall_session" : "customer_recall23123e23",
        };
		this.modal;
		var that

        function CustomerRecall(modalId){
			this.config = {
				"attr_time":"",
				"attr_page":"",
				"modal_id":""
			}
			that = this;
			
			var box = selectors["box"]; 
			var attr_time_name = selectors["time"]; 
			var attr_page_name = selectors["page"]; 
			var attr_time = $(box).attr(attr_time_name);
			var attr_page = $(box).attr(attr_page_name);
			this.config.attr_time = attr_time
			this.config.attr_page = attr_page
			this.config.modal_id = modalId
			
			var session_recall = localStorage.getItem(selectors["recall_session"]);
			if(session_recall)
				return false;
			
			this.modal = new theme.Modals(this.config.modal_id,this.config.modal_id);
			$('body').on('modalClose.' + this.config.modal_id,function(){
				that.closePopup();	
			});	
        	this.init();
        }
        
        CustomerRecall.prototype = $.extend({}, CustomerRecall.prototype, {
      		init: function() {
				  if(Cookies.get(selectors["recall_session"]))
				  	return false;
					
            	  var silence_session = selectors["silence_session"]; 
                  var page_num_session = selectors["page_num_session"]; 
				  var time = this.getTimes();
				  
				  var oldSessionTime =  localStorage.getItem(silence_session);
				  var session_page_num = localStorage.getItem(page_num_session) ? localStorage.getItem(page_num_session) : 0;
				  
				  page_num = ++ session_page_num;
                  localStorage.setItem(page_num_session,page_num);
                  localStorage.setItem(silence_session,time);
          
				  setTimeout(function(){
						that.recallOperate()
				  },(this.config.attr_time * 1000)) 
            },
            recallOperate : function(){
				var session_time = localStorage.getItem(selectors["silence_session"]);
				var session_page_num = localStorage.getItem(selectors["page_num_session"]);
				var pageType = theme.pageType;
				
				if(pageType != "product")
					return false;

				if(Cookies.get(selectors["recall_session"]))
					return false;
     
				if(session_page_num < this.config.attr_page)
					return false;
								
            	var time = this.getTimes();
				var timeOverage = time - session_time;
				if(timeOverage < this.config.attr_time)
					return false;
					
				// 展示弹窗 记录session
				Cookies.set(selectors["recall_session"],1, { path: '/', expires: selectors['expiry'] });
				this.recallClearTraces();
								
            	this.modal.open();
                if(typeof(gaDataDeploy) == "object")
                { 
              		gaDataDeploy.elementClick(true).RecallPopupOpenEvent();
                }
            },
			// 关闭弹窗
			closePopup:function(){
				console.log("recall closePopup")
				var box = selectors["box"]; 
				var modal_id = this.config.modal_id
				// 判断是否订阅之后的页面  
				var isRecall = $(box).find("#"+modal_id).hasClass("popup-recall-box-reward");
				if(isRecall)
				{
					Cookies.set(selectors["recall_session"],1, { path: '/', expires: 365 * 99 });
				}
			},
			// 清楚记录数据
			recallClearTraces:function(){
				localStorage.removeItem(selectors["silence_session"]);
				localStorage.removeItem(selectors["page_num_session"]);
			},
			getTimes:function(){
				var time = Date.now();
				return parseInt((time / 1000));
			}
        })
		return CustomerRecall;
  })();

  // 购物车插件 价格监控 
  theme.MiniCartPriceUpdate = (function() {
	  
	  function MiniCartPriceUpdate()
	  {
			this.init();
	  }
	  
	  MiniCartPriceUpdate.prototype = $.extend({}, MiniCartPriceUpdate.prototype, {
		  
		  init:function(){
			var that = this;
			window.addEventListener('sc:discount.calculated',function(){
				that.miniCartUpdate();
			})  
			window.addEventListener('sc:discount.init',function(){
				that.miniCartUpdate();
			}) 
            window.addEventListener('sc:discount.remove',function(){
				ajaxMiniCartPoint("");
			}) 
		  },
		  miniCartUpdate:function(){
			var scDiscountData = sessionStorage.getItem("scDiscountData");
			scDiscountData = JSON.parse(scDiscountData);
			var subtotal_price =  scDiscountData["subtotal"];
            //console.log("subtotal_price",subtotal_price)
            if(!subtotal_price)
				return false;
			// mini cart 标语
            /*
			if(typeof(change_progress_price) == "function")
				change_progress_price(subtotal_price);
            */
			// mini cart 积分展示
			if(typeof(ajaxMiniCartPoint) == "function")
				ajaxMiniCartPoint(subtotal_price);
             
            // 购物车产品折扣展示
            var CodeText = scDiscountData.code
            var CodeProductList = scDiscountData.items
            var CodeDomList = $('#CartContainer .drawer__scrollable .ajaxcart__product')
            var itemNum = $('.site-nav .site-nav__link.js-drawer-open-cart .cart-item').text()
            if (itemNum>0){
              if (CodeDomList.length <= 0){
                  var that = this;
                  setTimeout(function(){
                    that.miniCartUpdate()
                  },300)
                  return true
              }
            }
            for(var i= 0;i<CodeDomList.length;i++){
              var CodeProductId = CodeDomList.eq(i).find('.grid').attr('id').replace('cart_','')
              var CodeQTY = 0;
              var CodeAmount = 0;
              var OriginalPrice
              for(var j= 0;j<CodeProductList.length;j++){
                if(CodeProductId == CodeProductList[j].variantId ){
                  if(CodeProductList[j].discounts.length>0){
                    for(var k= 0;k<CodeProductList[j].discounts.length;k++){
                      if(CodeProductList[j].discounts[k].amount>0){
                         CodeAmount += CodeProductList[j].discounts[k].amount
                      }
                    }
                  }
                  var CodeQtyItem = CodeProductList[j].quantity
                  CodeQTY += CodeQtyItem
                  OriginalPrice = CodeProductList[j].price
                }
              }
              var AveragePrice = OriginalPrice.toString().replace('.',',')
              var AveragePriceTow = OriginalPrice * CodeQTY
              var DiscountedPrice = ((AveragePriceTow - CodeAmount)/CodeQTY).toFixed(2)   
              DiscountedPrice = DiscountedPrice.toString().replace('.',',')
              var CodeHtml =`<span class="money OriginalPrice">€${AveragePrice}</span>
                             <span class="money DiscountedPrice">€${DiscountedPrice}</span>
                             <span class="free-gift">(${CodeText})</span>` 
              if($('#CartContainer .drawer__scrollable .ajaxcart__product .grid ').hasClass('isDiscountsMessage') != true){
                if(CodeAmount>0){
                  CodeDomList.eq(i).find('.ajaxcart__price').html(CodeHtml)
                }else{
                  CodeDomList.eq(i).find('.ajaxcart__price').html(`<span class="money DiscountedPrice">€${DiscountedPrice}</span>`)
                }
              }   
            }
            setTimeout(function(){
                $('body').trigger('added.ajaxProductDrawerUpdate');
            },1000)
		  }
	  })
	  return MiniCartPriceUpdate;
  })();
  // 折扣码使用 根据链接参数 ?discount=Cart-BOGO50  getUrlParam
  theme.urlUseDiscount = (function() {
	  
	  var urlParam = "discount";
	  function urlUseDiscount()
	  {
			this.init();
	  }
	  var that ;
	  urlUseDiscount.prototype = $.extend({}, urlUseDiscount.prototype, {
		  
		  init:function(){
			  that = this;
			  var discount = getUrlParam(urlParam);            
			  if(discount)
			  {
				  this.useDiscount(discount)
			  }
		  },
		  useDiscount:function(discount){
			  window.addEventListener('sc:discount.init',function(){
				  var scDiscountData = sessionStorage.getItem("scDiscountData");
				  scDiscountData = JSON.parse(scDiscountData);
				  if(scDiscountData["code"] != discount)
				  {
					  window.DiscountHero.discount.apply(discount)
				  }
			  })  
			  var discountUrl = "/discount/" + discount
			  $.get(discountUrl)  
		  }
	  })  
	  return urlUseDiscount;
   })();
   
  theme.Photoswipe = (function() {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      activeImage: '.slick-active .photoswipe__image'
    };
  
    function Photoswipe(container, sectionId) {
      this.$container = $(container);
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.$images;
      this.inSlideshow = false;
  
      if (this.$container.attr('data-zoom') === 'false') {
        return;
      }
  
      if (this.$container.attr('data-has-slideshow') === 'true') {
        this.inSlideshow = true;
      }
  
      this.init();
    }
  
    Photoswipe.prototype = $.extend({}, Photoswipe.prototype, {
      init: function() {
        var $trigger = this.$container.find(selectors.trigger);
        this.$images = this.$container.find(selectors.images);
        var items = [];
  
        // Init gallery on active image
        $trigger.on('click' + this.namespace, function(evt) {
          items = this.getImageData();
          if (this.inSlideshow) {
            var index = this.$container.find(selectors.activeImage).data('index');
          } else {
            var index = $(evt.currentTarget).data('index');
          }
          this.initGallery(items, index);
        }.bind(this));
      },
  
      getImageData: function() {
        var haveImages = false;
        var items = [];
        var options = {};
  
        this.$images.each(function() {
          var haveImages = true;
          var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
          var item = {
            msrc: smallSrc,
            src: $(this).data('photoswipe-src'),
            w: $(this).data('photoswipe-width'),
            h: $(this).data('photoswipe-height'),
            el: $(this)[0],
            initialZoomLevel: 0.5
          };
  
          items.push(item);
        });
  
        return items;
      },
  
      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
  
        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }
  
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  
        this.gallery.init();
        this.gallery.listen('afterChange', this.afterChange.bind(this));
      },
  
      afterChange: function() {
        if (this.inSlideshow) {
          var $slideshow = $('#ProductPhotos-' + this.sectionId);
          if ($slideshow.hasClass('slick-initialized')) {
            var newIndex = this.gallery.getCurrentIndex();
            $slideshow.slick('slickGoTo', newIndex);
          }
        }
      }
    });
  
    return Photoswipe;
  })();
  
  

  // Medium breakpoint is also set in theme.scss.liquid and inline throughout some templates.
  // Do not change values unless you know what you're doing.
  theme.bp = {};
  theme.bp.smallUp = 769;
  theme.bp.small = theme.bp.smallUp - 1;

  theme.config = {
    bpSmall: false,
    hasSessionStorage: true,
    hasLocalStorage: true,
    mediaQuerySmall: 'screen and (max-width: '+ theme.bp.small +'px)',
    mediaQuerySmallUp: 'screen and (min-width: '+ theme.bp.smallUp +'px)',
    youTubeReady: false,
    vimeoReady: false,
    vimeoLoading: false,
    isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
    isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()) || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1),
    stickyHeader: false,
    recentlyViewed: []
  };

  if (theme.config.isIpad) {
    document.documentElement.className += ' js-ipad';
  }

  theme.recentlyViewed = {
    recent: {}, // will store handle+url of recent products
    productInfo: {} // will store product data to reduce API calls
  };

  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    $('body').trigger('youTubeReady');
  }

  window.loadVimeo = function() {
    if (theme.config.vimeoLoading) {
      return;
    }

    if (!theme.config.vimeoReady) {
      theme.config.vimeoLoading = true;
      var tag = document.createElement('script');
      tag.src = "https://player.vimeo.com/api/player.js";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // Because there's no way to check for the Vimeo API being loaded
      // asynchronously, we use this terrible timeout to wait for it being ready
      checkIfVimeoIsReady()
        .then(function() {
          theme.config.vimeoReady = true;
          theme.config.vimeoLoading = false;
          $('body').trigger('vimeoReady');
        })
        .fail(function() {
          // No vimeo API to talk to
        });
    }
  }

  function checkIfVimeoIsReady() {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (!Vimeo) {
        return;
      }

      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  theme.init = function() {
    theme.setGlobals();
    theme.pageTransitions();
    theme.collapsibles.init();
    theme.rte.init();

    AOS.init({
      easing: 'ease-out-quad',
      once: true,
      offset: 60,
      disableMutationObserver: true
    });

    $(document.documentElement).on('keyup.tab', function(evt) {
      if (evt.keyCode === 9) {
        $(document.documentElement).addClass('tab-outline');
        $(document.documentElement).off('keyup.tab');
      }
    });

    // Change email icon to submit text
    $('.footer__newsletter-input').on('keyup', function() {
      $(this).addClass('footer__newsletter-input--active');
    });
  };

  theme.initSecondary = function() {
    theme.initQuickShop();
    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch.init();
    }
    theme.collectionTemplate.init();
    theme.customerTemplates.init();
    theme.videoModal();
  };

  theme.setGlobals = function() {
    theme.config.hasSessionStorage = theme.isStorageSupported('session');
    theme.config.hasLocalStorage = theme.isStorageSupported('local');

    if (theme.config.hasLocalStorage) {
      theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');

      if (theme.recentlyViewed.localStorage) {
        theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
      }
    }

    theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};

    if (theme.config.isTouch) {
      $('body').addClass('supports-touch');
    }

    enquire.register(theme.config.mediaQuerySmall, {
      match: function() {
        theme.config.bpSmall = true;
        $('body').trigger('matchSmall');
      },
      unmatch: function() {
        theme.config.bpSmall = false;
        $('body').trigger('unmatchSmall');
      }
    });

    enquire.register(theme.config.mediaQuerySmallUp, {
      match: function() {
        $('body').trigger('matchLarge');
      },
      unmatch: function() {
        $('body').trigger('unmatchLarge');
      }
    });
  };

  theme.loadImageSection = function($container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      $container.removeClass('loading loading--delayed').addClass('loaded');
    }

    function checkForLazyloadedImage() {
      return $container.find('.lazyloaded').length;
    }

    // If it has SVGs it's in the onboarding state so set as loaded
    if ($container.find('svg').length) {
      setAsLoaded();
      return;
    };

    if (checkForLazyloadedImage() > 0) {
      setAsLoaded();
      return;
    }

    var interval = setInterval(function() {
      if (checkForLazyloadedImage() > 0) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 80);
  };

  theme.isStorageSupported = function(type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.isElementVisible = function($el, threshold) {
    var rect = $el[0].getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    threshold = threshold ? threshold : 0;

    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (windowHeight + threshold) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  theme.pageTransitions = function() {
    if ($('body').data('transitions') == true) {
      var namespace = '.page-transition';

      // Hack test to fix Safari page cache issue.
      // window.onpageshow doesn't always run when navigating
      // back to the page, so the unloading class remains, leaving
      // a white page. Setting a timeout to remove that class when leaving
      // the page actually finishes running when they come back.
      if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
        $('a').off(namespace).on('click' + namespace, function() {
          window.setTimeout(function() {
            $('body').removeClass('unloading');
          }, 1200);
        });
      }

      // Add disable transition class to malito, anchor, and YouTube links
      $('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function() {
        $(this).addClass('js-no-transition');
      });

      $('a:not(.js-no-transition)').off(namespace).on('click' + namespace, function(evt) {
        if (evt.metaKey) return true;
        evt.preventDefault();
        $('body').addClass('unloading');
        var src = $(this).attr('href');
        window.setTimeout(function() {
          location.href = src;
        }, 50);
      });

      // iOS caches the page state, so close the drawer when navigating away
      $('a.mobile-nav__link').off(namespace).on('click' + namespace, function() {
        theme.NavDrawer.close();
      });
    }
  };

  theme.reinitSection = function(section) {
    for (var i = 0; i < sections.instances.length; i++) {
      var instance = sections.instances[i];
      if (instance['type'] === section) {
        if (typeof instance.forceReload === 'function') {
          instance.forceReload();
        }
      }
    }
  };

  theme.reinitProductGridItem = function($scope) {
    if (AOS) {
      AOS.refreshHard();
    }

    // Reload quick shop buttons
    theme.initQuickShop();

    // Refresh reviews app
    if (window.SPR) {
      SPR.initDomEls();SPR.loadBadges();
    }

    // Re-register product templates in quick view modals.
    // Will not double-register.
    sections.register('product-template', theme.Product, $scope);

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      $('body').removeClass('unloading');
    }
  };

  $(document).ready(function() {
    theme.init();

    window.sections = new theme.Sections();
    sections.register('header-section', theme.HeaderSection);
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('video-section', theme.VideoSection);
    sections.register('background-image', theme.BackgroundImage);
    sections.register('recently-viewed', theme.RecentlyViewed);
    sections.register('product', theme.Product);
    sections.register('product-recommendations', theme.Recommendations);
    sections.register('product-template', theme.Product);
    sections.register('collection-header', theme.CollectionHeader);
    sections.register('collection-sidebar', theme.CollectionSidebar);
    sections.register('collection-template', theme.Collection);
    sections.register('featured-content-section', theme.FeaturedContentSection);
    sections.register('testimonials', theme.Testimonials);
    sections.register('newsletter-popup', theme.NewsletterPopup);
    sections.register('map', theme.Maps);
    sections.register('blog', theme.Blog);
    sections.register('photoswipe', theme.Photoswipe);
    sections.register('footer-section', theme.FooterSection);

    theme.initSecondary();
    //new theme.updateCurrencyData();
    new theme.MiniCartPriceUpdate();
    new theme.urlUseDiscount();
  });
})(theme.jQuery);

/****************************************************************************** public.js **************************************************************************************************/
// JavaScript Document
// 获取滚动条的宽度
function getScrollbarWidth() {
	var oP = document.createElement('p'),
		styles = {
			width: '100px',
			height: '100px'
		}, i, clientWidth1, clientWidth2, scrollbarWidth;
	for (i in styles) oP.style[i] = styles[i];
	document.body.appendChild(oP);
	clientWidth1 = oP.clientWidth;
	oP.style.overflowY = 'scroll';
	clientWidth2 = oP.clientWidth;
	scrollbarWidth = clientWidth1 - clientWidth2;
	oP.remove();
	return scrollbarWidth;
}
// 获取浏览器真实宽度
function getWindowRealWidth()
{
  var scrollbarWidth = getScrollbarWidth();
  return $(window).width()+scrollbarWidth;
  
}
function getWidthSize()
{
 	windowRealWidth = getWindowRealWidth();
  	if(windowRealWidth > 1080)
      return "pc";
 	else if(windowRealWidth <= 1080 && windowRealWidth>768)
      return "pad";
 	else
      return "mb";
}
// 获取菜单的高度
function getMenuHeight()
{
  windowRealWidth = getWindowRealWidth();
  if(windowRealWidth > 1280)
    return "85";
  else if(windowRealWidth <= 1080 && windowRealWidth>768)
    return "145";
  else
    return "95";
}
// 随机整数
function randInt(start,end)
{
 var rand = parseInt(Math.random() * (end - start + 1) + start);
 return rand;
}
// 下雪
function snowflake(snowflakeBox)
{
	var snowflakeThis = this;
	this.speed = [8000,10000]; //雪花下落的速度
	// 定义块初始位置样式
	this.draw = function(odiv)
	{
		var speedH = 0;  
		var startPosLeft = Math.ceil(Math.random() * $(document).width());//设置雪花随机的开始x值的大小
		var oOpacity = this.getRandInt(6,10)/10;  //设置透明度
		var oLeft = startPosLeft+'px';
		var oTop = "-20px"; 
		var oColor = "#fff";
		var oFontSize = this.getRandInt(12,25)+"px";
		odiv.css({"opacity":oOpacity,"left":oLeft,"color":oColor,"font-size":oFontSize,"top":oTop});
		
		odiv.animate({"top":snowflakeBox.height() + 50,"left":parseInt(oLeft) + this.getRandInt(-100,100)+"px","opacity":"0"},
			this.getRandInt(this.speed[0],this.speed[1]),
			function(){
				odiv.remove();
			});
	}
	// 新增块
	this.snowflakeAdd = function()
	{
		var snowflakeOne = "<div class='snowflakeItem'>"; 
		snowflakeOne += this.randIcon();
		snowflakeOne += "</div>";
		
		snowflakeBox.append(snowflakeOne);   //把创建好的div放进flame中
		that = snowflakeBox.children(".snowflakeItem:last-child");
		this.draw(that);  //执行obj的draw方法
	}
	
	// 随机雪花
	this.randIcon = function()
	{
		var icon = ["❆"];	
		return icon[this.getRandInt(0,(icon.length-1))];
	}
	
	// 随机整数
	this.getRandInt = function(start,end)
	{
		var rand = parseInt(Math.random() * (end - start + 1) + start);
		return rand;
	}
	return this;
} 
// 倒计时
function countdown(endDate)
{
  function getLocalTime(i) {
	if (typeof i !== 'number') return;
	var d = new Date();
	var len = d.getTime();
	var offset = d.getTimezoneOffset() * 60000;
	var utcTime = len + offset;
	return new Date(utcTime + 3600000 * i);

  }
  var dayTime = 24*3600*1000;
  
  var nowDate = new Date(); //开始时间
  var nowDate = getLocalTime(+2);//new Date(); //开始时间
  var endDate = new Date(endDate.toString().replace(/-/g, "/")); //结束时间

  var dateDistance = endDate.getTime() - nowDate.getTime() //时间差的毫秒数
  if(dateDistance <= 0)
		return false;
  
  var days = Math.floor(dateDistance / dayTime);
  //计算出小时数
  var dayLeave1 = dateDistance % dayTime;
  var hours = Math.floor(dayLeave1 / (3600*1000));

  var hoursLeave1 = dayLeave1 % (3600*1000); 
  var minutes = Math.floor(hoursLeave1 / (60*1000));

  var minutesLeave = hoursLeave1 % (60*1000) ;
  var seconds = Math.round(minutesLeave / 1000);

  return {"d":days,"h":hours,"m":minutes,"s":seconds};

}

// 实例化 弹框类
function popupView()
{
	var popupView = new Object();
	/*
	title : 头部title
	width:  弹框宽度
	height  弹框高度
    style   popupViewBase 的样式
	shade   弹框遮罩层透明度
	content 弹框内容
	*/
	var popupViewShade = "<div class='popupViewShade'></div>";
	popupView.open = function(str){
		popuoViewBase = "<div class='popupViewBox'>";
		popuoViewBase += popupViewShade;
		popuoViewBase += "<div class='popupViewBase'>";
		popuoViewBase += "<div class='popupViewTopContent'>";
		popuoViewBase += "<span class='popupViewTopContentTitle'></span>";
		popuoViewBase += "<span class='popupViewTopContentClose'></span>";
		popuoViewBase += "";
		popuoViewBase += "</div>";
		popuoViewBase += "<div class='popupViewContent'></div>";
		popuoViewBase += "</div></div>";

		jQuery("body").css("overflow","hidden");		
		jQuery("body").append(popuoViewBase);
      	jQuery("body .popupViewBase").animate({"marginTop":0});
		jQuery("body .popupViewBox").animate({"opacity":1});
		jQuery("body .popupViewBox .popupViewBase .popupViewContent").html(str.content);
		if(!str.title)
			jQuery("body .popupViewTopContent").css("height",0);
		else
			jQuery("body .popupViewTopContent .popupViewTopContentTitle").html(str.title);
		if(str.width)
			jQuery("body .popupViewBase").css("width",str.width);
      	if(str.style)
			jQuery("body .popupViewBase").css(str.style);
		if(str.height)
			jQuery("body .popupViewContent").css("height",str.height);
		if(str.shade)
			jQuery("body .popupViewShade").css("opacity",str.shade);
		
		jQuery(".popupViewContent").animate({scrollTop:100},1);
		jQuery(".popupViewContent").animate({scrollTop:0},500);
		
		jQuery("body").find(".popupViewTopContentClose").click(function(){
			popupView.close(this);
		})
		jQuery("body").find(".popupViewShade").click(function(){
			popupView.close(this);
		})
		
	}
	popupView.close = function(that){
		jQuery(that).parents(".popupViewBox").remove();
		jQuery(that).remove();
		jQuery("body").css("overflow","auto");
	}
	// 关闭所有弹框
	popupView.closeAll = function(){
		jQuery(".popupViewBox").remove();
		jQuery("body").css("overflow","auto");
	}
	return popupView;
}

var popupView = popupView();

// 判断数据是否是json
function isJSON(str) 
{
    try{
        $.parseJSON(str)
        return true
    }catch (e) {
        return false
    } 
}



/** Event snippet for Mommesilk - Add to basket conversion page 
点击加购
**/
function gtag_add_to_cart(price){
  return false; // 黄康 2022-07-13
  gtag('event', 'conversion', {
    'send_to': 'AW-637520684/7XEfCKaLgPwBEKyW_68C',
    'value': price,
    'currency': 'EUR'
  });
  //console.log(price);
}
/* Event snippet for Mommesilk - Begin checkout conversion page 
checkout
*/
function gtag_checkout(price){
  return false; // 黄康 2022-07-13
  gtag('event', 'conversion', {
    'send_to': 'AW-637520684/9Uk-CI_e3_sBEKyW_68C',
    'value': price,
    'currency': 'EUR'
  });
  //console.log(price);
}

/* Event snippet for Mommesilk-Page view conversion page  
当前页面
*/
function gtag_page(){
  return false; // 黄康 2022-07-13
  gtag('event', 'conversion', {
      'send_to': 'AW-637520684/qPSLCIrg9PsBEKyW_68C',
      'value': 0.0,
      'currency': 'EUR'
  });
  
  //console.log("gtag_page");
}
gtag_page();



function mini_cart_recommend_add_to_cart(gasku)
{
    if(typeof ga == "function")
    {
        ga('send', 'event', 'GG_CUSTOM', 'cart_you_may_also_like', gasku, 1,true);
    }
}


// 程序睡眠  毫秒
function sleep(numberMillis) {
    var now = new Date();
    var exitTime = now.getTime() + numberMillis;
    while (true) {
        now = new Date();
        if (now.getTime() > exitTime)
        return;
    }
}



function mini_cart_recommend_add_to_cart(gasku)
{
    if(typeof ga == "function")
    {
        ga('send', 'event', 'GG_CUSTOM', 'cart_you_may_also_like', gasku, 1,true);
    }
}


function numAdd(id) {
  var idvar='#'+id;
  var numD = $(idvar);
  var num = numD.attr("data-to");
  var end = numD.attr("end-data");
  var time = parseInt(numD.attr("data-speed"));
  var i = 0.01;
  var timer = setInterval(function () {
    if ((i + time) >= num) {
      clearInterval(timer);
    }
    i = i+time;
    numD.html((Math.floor(i)/100).toFixed(2));
    if ((i + time) >= num) {
      numD.html(end);
    };
  }, 2)
  }

// 程序睡眠  毫秒
function sleep(numberMillis) {
    var now = new Date();
    var exitTime = now.getTime() + numberMillis;
    while (true) {
        now = new Date();
        if (now.getTime() > exitTime)
        return;
    }
}



$(function(){
	// pc
	
	// 打开事件 -- 弹框
	$(".site-header .header-layout--center .header-item--icons .site-nav__icons .doubly-wrapper,.site-header .header-layout--center .header-item--icons .site-nav__icons .site-nav .current_country").click(function(){
		if(typeof ga != "function")
			return false; 
		//console.log("打开事件 -- 弹框");	
		ga('send', 'event', 'GG_CUSTOM', 'open_site_nav', '', 1,true);
	})	
    
	// 点击切换币种
	$("#right-country").on("click",".currency-box .custom-select-list .custom-select-item",function(event){
		if(typeof ga != "function")
			return false; 
      
        //判断是否是自动触发 还是手动点击
      	if(typeof event.originalEvent == "undefined")
          return false
          
		var dataValue = $(this).attr("data-value");	
		var currency = dataValue.replace("Currency : ","")
		//console.log("点击切换币种");
		ga('send', 'event', 'GG_CUSTOM', 'currency_change',currency, 1,true);
	})
	
	// 点击切换国家
	$("#right-country").on("click",".country-box .custom-select-list .custom-select-item",function(event){
		if(typeof ga != "function")
			return false; 
        
        //判断是否是自动触发 还是手动点击
      	if(typeof event.originalEvent == "undefined")
          return false
      
		var country = $(this).find("a>span").html();	
		switch(country) {
          case "United Kingdom":
            country = "UK";
            break;
          case "United States":
            country = "US";
            break;
		  case "Deutschland":
            country = "DE";
            break;
        } 
		//console.log("点击切换国家");
		ga('send', 'event', 'GG_CUSTOM', 'country_change',country, 1,true);
	})
	
	// mb
	
	// 打开事件 -- 弹框
	$("#NavDrawer .silder-currency").click(function(){
		if(typeof ga != "function")
			return false; 
		//console.log("打开事件 -- 弹框");	
		ga('send', 'event', 'GG_CUSTOM', 'open_site_nav', '', 1,true);
	})	
    
	// 点击切换币种
	$("#country-currency-box").on("click",".currency-box .custom-select-list .custom-select-item",function(event){
		if(typeof ga != "function")
			return false; 
      
        //判断是否是自动触发 还是手动点击
      	if(typeof event.originalEvent == "undefined")
          return false
          
		var dataValue = $(this).attr("data-value");	
		var currency = dataValue.replace("Currency : ","")
		//console.log("点击切换币种"+currency);
		ga('send', 'event', 'GG_CUSTOM', 'currency_change',currency, 1,true);
	})
	
	// 点击切换国家
	$("#country-currency-box").on("click",".country-box .custom-select-list .custom-select-item",function(event){
		if(typeof ga != "function")
			return false; 
        
        //判断是否是自动触发 还是手动点击
      	if(typeof event.originalEvent == "undefined")
          return false
      
		var country = $(this).find("a>span").html();	
		switch(country) {
          case "United Kingdom":
            country = "UK";
            break;
          case "United States":
            country = "US";
            break;
		  case "Deutschland":
            country = "DE";
            break;
        } 
		//console.log("点击切换国家"+country);
		ga('send', 'event', 'GG_CUSTOM', 'country_change',country, 1,true);
	})
})




/**  使用折扣码监控事件 **/
$(function(){
	
	var cartDrawer = $("#CartDrawer");
	
	// 点击事件
	function scDiscountApplyClickEvent()
	{
		//console.log("scDiscountApplyClickEvent",cartDrawer.find(".scDiscount__container form #submit").length)
		if(cartDrawer.find(".scDiscount__container form #submit").length > 0)
		{
			cartDrawer.find(".scDiscount__container form #submit").click(function(){
				var discountVal =  getScDiscount();
				if(typeof ga != "function")
					return false; 
				//console.log("点击事件",discountVal)
				ga('send', 'event', 'minicartUseCoupon_all', 'submitCoupon', discountVal, 1,true);
			})
		}
		else
        {
			setTimeout(function(){
				scDiscountApplyClickEvent();	
			},1000)
        }
	}
	scDiscountApplyClickEvent();
	
	// 点击删除事件
	cartDrawer.on("click",".scDiscount__container .sc_simple-info .code .button",function(){
		var discountVal =  $(this).parent().find(".code-name").attr("title")
		if(typeof ga != "function")
			return false; 
		//console.log("点击删除事件",discountVal)
		ga('send', 'event', 'minicartUseCoupon_all', 'deleteCoupon', discountVal, 1,true);
	})
	
	// discount 内容改变事件
	cartDrawer.on("change",".scDiscount__container form #code",function(){
		var discountVal =  getScDiscount()
		if(typeof ga != "function")
			return false; 
		//console.log("内容改变事件",discountVal)
		ga('send', 'event', 'minicartUseCoupon_all', 'FillInCoupon', discountVal, 1,true);
	})
	
	
	function getScDiscount()
	{
		var discountVal = cartDrawer.find(".scDiscount__container #code").val();
		return discountVal;
	}
})
/**  使用折扣码监控事件end **/
/************************************************************************************************* public.js end **************************************************************************/



$(".tag_title .tag .top").click(function(){

  if($(this).parent('.tag').hasClass('true')){
      $(this).parent('.tag').removeClass("true");
    }else{
      $(".tag_title .tag").removeClass("true");
      $(this).parent('.tag').addClass("true");
      $(this).parent('.tag').siblings(".bottom").find(".tab_content_text").find(".tag_content").removeClass("true");
      $(this).siblings(".bottom").find(".tab_content_text").find(".tag_content").addClass("true");
    }

})

// 情侣睡衣TAB切换
$(".womensize").click(function(){
  $('.womensize').addClass('colorblack');
  $('.mensize').removeClass('colorblack');
  $(".women").addClass("displaysize");
  $(".men").removeClass("displaysize");
});
$(".mensize").click(function(){
  $('.mensize').addClass('colorblack');
  $('.womensize').removeClass('colorblack');
  $(".men").addClass("displaysize");
  $(".women").removeClass("displaysize");
});




$('.variant-input').click(function(){
	$(this).parent().parent().find('span').find('span').text($(this).attr('data-value'));

});

$(".select_options").change(function(){
	$(this).parent().parent().find('.variant__label-info span').text($(this).val());
})

/*
$('.color-swatch').click(function(){
  		var color=$(this).parent().attr('data-value');
  		$('.product__thumb-item').each(function(){
        	$(this).attr("data-color");
          if ($(this).attr("data-color") == color){
              $(this).css('display','block');
          }else{
          	  $(this).css('display','none');
          }
        })
	}
);
*/

$(".video-img").click(function(){
  $(this).hide();
  $("#video-des")[0].play();
})
$("#video-des").click(function(){
  $('.video-img').show();
  $("#video-des")[0].pause();
})






// 订单最终价格 subtotal_price
function change_progress_price(subtotal_price){
      // 免邮的价格         
    var freeShippingPrice = 59; 
  //购物车 折扣标语展示
    var saleExtraInfoHtml = "";
    
    if (subtotal_price >= 450 ){
        saleExtraInfoHtml = `<div class="event-information">110€ Rabatt ab 450€. Code: MOM110</div>` 
    }
    else if (subtotal_price >= 299 ){
        saleExtraInfoHtml = `<div class="event-information">50€ Rabatt ab 250€. Code: MOM50</div>
                             <div class="event-information">110€ Rabatt ab 450€. Code: MOM110</div>` 
    }
    else if (subtotal_price >= 199 ){
        saleExtraInfoHtml = `<div class="event-information">50€ Rabatt ab 250€. Code: MOM50</div>
                             <div class="event-information">Gratis Seidenkissenbezug ab 299€</div>` 
    }
    else if (subtotal_price >= 99 ){
        saleExtraInfoHtml = `<div class="event-information">25€ Rabatt ab 150€. Code: MOM25</div>
                             <div class="event-information">Gratis Haargummi-Set ab 199€</div>` 
    }
    else if (subtotal_price >= 59 ){
        saleExtraInfoHtml = `<div class="event-information">Glückwunsch. Sie haben kostenlosen Versand.</div>
                             <div class="event-information">Gratis Schlafmaske ab 99€</div>` 
    }
    else if (subtotal_price >= freeShippingPrice ){
        saleExtraInfoHtml = `<div class="event-information">Sie sind xxx weit von gratis Versand.</div><div class="event-information">Glückwunsch. Sie haben kostenlosen Versand.</div>` 
    }
    else if (subtotal_price > 0 ){
        var char_value_price= freeShippingPrice - subtotal_price ;
        char_value_price = Math.floor(char_value_price * 100) / 100
        saleExtraInfoHtml = `<div class="event-information sale-extra-text">Sie sind <span id="sale-extra">${char_value_price.toString()}€</span> weit von gratis Versand.</div>
        `
    }
    else{
    	saleExtraInfoHtml = `<div class="event-information">25€ Rabatt ab 150€. Code: MOM25</div>
                             <div class="event-information">50€ Rabatt ab 250€. Code: MOM50</div>
                             <div class="event-information">110€ Rabatt ab 450€. Code: MOM110</div>
          `
    }


    //console.log(saleExtraInfoHtml)
	
	var saleExtraInfo = $("#sale-extra-info");
    if(saleExtraInfo.hasClass('slick-initialized'))
		saleExtraInfo.slick("unslick")
    saleExtraInfo.html(saleExtraInfoHtml);
    
    //购物车 折扣标语轮播
    var SlickDom = $("#CartDrawer .freehippingprice .title")
    function eventInformation(){
    	if(SlickDom.hasClass('slick-initialized'))
            SlickDom.slick("unslick")
        SlickDom.slick({
            arrows: false,
            slidesToShow:1,
            slidesToScroll:1,
            autoplay:false,
            draggable:true,
            vertical:true,
            verticalSwiping:true,
        })

    }
    eventInformation()
    if(CartDomTime){
      clearInterval(CartDomTime)
    }
    CartDomTime = setInterval(function (){
      $("#CartDrawer .freehippingprice .title").slick('slickPrev')
    },2000)
}	

  




 
    
function addnote(){
  $('#NoteDrawer').addClass('drawer--is-open')
}
function edit_note(){
  $('#NoteDrawer').addClass('drawer--is-open');
}
function edit_remove(){
  theme.cart.updateNote('');
  document.getElementsByClassName('cart-note')[0].innerHTML=
    '<div class="image"><img src="https://cdn.shopify.com/s/files/1/0422/9745/8849/files/buy-gift.svg?v=1597656338"></div>'+
    '<div class="info">Want This a Gift?</div>'+
    '<div class="addnote" onclick="addnote()">Add a Note.</div>';
}

//wm add to cart gift wrap
function addtocartall(){
  if($('.addcheckbox').hasClass('addcheckboxtrue')){
     $('.addcheckbox').removeClass('addcheckboxtrue')
    }else{
	 $('.addcheckbox').addClass('addcheckboxtrue')
    }
}

function addtocartshowinfo(){
	$('#addalltoproduct').addClass('modal--is-active')
}
function closeshowinfo(){
	$('#addalltoproduct').removeClass('modal--is-active')
}
$('.content_title_1').click(function(){
  	$(this).parent().find('.content_title_1').removeClass('active');
    $(this).addClass('active');
  	let id_str = $(this).attr('data');
  	$('.content_calalog_1').removeClass('display');
  	$('#'+id_str).addClass('display');
  })

/*广告统计*/
function obapi_add_tocart(){
  	
	if(typeof(obApi) == "function")
    {
      obApi('track', 'AddToCart');
    }
}
function obapi_checkout(){
  	
	if(typeof(obApi) == "function")
    {
      obApi('track', 'checkout');
    }
}
function obapi_subscription(){
  	
	if(typeof(obApi) == "function")
    {
      obApi('track', 'subscription');
    }
}
/*广告统计*/  


 


 



// 搜索遮罩层
$('.search_close_close').click(function(){
     $('.site-header__search-container').removeClass("is-active");
  	 $('.site-header__search-input').val("")
})
$(".js-search-header").click(function(){
  $('.site-header__search').css({"display":"block"});
  $('.site-header__search').addClass("is-active");
})








function cart_recommend_ajax_product()
{
  var timestamp1 = Date.parse( new Date());
  var cartContainer = $("#CartContainer");
  
  if(theme.miniRecommendAdd && !theme.miniAddToCartTop)
    cartContainer.scrollTop(cartContainer[0].scrollHeight)
  $.get("/cart?"+timestamp1,{"view":"recommend"},function(data){
    $(".cart-recommend-box").html(data);
    $('.cart-recommend-box.cart-recommend-freebie-box').html($("<div>"+data+"</div>").find(".cart-giveaway-box"))
    $('.cart-recommend-box.cart-recommend-mb-box').html($("<div>"+data+"</div>").find(".cart-recommend-content"))
	$(".cart-recommend-box").removeClass("cart-recommend-box-false").removeClass("cart-recommend-box-true");
	$("#CartDrawer").removeClass("CartDrawer-recommend-false").removeClass("CartDrawer-recommend-true");
    $('.cart-recommend-box.cart-recommend-mb-box').css({"height":"unset"});
	if($(".cart-recommend-box").find(".cart-recommend-product-list").data("product-count") > 0)
	{
		$(".cart-recommend-box").addClass("cart-recommend-box-true");
		$("#CartDrawer").addClass("CartDrawer-recommend-true");
		if(!$("#CartDrawer .ajaxcart__row").length)
		{
			$("#CartDrawer").removeClass("CartDrawer-recommend-false").removeClass("CartDrawer-recommend-true");
			$("#CartDrawer").addClass("CartDrawer-recommend-false");
		}
        else
        {
            miniCartRecommendIsEye = false;
			miniCartChangeAction()        
        }
        $(".cart-recommend-box .AddToCartForm .product-image div.image").addClass("aos-init aos-animate")

        if(!theme.miniAddToCartTop) 
        {   
            var scInitScroll = false;
            if(theme.miniRecommendAdd )
            {
                scInitScroll = true;
                cartContainer.scrollTop(cartContainer[0].scrollHeight)
            }
            window.addEventListener('sc:discount.calculated',function(){
              if(scInitScroll)
              {
                setTimeout(function(){
                    cartContainer.animate({"scrollTop":cartContainer[0].scrollHeight},1000)
                },500)
              }
              scInitScroll = false;
            }) 
        }
        
        $(".cart-recommend-box.cart-recommend-mb-box .AddToCartForm").on("submit",function(){
            theme.miniRecommendAdd = true; 
        })
	}
	else
	{
		$(".cart-recommend-box").addClass("cart-recommend-box-false");
		$("#CartDrawer").addClass("CartDrawer-recommend-false");
	}
    theme.miniRecommendAdd = false;
    
	var cartRecommendMbSlick = $("#CartDrawer").find(".cart-recommend-mb-box .cart-recommend-product-list")	 
    //cartRecommendMbSlick.slick({
		//dots:true,
		//arrows:false,
		//autopaly:true,
		//touchThreshold:10
    //})
    if(typeof(gaDataDeploy) == "object")
    {
     	 gaDataDeploy.cartRecommendDeploy()     
         var cartRecommendDeploy = gaDataDeploy.productListDeploy($(gaDataDeploy.config.miniCartRecommendDrawer.box_class),gaDataDeploy.config.miniCartRecommendDrawer.listName);
		 // pc
      	 gaDataDeploy.config.miniCartRecommendDrawer.box.find(".drawer__scrollable").scroll(function(){
			 cartRecommendDeploy.itemShowAction();
		 })
		 // mb
		 cartRecommendMbSlick.on("afterChange",function(event, slick, currentSlide, nextSlide){
            cartRecommendDeploy.itemShowAction();
         })	
		 
      	 var miniCartBtn = $(".header-wrapper .header-item .js-drawer-open-cart");
		 miniCartBtn.click(function(){
           setTimeout(function(){
           	cartRecommendDeploy.itemShowAction();
           },600)
		 })
    }
  })
}
   
// 解决下购物车在none的 slick的问题 Jack 2021-11-08
$(".js-drawer-open-cart").click(function(){
  var recommendProductList =  $("#CartDrawer").find(".cart-recommend-mb-box .cart-recommend-product-list");
  function isInitialized($slider) {
      return $slider.length && $slider.hasClass('slick-initialized');
    }
  if(isInitialized(recommendProductList))
  {
    setTimeout(function(){
    	recommendProductList.slick("setPosition");
    },400)
  }
})



// 统计代码
var miniCartRecommendIsEye = false;
var miniCartRecommendBoxClass = "#CartDrawer";
var miniCartRecommendProductListClassBase = ".cart-recommend-box";
var miniCartRecommendProductListClass = ".cart-recommend-box";
var miniCartRecommentProductClass = ".mini-product-item-variant";
var miniCartBrand = "mommesilk";

// 展示
function miniCartRecommendProducyEye()
{
	if(typeof ga != "function")
		return false; 
	if(miniCartRecommendIsEye)
		return false;
	
	var miniCartRecommendProductList = $(miniCartRecommendProductListClass);
	if(miniCartRecommendProductList.length < 1)
		return false;	
	// 判断推荐产品是否加载完成品就还没加载好
	if($(miniCartRecommendProductListClass).find(miniCartRecommentProductClass).length < 1 )
		return false; 
	var miniCartRecommendProductList = $(miniCartRecommendProductListClass);		
	if(!miniCartRecommendIsEye)
	{
		var scrollTop = $(window).scrollTop();
		var winH = $(window).height();
		var recommendProductListOffset = miniCartRecommendProductList.offset()
		var recommendProductListTop = recommendProductListOffset.top;
		var recommendProductListLeft = recommendProductListOffset.left;
		if(recommendProductListLeft <= 0)
		  return false;
		var recommendProductListH = miniCartRecommendProductList.height();
					
		if(scrollTop + winH >= (recommendProductListH / 2) + recommendProductListTop)
		{
			ga('set', '&cu', 'USD');
			miniCartRecommendProductList.find(miniCartRecommentProductClass).each(function(k,v){
				var impression = {
					'name': $(this).find(".grid-product--title").html(), 
					'id': $(this).attr("data-id"), 
					'price': miniCartGetProductPrice($(this).attr("data-price")),
					'brand': miniCartBrand,  
					'category': "",  
					'list': 'cartYouMayAlsoLike',
					'position': k + 1  
				};
				//console.log(impression);
				ga('ec:addImpression',impression); 
			})
			ga('send', 'pageview');
			//console.log("miniCartRecommendProducyEye pageview");
			miniCartRecommendIsEye = true
		}
	}

}
//点击跳转
function miniCartProductRecommendClick()
{	
	$(miniCartRecommendBoxClass).on("click",miniCartRecommendProductListClassBase+" .grid-product__link",function(event){
		if(typeof ga != "function")
			return false; 
		
		var productItem = $(this).parents(miniCartRecommentProductClass);
		ga('ec:addProduct', {
			'id': productItem.attr("data-id"),
			'name':productItem.find(".grid-product--title").html(), 
			'price': miniCartGetProductPrice(productItem.attr("data-price")),
			'brand':miniCartBrand,  
			'category': ""// 分类信息
		});
		ga('ec:setAction', 'click', {list: 'cartYouMayAlsoLike'});
		ga('send', 'event', 'UX', 'click', 'Results', {
			hitCallback: function() {
			}
		});
		//console.log("被点击的商品"+productItem.find(".grid-product--title").html());
	})
}

function miniCartGetProductPrice(price)
{
	var productPrice = 0
	productPrice = price / 100;
	return productPrice;
}

function miniCartRecommentBoxClassUpdate()
{
	var pcClass = ".cart-recommend-pc-box"
	var mbClass = ".cart-recommend-mb-box"
	if($(pcClass).css("display") == "none")
		miniCartRecommendProductListClass = mbClass;
	else
		miniCartRecommendProductListClass = pcClass;
}

function miniCartChangeAction()
{
	miniCartRecommentBoxClassUpdate()
	miniCartRecommendProducyEye();
}
$(function(){
	$(window).resize(function(){
		miniCartChangeAction();
	})
	$(window).scroll(function(){
		miniCartChangeAction();
	})
	document.addEventListener('scroll', function (event) {
		if ($(event.target).hasClass("drawer__scrollable")) 
			miniCartChangeAction();
	}, true);
	$(".site-nav__link.js-drawer-open-cart").click(function(){
		miniCartChangeAction();
	})
	
	miniCartChangeAction();
	miniCartRecommendProducyEye();
	miniCartProductRecommendClick();
})


//加购
function mini_cart_recommend_add_to_cart(gasku)
{
	if(typeof ga == "function")
	{
		ga('send', 'event', 'GG_CUSTOM', 'cartYouMayAlsoLike', gasku, 1,true);
	}
}



  
//枕套触发点击出现订阅弹窗

function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg);  //匹配目标参数
  if (r != null) return unescape(r[2]); return null; //返回参数值
}

// 顶部导航栏的二级菜单消失过快优化
var terminate;

$('.site-nav--has-dropdown').mouseleave(function(){
  $(this).find('.megamenu').css('opacity','1');
  $(this).find('.megamenu').css('display','block');
  $(this).find('.megamenu').css('visibility','inherit');
   terminate = setTimeout(function(){
     $('.site-nav--has-dropdown').find('.megamenu').css('display','none');
  },350)
})
function colseTerminate(){
	 clearTimeout(terminate);
}
$('.site-nav--has-dropdown').mouseenter(function(){
  colseTerminate();
  $(this).find('.megamenu').css('display','block');
  $(this).siblings().find('.megamenu').css('display','none');
})

$(function(){
	var NewsletterPopup =  new theme.Modals('NewsletterPopup-newsletter-popup', 'newsletter-popup-modal')
    // 点击打开订阅弹框
	$("#MainContent").on("click",".product_signup_each_info .signUpButton",function(){
		event.preventDefault();
		NewsletterPopup.open();
	
	})
    
    $("#MainContent").on("click",".code-box .code-text-box .signUpButton",function(){
      event.preventDefault();
      NewsletterPopup.open();

    })


    $("#MainContent").on("click",".wm_pro_saleinfo li .signUpButton",function(){
      event.preventDefault();
      NewsletterPopup.open();

    })
    
    
    //侧导航
    $("#NavDrawer").on("click",".silder-botton .silder-botton-a.ABONNIEREN",function(){
      event.preventDefault();
      NewsletterPopup.open();
    })
    //底部悬浮导航点击事件
    $('.suspension-nav .suspension-nav-button-box').click(function(){
      	var productId = $('.suspension-nav').attr('data-product-id')
        var hrefAttr = `#AddToCartForm-${productId}`
        $(this).attr("href",`${hrefAttr}`);
        $('html, body').animate({scrollTop: $(`${hrefAttr}`).offset().top}, 500)


    })
})



function miniVariantAction(obj)
{
	obj.find(".mini-product-item-variant .grid-product--option .grid-product--variant-list").find(".grid-product--variant,.color-swatch--small").click(function(){
    	
        var productItem = $(this).parents(".mini-product-item-variant")
        $(this).siblings().removeClass("is-active");
        $(this).addClass("is-active");
    	if($(this).parents(".grid-product--option").hasClass("grid-product--option-color"))
        {
        	
        	var dataValue = $(this).attr("data-value");
            var dataVariantImage = $(this).attr("data-variant-image");
            productItem.find(".grid-product__link img").attr("src",dataVariantImage).removeAttr("data-srcset").removeAttr("srcset");
            $(this).parents(".grid-product--option").find(".grid-product--option-value").html(dataValue);        	
        }
        else
        {
          	var dataValue = $(this).attr("data-value");
        	$(this).parents(".grid-product--option").find(".grid-product--option-value").html(dataValue);
        }
        productVariantIdUpdate(productItem);
    })
    
    function productVariantIdUpdate(productItem)
    {
    	var selectVariantId = [];
        $.each(productItem.find(".grid-product--option .grid-product--variant-list"),function(k,v){
        	var thisSelectVariantId = $(this).find(">.is-active").attr("data-variant-id").split(',');
        	if(selectVariantId.length > 0)
            	selectVariantId = getArraySame(selectVariantId,thisSelectVariantId);
            else
            	selectVariantId = thisSelectVariantId;
        })
        //去除空值
        var selectVariantId = $.grep(selectVariantId,function(n,i){  
            return n;  
        },false); 
    	
        productItem.find('input[name="id"]').val(selectVariantId[0]);
    }
    function getArraySame(arr1,arr2)
    {
    	var sameArr = $.grep(arr1, function(n,i){
        	return $.inArray(n, arr2)>-1; 
        });
		return sameArr;
    }  	
}



 
$("#CartDrawer").on("click",".cart-giveaway-title",function(){
	  var giveawayOff = $("#CartDrawer").find(".cart-giveaway-box").offset();
	  var cartProductOff = $("#CartDrawer").find("#CartContainer>.drawer__scrollable").offset();
	  var cartProductScrollTopNow = $("#CartDrawer").find("#CartContainer>.drawer__scrollable").scrollTop();
	  var cartProductScrollTopNew = giveawayOff.top + cartProductScrollTopNow - cartProductOff.top 
	  $("#CartDrawer").find("#CartContainer>.drawer__scrollable").animate({"scrollTop":cartProductScrollTopNew });
  })




/* 获取对应的积分数*/
function getPricePoints(price)
{
  	var point = "1" 
  	var productPoints = Math.round(price / 100 * point)
	return productPoints
}
// 折扣码积分变动
function ajaxMiniCartPoint(subtotal_price)
{
	var miniCartPointObj = $("#CartContainer .ajaxcart__points")
	var pricePoint = 0;
	if(subtotal_price == "")
    	pricePoint = miniCartPointObj.attr("data-points");
    else
        pricePoint = getPricePoints(subtotal_price*100)
   
	var pricePointMsg =  'Reward %Points% Points'.replace('%Points%',pricePoint)
    miniCartPointObj.html(pricePointMsg);
}

/* ajax-cart模板js里面   比较运算的js */

Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
 
    switch (operator) {
        case '==':
            return (v1 == v2) ? options.fn(this) : options.inverse(this);
        case '===':
            return (v1 === v2) ? options.fn(this) : options.inverse(this);
        case '!=':
            return (v1 != v2) ? options.fn(this) : options.inverse(this);
        case '!==':
            return (v1 !== v2) ? options.fn(this) : options.inverse(this);
        case '<':
            return (v1 < v2) ? options.fn(this) : options.inverse(this);
        case '<=':
            return (v1 <= v2) ? options.fn(this) : options.inverse(this);
        case '>':
            return (v1 > v2) ? options.fn(this) : options.inverse(this);
        case '>=':
            return (v1 >= v2) ? options.fn(this) : options.inverse(this);
        case '&&':
            return (v1 && v2) ? options.fn(this) : options.inverse(this);
        case '||':
            return (v1 || v2) ? options.fn(this) : options.inverse(this);
        default:
            return options.inverse(this);
    }
})




// 侧导航距离顶部的距离   优化    2023-04-22
$(function(){
  $('.header-sticky-wrapper .header-wrapper .header-item--left.header-item--navigation .site-nav .js-drawer-open-nav').click(function(){
    //顶部导航高度
    //滚动距离
    var scrollT = $(window).scrollTop()
    //header高度
    var all_header = 0
    if ($(window).width() >= 1280) {
      var all_header = 112
    }else{
      if ($(window).width() >= 768){
        var all_header = 97
      }else{
        var all_header = 89
      }
    }
    var HeaderTop = all_header - 1
    if(scrollT > HeaderTop -1){
      NavDrawerTop = HeaderTop
    }else{
      NavDrawerTop = HeaderTop - scrollT
    }
    $('#NavDrawer').css('margin-top',`${NavDrawerTop}px`)
  })
})


//底部订阅和page订阅
$(function(){
  var newsletterMessage = "";
  if(getUrlParam("form_type") == "customer"){
    console.log(1)
    var login = '<a href="https://www.mommesilk.com/account/login"> Login Now</a>';
    newsletterMessage = `This email address has subscribed. ${login}`;
  }
  var newsletterPo = getUrlParam("contact%5Bcontext%5D");
  var newsletterPo2 = getUrlParam('contact%5Btags%5D')
  var newsletterPo3 = getUrlParam('contact%5Bcontext%5D')
  if(newsletterPo == "footer"){
     var newsletterErrorObj = $(".footerSubscribeContent").find(".NewsletterPopupError");
     newsletterErrorObj.html(newsletterMessage);
  }else if(newsletterPo == "newsletter-page"){
    var newsletterErrorObj = $(".pageSubscribeContent").find(".NewsletterPopupError");
    newsletterErrorObj.html(newsletterMessage);
  }
})


// 被子类尺寸选择器
function sizeDropdown(){
  document.querySelector('.variant-input-wrap-dropdown').classList.toggle('active')
}
function toggleDropdown(name){
  document.querySelector('.variant-input-wrap-dropdown').classList.toggle('active');
  document.querySelector('.select_info').innerText=name
}


// 颜色色块的长度
$(window).on('load', function() {
  $('.grid-product__colors-box .grid-product__colors').each(function(index) {
        var count = $(this).find('.color-swatch').length;
        var currentWidth = count*28; 
        var parentWidth = $(this).parent().parent().parent().width(); 
        var difference = parentWidth - currentWidth; 
        // 检查父级的父级下的 .next-color 是否是 display: none
        var nextColorVisible = $(this).parent().parent().find('.next-color');

        if (difference <= 0) {
            nextColorVisible.css('display','flex')
        }else{
                
        }

    });
  
})
